(function() {
  'use strict';

  angular
    .module('app', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ui.router', 'ui.bootstrap', 'ui.mask', 'ngIdle'])
    .run(initializeXsrf);

  /** @ngInject */
  function initializeXsrf($http) {
    // Making a simple GET request triggers the backend to set the XSRF-TOKEN cookie
    // Use an endpoint that doesn't require authentication, like a version info or heartbeat check
	$http.get('/api/xauth?v=' + new Date().getTime()).then(function() {
      console.log('XSRF-TOKEN should now be set in cookies');
    });
  }

})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('Signup2Controller', Signup2Controller);

  Signup2Controller.$inject = ['$scope', 'userFactory'];

  function Signup2Controller($scope, userFactory) {
    var vm = this;

    vm.email = userFactory.getEmail();
    vm.fieldRequired = 'This field is required.';


    vm.signup = function () {
      vm.closeAlert();
      vm.masterId = userFactory.getId();
      vm.checkValidation('email');
      vm.checkValidation('password');
      vm.checkValidation('password2');
      if (vm.masterId === -1)
        vm.alertMessage = 'There was an error in creating your account. Please restart the registration process from the beginning.';
      vm.alertType = 'danger';
      if (vm.formValidated && vm.masterId !== -1) {
        userFactory.userCreate(vm.email, vm.password, vm.masterId)
                .success(function (customerStatus) {
                  vm.alertMessage = 'Congratulations! An email has been sent to complete the activation of your account.';
                  vm.alertType = 'success';
                })
                .error(function (error) {
                  if (error)
                    vm.alertMessage = error.message;
                  else
                    vm.alertMessage = 'An unknown error has occurred.';
                  vm.alertType = 'danger';
                });
      }
    };

    vm.checkValidation = function (field) {
      if (field === 'email') {
        if (vm.email) {
          vm.emailInvalid = null;
          if (!vm.email.match(/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$)/)) {
            vm.emailInvalid = 'Please enter a valid email.';
          }
        } else {
          vm.emailInvalid = vm.fieldRequired;
        }
      }
      if (field === 'password') {
        vm.passwordInvalid = [];
        if (vm.password) {
          if (!vm.password.match(/\d/)) {
            vm.passwordInvalid.push('Must include at least 1 number.');
          }
          if (!vm.password.match(/[a-z]/)) {
            vm.passwordInvalid.push('Must include at least 1 lowercase letter.');
          }
          if (!vm.password.match(/[A-Z]/)) {
            vm.passwordInvalid.push('Must include at least 1 uppercase letter.');
          }
          if (!vm.password.match(/[\!\@\#\$\%\^\&\*\(\)\[\]\{\}]/)) {
            vm.passwordInvalid.push('Must include one of !@#$%^&*()[]{}.');
          }
          if (!vm.password.match(/(^.{14,}$)/)) {
            vm.passwordInvalid.push('Must be a at least 14 characters long.');
          }
        } else {
          vm.passwordInvalid.push(vm.fieldRequired);
        }
        if (vm.passwordInvalid.length === 0) {
          vm.passwordInvalid = null;
        }
      }
      if (field === 'password2') {
        if (vm.password2) {
          vm.password2Invalid = null;
          if (vm.password !== vm.password2) {
            vm.password2Invalid = 'Your passwords do not match.';
          }
        } else {
          vm.password2Invalid = vm.fieldRequired;
        }
      }
      vm.formValidated = !(vm.emailInvalid || vm.passwordInvalid || vm.password2Invalid);
    };

    vm.closeAlert = function () {
      vm.alertMessage = '';
    };

  }
})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('SignupController', SignupController);

  SignupController.$inject = ['$scope', 'userFactory', '$state'];

  function SignupController($scope, userFactory, $state) {
    var vm = this;

    vm.birthDate = {};
    vm.fieldRequired = 'This field is required.';
    vm.fieldsRequired = 'These fields are required.';
    vm.lettersOnly = 'This field may only contain letters.';
    vm.numbersOnly = 'This field may only contain numbers.';
    vm.zipLength = 'This field must be five characters long.';
    vm.monthLength = 'Month must be two characters long.';
    vm.dayLength = 'Day must be two characters long.';
    vm.yearLength = 'Year must be four characters long.';
    vm.monthValid = 'Please select a valid month.';
    vm.dayValid = 'Please select a valid day.';
    vm.yearValid = 'Please select a valid year.';
    vm.tosValid = 'You must accept Terms of Use and Code of Conduct.';
    vm.currentDate = new Date();
    vm.formValidated = false;
    vm.fieldList = ['firstName', 'lastName', 'month', 'day', 'year', 'zip', 'tos'];

    vm.signup = function () {
      vm.closeAlert();
      for (var x in vm.fieldList) {
        vm.checkValidation(vm.fieldList[x]);
      }
      if (vm.formValidated) {
        // TODO: Ask David about the following line.
        vm.birthDateString = vm.birthDate.year + '-' + (vm.birthDate.month.length === 1 ? '0' + vm.birthDate.month : vm.birthDate.month) + '-' + (vm.birthDate.day.length === 1 ? '0' + vm.birthDate.day : vm.birthDate.day);
        userFactory.register(vm.firstName, vm.lastName, vm.birthDateString, vm.zipCode)
          .success(function (customerStatus) {
            customerStatus = angular.fromJson(customerStatus);
            vm.alertMessage = customerStatus.email;
            if (customerStatus.email !== 'null') {
              userFactory.setEmail(customerStatus.email);
            } else {
              userFactory.setEmail(null);
            }
            userFactory.setId(customerStatus.id);
            vm.alertType = 'success';
            $state.go('signup2');
          })
          .error(function (error) {
            if (error) vm.alertMessage = error.message;
            else vm.alertMessage = 'An unknown error has occurred.';
            vm.alertType = 'danger';
          });
      } else {
        vm.alertType = 'danger';
        //vm.alertMessage = 'Please fill out all of the fields correctly.';
      }
    };

    vm.testForms = function () {
      vm.firstName = 'Kenneth';
      vm.lastName = 'Urban';
      vm.birthDate.month = '11';
      vm.birthDate.day = '05';
      vm.birthDate.year = '1950';
      vm.zipCode = '34996';
    };

    vm.testForms2 = function () {
      vm.firstName = 'John';
      vm.lastName = 'Pahl';
      vm.birthDate.month = '11';
      vm.birthDate.day = '20';
      vm.birthDate.year = '1960';
      vm.zipCode = '37014';
    };

    // checks validation for various fields
    // field args - 'firstName', 'lastName', 'month', 'day', 'year', 'zip'
    vm.checkValidation = function (field) {
      if (field === 'zip') {
        if (vm.zipCode) {
          vm.zipInvalid = null;
          if (vm.zipCode.length > 5 || vm.zipCode.length < 5) {
            vm.zipInvalid = vm.zipLength;
          }
          if (!vm.zipCode.match(/(^\d+$)/)) {
            vm.zipInvalid = vm.numbersOnly;
          }
        } else {
          vm.zipInvalid = vm.fieldRequired;
        }
      }
      if (field === 'firstName') {
        if (vm.firstName) {
          vm.firstInvalid = null;
        } else {
          vm.firstInvalid = vm.fieldRequired;
        }
      }
      if (field === 'lastName') {
        if (vm.lastName) {
          vm.lastInvalid = null;
        } else {
          vm.lastInvalid = vm.fieldRequired
        }

      }
      if (field === 'month') {
        vm.monthInvalid = null;
        if (vm.birthDate.month) {
          if (!vm.birthDate.month.match(/(^\d+$)/)) {
            vm.monthInvalid = vm.numbersOnly;
          }
          if (vm.birthDate.month > 12) {
            vm.monthInvalid = vm.monthValid;
          }
        } else {
          vm.monthInvalid = vm.fieldsRequired;
        }
      }
      if (field === 'day') {
        vm.dayInvalid = null;
        if (vm.birthDate.day) {
          if (!vm.birthDate.day.match(/(^\d+$)/)) {
            vm.dayInvalid = vm.numbersOnly;
          }
          /*if (vm.birthDate.day.length > 2 || vm.birthDate.day.length < 2) {
           vm.dayInvalid = vm.dayLength;
           }*/
          if (vm.birthDate.day < 1 || vm.birthDate.day > 31) {
            vm.dayInvalid = vm.dayValid;
          }
        } else {
          vm.dayInvalid = vm.fieldsRequired;
        }
      }
      if (field === 'year') {
        vm.yearInvalid = null;
        if (vm.birthDate.year) {
          if (!vm.birthDate.year.match(/(^\d+$)/)) {
            vm.yearInvalid = vm.numbersOnly;
          }
          if (vm.birthDate.year.length > 4 || vm.birthDate.year.length < 4) {
            vm.yearInvalid = vm.yearLength;
          }
          if (vm.birthDate.year < 1900 || vm.birthDate.year > vm.currentDate.getFullYear()) {
            vm.yearInvalid = vm.yearValid;
          }
        } else {
          vm.yearInvalid = vm.fieldsRequired;
        }
      }
      if (field === 'tos') {
        if (vm.tos) {
          vm.tosInvalid = null;
        } else {
          vm.tosInvalid = vm.tosValid;
        }
      }
      vm.firstInvalid ? vm.firstFieldError = 'has-error' : vm.firstFieldError = null;
      vm.lastInvalid ? vm.lastFieldError = 'has-error' : vm.lastFieldError = null;
      vm.monthInvalid || vm.dayInvalid || vm.yearInvalid ? vm.dateFieldError = 'has-error' : vm.dateFieldError = null;
      vm.zipInvalid ? vm.zipFieldError = 'has-error' : vm.zipFieldError = null;
      vm.tosInvalid ? vm.tosFieldError = 'has-error' : vm.tosFieldError = null;
      vm.firstInvalid || vm.lastInvalid || vm.monthInvalid || vm.dayInvalid || vm.yearInvalid || vm.zipInvalid || vm.tosInvalid ? vm.formValidated = false : vm.formValidated = true;
    };

    vm.closeAlert = function () {
      vm.alertMessage = '';
    };

  }
})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('ResetController', ResetController);

  ResetController.$inject = ['$scope', 'userFactory', '$stateParams'];

  function ResetController($scope, userFactory, $stateParams) {
    var vm = this;

    vm.token = $stateParams.token;
    vm.fieldRequired = 'This field is required.';

    vm.reset = function () {
      vm.closeAlert();
      vm.checkValidation('password');
      vm.checkValidation('password2');
      if (vm.formValidated) {
        vm.saving = true;
        userFactory.resetPass(vm.token, vm.password)
                .success(function () {
                  vm.alertMessage = 'Password Changed!';
                  vm.alertType = 'success';
                  vm.saving = false;
                })
                .error(function () {
                  vm.alertMessage = 'Password not changed';
                  vm.alertType = 'danger';
                  vm.saving = false;
                });
      }
    };

    vm.closeAlert = function () {
      vm.alertMessage = '';
    };

    vm.checkValidation = function (field) {
      if (field === 'password') {
        vm.passwordInvalid = [];
        if (vm.password) {
          if (!vm.password.match(/\d/)) {
            vm.passwordInvalid.push('Must include at least 1 number.');
          }
          if (!vm.password.match(/[a-z]/)) {
            vm.passwordInvalid.push('Must include at least 1 lowercase letter.');
          }
          if (!vm.password.match(/[A-Z]/)) {
            vm.passwordInvalid.push('Must include at least 1 uppercase letter.');
          }
          if (!vm.password.match(/[\!\@\#\$\%\^\&\*\(\)\[\]\{\}]/)) {
            vm.passwordInvalid.push('Must include one of !@#$%^&*()[]{}.');
          }
          if (!vm.password.match(/(^.{8,}$)/)) {
            vm.passwordInvalid.push('Must be a at least 8 characters long.');
          }
        } else {
          vm.passwordInvalid.push(vm.fieldRequired);
        }
        if (vm.passwordInvalid.length === 0) {
          vm.passwordInvalid = null;
        }
      }
      if (field === 'password2') {
        if (vm.password2) {
          vm.password2Invalid = null;
          if (vm.password !== vm.password2) {
            vm.password2Invalid = 'Your passwords do not match.';
          }
        } else {
          vm.password2Invalid = vm.fieldRequired;
        }
      }
      vm.formValidated = !(vm.passwordInvalid || vm.password2Invalid);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ForgotController', ForgotController);

  ForgotController.$inject = ['$scope', 'userFactory'];

  function ForgotController($scope, userFactory) {
    var vm = this;

    vm.forgot = function() {
      vm.closeAlert();
      vm.checkValidation();
      if (vm.formValidated) {
        userFactory.forgotPass(vm.email)
          .success(function () {
            vm.alertMessage = 'Email Sent!';
            vm.alertType = 'success';
          })
          .error(function () {
            vm.alertMessage = 'Email Not Sent';
            vm.alertType = 'danger';
          });
      }
    };

    vm.checkValidation = function () {
      if (vm.email) {
        vm.invalid = null;
        if (!vm.email.match(/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$)/)) vm.invalid = 'Please enter a valid email address.';
      } else {
        vm.invalid = 'This field is required.';
      }
      vm.invalid ? vm.formValidated = false : vm.formValidated = true;
    };


    vm.closeAlert = function() {
      vm.alertMessage = '';
    };

  }
})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('ProfileController', ProfileController)
          .controller('ModalInstanceController', ModalInstanceController);

  ProfileController.$inject = ['$uibModal', 'userFactory', 'billingFactory', '$cookies', '$timeout', '$rootScope'];
  ModalInstanceController.$inject = ['$scope', 'userFactory', '$modalInstance', 'selected', 'customer'];

  function ProfileController($uibModal, userFactory, billingFactory, $cookies, $timeout, $rootScope) {
    var vm = this;

    vm.isAdmin = userFactory.isAdmin();
    vm.enabledStatus = $cookies.get('customerUserEnabled') === 'true';
    if (!$cookies.get('customerUserEnabled')) {
      vm.notRegistered = true;
    }

    vm.customer = userFactory.getCustomer();
    vm.customerTitle = '';

    vm.address = {
      addressLine1: '',
      addressLine2: null,
      addressLine3: null,
      city: '',
      state: '',
      zipCode: ''
    };

    vm.loginEmail = 'No login email found!';

    vm.email = 'No email found!';

    vm.birthDate = 'No birth date found!';

    vm.homePhone = 'No phone number found!';
    vm.officePhone = 'No phone number found!';
    vm.mobilePhone = 'No phone number found!';

    function loadCustomerInfo() {
      billingFactory.findCustomer()
              .success(function (customer) {
                vm.customer = customer;
                userFactory.setCustomer(vm.customer);
                setInfo();

              })
              .error(function (data) {
                vm.customerName = 'Name not Found';
              });
    }

    function setInfo() {
      vm.customerName = vm.customer.firstName + ' ' + vm.customer.lastName;
      vm.loginEmail = vm.customer.loginEmail;
      vm.emailAddress = vm.customer.emailAddress;
      vm.address = vm.customer.address;
      vm.birthDate = vm.customer.birthDate;
      vm.homePhone = userFactory.phoneFormat(vm.customer.homePhone);
      vm.mobilePhone = userFactory.phoneFormat(vm.customer.mobilePhone);
      vm.officePhone = userFactory.phoneFormat(vm.customer.officePhone);
      vm.membershipCode = '';
      vm.customer.certificates.filter(function (item) {
        if (item.membershipCode) {
          vm.membershipCode = item.membershipCode;
        }
      });
      vm.enabled = 'No';
      if (vm.customer.user != null && vm.customer.user.enabled == true) {
        vm.enabled = "Yes"
      }
    }

    if (!vm.customer || vm.isAdmin) {
      loadCustomerInfo();
    } else {
      setInfo();
    }

    //used for only admin
    vm.activeUser = function (username) {
      userFactory.activateUser(username).success(function () {
        $cookies.put('customerUserEnabled', true);
        vm.enabledStatus = true;
      });
    };

    vm.removePhone = function(label){
      if(confirm('Are you sure you want to remove this phone number?')){
        userFactory.updatePhone({phoneNumber: '0'}, label)
                .then(function(result) {
                  loadCustomerInfo();
                });
      }
    };

    vm.open = function (fieldName, fieldValue) {
      vm.fieldName = fieldName;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'profileModal.html', // needs to be moved to a separate file
        controller: 'ModalInstanceController as vm',
        resolve: {
          selected: function () {
            return {
              name: fieldName,
              value: fieldValue
            };
          },
          customer: function () {
            return vm.customer;
          }
        }
      });

      modalInstance.result.then(function (newInfo) {
        /*if (fieldName === 'Email Address') {
         vm.customer.emailAddress = newInfo;
         vm.emailAddress = newInfo;
         } else if (fieldName === 'Login Email') {
         vm.customer.loginEmail = newInfo;
         vm.loginEmail = newInfo;
         } else if (fieldName === 'Home Phone') {
         vm.customer.homePhone = newInfo;
         vm.homePhone = userFactory.phoneFormat(newInfo);
         } else if (fieldName === 'Office Phone') {
         vm.customer.officePhone = newInfo;
         vm.officePhone = userFactory.phoneFormat(newInfo);
         } else if (fieldName === 'Cell Phone') {
         vm.customer.mobilePhone = newInfo;
         vm.mobilePhone = userFactory.phoneFormat(newInfo);
         } else if (fieldName === 'of Address') {
         vm.customer.address = newInfo;
         vm.address = newInfo;
         }*/
        loadCustomerInfo();
      });
    };

    vm.joinAMA = function(){
      $rootScope.openExternalUrl('https://commerce.ama-assn.org/membership/');
    };

  }

  function ModalInstanceController($scope, userFactory, $modalInstance, selected, customer) {

    var vm = this;

    vm.allStates = userFactory.getStatesList();

    vm.selected = selected;
    vm.fieldRequired = 'This field is required.';
    vm.isPhone = vm.selected.name === 'Home Phone'
            || vm.selected.name === 'Office Phone' || vm.selected.name === 'Cell Phone';
    if (vm.selected.name === 'Home Phone') {
      //vm.isMobilePhone = customer.homeMobile === 'Y';
      //vm.isMarketPhone = customer.marketHome === 'Y';
    } else if (vm.selected.name === 'Office Phone') {
      //vm.isMobilePhone = customer.officeMobile === 'Y';
      //vm.isMarketPhone = customer.marketOffice === 'Y';
    } else if (vm.selected.name === 'Cell Phone') {
      vm.isMobilePhone = true; //always true for cell phone
      //vm.isMarketPhone = customer.marketCell === 'Y';
    }

    vm.checkValidation = function (field) {
      vm.formValidated = false;
      // Email Validations
      if (field === 'Email Address') {
        if (vm.emailAddress) {
          vm.emailAddressInvalid = null;
          if (!vm.emailAddress.match(/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$)/)) {
            vm.emailAddressInvalid = 'Please enter a valid email.';
          } else {
            vm.formValidated = true;
            vm.contactInfo = vm.emailAddress;
          }
        } else {
          vm.emailAddressInvalid = vm.fieldRequired;
        }
      }
      if (field === 'Login Email') {
        if (vm.loginEmail) {
          vm.loginEmailInvalid = null;
          if (!vm.loginEmail.match(/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$)/)) {
            vm.loginEmailInvalid = 'Please enter a valid email.';
          } else {
            vm.formValidated = true;
            vm.contactInfo = vm.loginEmail;
          }
        } else {
          vm.loginEmailInvalid = vm.fieldRequired;
        }
      }

      // Phone Number Validation
      if (vm.isPhone) {
        if (vm.phone) {
          vm.phoneInvalid = null;
          // with ui.mask, this code never gets called; however, the regex may be useful elsewhere
          // if (!vm.contactInfo.match(/(\d-\d{3}-\d{3}-\d{4})|(\d{3}-\d{3}-\d{4})|(\d{11})|(\d{10})/)) vm.contactInfoInvalid = 'Please enter a valid phone number.';
          vm.formValidated = true;
          vm.contactInfo = vm.phone;

        } else {
          vm.phoneInvalid = 'Please enter a valid phone number.';
        }
      }

      // Address Validation (various)
      if (field === 'of Address') {
        vm.checkValidation('addressLine1');
        vm.checkValidation('city');
        vm.checkValidation('state');
        vm.checkValidation('zip');
        vm.addressLine1Invalid || vm.cityInvalid || vm.stateInvalid || vm.zipInvalid ? vm.formValidated = false : vm.formValidated = true;
      }

      // address line validations
      if (field === 'addressLine1') {
        if (vm.addressLine1) {
          vm.addressLine1Invalid = null;
        } else {
          vm.addressLine1Invalid = vm.fieldRequired;
        }
      }

      if (field === 'city') {
        if (vm.city) {
          vm.cityInvalid = null;
          if (!vm.city.match(/[A-Za-z'.\- ]+/g)) {
            vm.cityInvalid = 'Please enter a valid City';
          }
        } else {
          vm.cityInvalid = vm.fieldRequired;
        }
      }

      if (field === 'state') {
        if (vm.state) {
          vm.stateInvalid = null;
          if (!vm.state.match(/[A-Za-z ]+/g)) {
            vm.stateInvalid = 'Please enter a valid State';
          }
        } else {
          vm.stateInvalid = vm.fieldRequired;
        }
      }

      if (field === 'zip') {
        if (vm.zipCode) {
          vm.zipInvalid = null;
          if (vm.zipCode.length > 5 || vm.zipCode.length < 5) {
            vm.zipInvalid = 'This field must be five characters long.';
          }
          if (!vm.zipCode.match(/(^\d+$)/)) {
            vm.zipInvalid = 'This field may only contain numbers.';
          }
        } else {
          vm.zipInvalid = vm.fieldRequired;
        }
      }
    };

    vm.update = function () {
      vm.checkValidation(vm.selected.name);

      if (vm.formValidated) {
        if (vm.selected.name === 'Email Address') {
          userFactory.updateEmailAddress(vm.contactInfo)
                  .then(function successCallback(result) {
                    $modalInstance.close(vm.contactInfo);
                  }, function errorCallback(error) {
                    vm.emailAddressInvalid = error.data.message;
                  });
        }
        if (vm.selected.name === 'Login Email') {
          userFactory.updateLoginEmail(vm.contactInfo)
                  .then(function successCallback(result) {
                    $modalInstance.close(vm.contactInfo);
                  }, function errorCallback(error) {
                    vm.loginEmailInvalid = error.data.message;
                  });
        }
        if (vm.isPhone) {
          var data = {
            phoneNumber: vm.phone,
            isMobile: vm.isMobilePhone,
            isMarket: vm.isMarketPhone
          };
          userFactory.updatePhone(data, vm.selected.name)
                  .then(function successCallback(result) {
                    $modalInstance.close(vm.contactInfo);
                  }, function errorCallback(error) {
                    vm.phoneInvalid = error.data.message;
                  });
        }
        if (vm.selected.name === 'of Address') {
          vm.newAddress = {
            addressLine1: vm.addressLine1,
            city: vm.city,
            state: vm.state,
            zipCode: vm.zipCode
          };
          if (vm.addressLine2)
            vm.newAddress.addressLine2 = vm.addressLine2;
          if (vm.addressLine2 && vm.addressLine3)
            vm.newAddress.addressLine3 = vm.addressLine3;
          userFactory.updateAddress(vm.newAddress)
                  .then(function successCallback(result) {
                    $modalInstance.close(vm.newAddress);
                  }, function errorCallback(error) {
                    vm.addressInvalid = error.data;
                  })
        }
      }
    };

    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

  }

})();

(function () {
  'use strict';

  angular
          .module('app')
          .factory('userFactory', userFactory);

  userFactory.$inject = ['$http', '$cookies', '$rootScope', 'idleFactory'];

  function userFactory($http, $cookies, $rootScope, idleFactory) {
    var _user;
    var _token;
    var _customerEmail = null;
    var _customerId = null;
    var _customer = null;
    var _paymentUrl = '';

    // uses gulp's 'template' function to replace the environment keyword with the proper environment
    //var _serverAddress = '<%= environment %>' + '/api/';
    //var _serverAddress = 'http://localhost:8080/api/'; // Local Host
    //var _serverAddress = 'http://207.97.195.86/api/'; // Dev Server
    //var _serverAddress = 'http://207.97.195.85/api/'; // Test Server
    //var _serverAddress = 'http://207.97.195.81/api/'; // NEW Test Server
    //var _serverAddress = 'http://207.97.195.87/api/'; // NEW Test Cloud Server
    //var _serverAddress = 'https://testmyaccount.amainsure.com/api/'; // NEW Test Cloud Server
    //var _imageAddress = 'https://amainsureut2.hylandcloud.com/203AppNet/docpop/docpop.aspx'; // UAT image server
    var _serverAddress = 'https://myaccount.amainsure.com/api/'; // Production Server
    var _imageAddress = 'https://amainsure.hylandcloud.com/203AppNet/docpop/docpop.aspx'; // PROD image server

    var service = {
      verifyUser: verifyUser,
      verifyPasscode: verifyPasscode,
      resendPasscode: resendPasscode,
      register: register,
      userCreate: userCreate,
      storeUser: storeUser,
      logout: logout,
      loggedIn: loggedIn,
      forgotPass: forgotPass,
      resetPass: resetPass,
      phoneFormat: phoneFormat,
      dateFormat: dateFormat,
      updateEmailAddress: updateEmailAddress,
      updateLoginEmail: updateLoginEmail,
      updatePhone: updatePhone,
      updateAddress: updateAddress,
      getEmail: getEmail,
      setEmail: setEmail,
      getId: getId,
      setId: setId,
      getServerAddress: getServerAddress,
      getImageAddress: getImageAddress,
      getCustomer: getCustomer,
      setCustomer: setCustomer,
      getToken: getToken,
      isAdmin: isAdmin,
      isSuperAdmin: isSuperAdmin,
      isAdminCustomerSet: isAdminCustomerSet,
      setAdminCustomerId: setAdminCustomerId,
      getPaymentUrl: getPaymentUrl,
      activateUser: activateUser,
      getStatesList: getStatesList,   resetCustomer: resetCustomer
    };

    if (loggedIn() === 'logged-in') {
      //load customer info initially
      //loadCustomer();

      //load payment Url
      getPaymentUrl();
    }

    return service;

    // used for signup and login, httpRoute is where the POST is sent
    // if 'user' it goes to signup, if 'authenticate' it handles login
    function verifyUser(username, password, httpRoute) {
      return $http({
        method: 'POST',
        url: _serverAddress + httpRoute,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        // reformats request so that server understands it
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
          }
          return str.join('&');
        },
        data: {
          username: username,
          password: password
        }
      });
    }

    // used for mfa
    function verifyPasscode(passcode, httpRoute) {
      var username = getUsername();
      return $http({
        method: 'POST',
        url: _serverAddress + httpRoute,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        // reformats request so that server understands it
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
          }
          return str.join('&');
        },
        data: {
          username: username,
          passcode: passcode
        }
      });
    }

    function resendPasscode(httpRoute) {
      var username = getUsername();
      return $http({
        method: 'POST',
        url: _serverAddress + httpRoute,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        // reformats request so that server understands it
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
          }
          return str.join('&');
        },
        data: {
          username: username
        }
      });
    }

    function register(firstName, lastName, dateOfBirth, zipCode) {
      return $http({
        method: 'POST',
        url: _serverAddress + 'user',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        // reformats request so that server understands it
        transformRequest: function (object) {
          var strings = [];
          for (var string in object) {
            strings.push(encodeURIComponent(string) + '=' + encodeURIComponent(object[string]));
          }
          return strings.join('&');
        },
        data: {
          firstName: firstName,
          lastName: lastName,
          dateOfBirth: dateOfBirth,
          zipCode: zipCode
        }
      });
    }

    function userCreate(email, password, id) {
      return $http({
        method: 'POST',
        url: _serverAddress + 'user/register',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        // reformats request so that server understands it
        transformRequest: function (object) {
          var strings = [];
          for (var string in object) {
            strings.push(encodeURIComponent(string) + '=' + encodeURIComponent(object[string]));
          }
          return strings.join('&');
        },
        data: {
          email: email,
          password: password,
          id: id
        }
      });
    }

    // puts user object in cookies, updates token
    function storeUser(user, callback) {
      var expireDate = new Date();
      expireDate = new Date(expireDate.getTime() + (30 * 60 * 1000)); // 30 minutes from current time
      user.expireDate = expireDate;
      $cookies.putObject('user', user, {
        expires: expireDate
      });
      _user = $cookies.getObject('user');
      _token = _user.token;
      _customerId = _user.id;
      getPaymentUrl();
      if (callback) {
        callback(user);
      }
    }

    // checks if user is logged in or not, used primarily for styling purposes
    function loggedIn() {
      _user = $cookies.getObject('user');
      if (_user) {
        return 'logged-in';
      } else {
        return 'logged-out';
      }
    }

    function getToken() {
      _user = $cookies.getObject('user');
      if (_user) {
        return _user.token;
      } else {
        return '';
      }
    }

    function getUsername() {
      _user = $cookies.getObject('user');
      if (_user) {
        return _user.name;
      } else {
        return '';
      }
    }
	
    function isAdmin() {
      _user = $cookies.getObject('user');
      return _user && (_user.role === 'ROLE_ADMIN' || _user.role === 'ROLE_SUPER');
    }

    function isSuperAdmin() {
      _user = $cookies.getObject('user');
      return _user && _user.role === 'ROLE_SUPER';
    }

    function forgotPass(email) {
      return $http({
        method: 'POST',
        url: _serverAddress + 'user/forgotPassword',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
          }
          return str.join('&');
        },
        data: {email: email}
      });
    }

    function resetPass(token, password) {
      return $http({
        method: 'POST',
        url: _serverAddress + 'user/resetPassword',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
          }
          return str.join('&');
        },
        data: {
          token: token,
          password: password
        }
      });
    }

    // should be moved to customer factory when it is created
    function phoneFormat(phoneNumber) {
      var formattedNumber = phoneNumber;
      switch (phoneNumber.length) {
        case 11:
          formattedNumber = phoneNumber.substr(0, 1) + '-' + phoneNumber.substr(1, 3) + '-' + phoneNumber.substr(4, 3) + '-' + phoneNumber.substr(7);
          break;
        case 10:
          formattedNumber = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
          break;
        case 7:
          formattedNumber = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3);
          break;
        case 0:
        case 1:
          formattedNumber = '';
          break;
        default:
          formattedNumber = 'Phone number is not formatted correctly';
      }
      return formattedNumber;
    }

    function dateFormat(date) {
      var formattedDate = date;
      if (date.match(/(\d{4})(-\d{2}){2}/)) {
        formattedDate = date.substr(5, 2) + '/' + date.substr(8, 2) + '/' + date.substr(0, 4);
      } else {
        formattedDate = 'date is not formatted correctly: ' + date;
      }
      return formattedDate;
    }

    function updateEmailAddress(email) {
      return $http({
        method: 'PUT',
        url: _serverAddress + 'customer/' + getId(),
        data: {
          "emailAddress": email
        }
      })
    }

    // TODO: this function should also update the user cookie
    function updateLoginEmail(email) {
      return $http({
        method: 'PUT',
        url: _serverAddress + 'customer/' + getId(),
        data: {
          "loginEmail": email
        }
      }).then(function successCallback() {
        var userObject = $cookies.getObject('user');
        userObject.name = email;
        $cookies.putObject('user', userObject, {
          expires: userObject.expireDate
        });
      });
    }

    function updatePhone(data, fieldLabel) {
      var sendData = {};
      var mobileStr = data.isMobile ? 'Y' : 'N';
      var marketStr = data.isMarket ? 'Y' : 'N';
      if (!data.isMobile) {
        marketStr = 'D';
      }
      if (data.phoneNumber === '0' || data.phoneNumber === 0) {
        mobileStr = '';
        marketStr = '';
      }
      if (fieldLabel === 'Home Phone') {
        sendData.homePhone = data.phoneNumber;
        sendData.homeMobile = mobileStr;
        sendData.marketHome = marketStr;
      } else if (fieldLabel === 'Office Phone') {
        sendData.officePhone = data.phoneNumber;
        sendData.officeMobile = mobileStr;
        sendData.marketOffice = marketStr;
      } else if (fieldLabel === 'Cell Phone') {
        sendData.mobilePhone = data.phoneNumber;
        sendData.cellMobile = mobileStr;
        sendData.marketCell = marketStr;
      }
      return $http({
        method: 'PUT',
        url: _serverAddress + 'customer/' + getId(),
        data: sendData
      });
    }

    function updateAddress(address) {
      return $http({
        method: 'PUT',
        url: _serverAddress + 'customer/' + getId(),
        data: {
          "address": address
        }
      });
    }

    function activateUser(username) {
      return $http({
        method: 'PUT',
        url: _serverAddress + 'user/enable',
        data: {
          "username": username
        }
      });
    }

    function resetCustomer() { 	_customer = getCustomer(); 	return $http({ 		method: 'POST', 		url: _serverAddress + 'utility/reset/' + _customer.masterId, transformResponse: function (response) { return response; }       }).then(function (response) { 		alert(response.data); 	});
    }

    // logs user out, including clearing token on server and deletes user cookie
    function logout() {
      // gets user's token from cookies, if no cookie, _token will be blank and server will return 403
      if ($cookies.getObject('user')) {
        _token = $cookies.getObject('user').token;
      } else {
        _token = 'error';
      }
      $http({
        method: 'POST',
        url: _serverAddress + 'doLogout',
        transformResponse: function (data) {
          return data;
        }
      }).finally(function () {
        $cookies.remove('user');
        idleFactory.clearIdle();
      });
      _token = null;
      _customerId = null;
      _customer = null;
      $rootScope.$broadcast('user-logged-out');
    }

    // gets _customerEmail
    function getEmail() {
      return _customerEmail;
    }

    function setEmail(email) {
      _customerEmail = email;
    }

    function setAdminCustomerId(id, customerUser) {
      var tempUser = $cookies.getObject('user');
      tempUser.id = id;
      if (id === -1 || !customerUser) {
        $cookies.remove('customerUserEnabled');
      } else {
        $cookies.put('customerUserEnabled', customerUser.enabled);
      }
      // set up expire time for cookie
      // TODO: move expire set up to a reusable function, perhaps disable timer for admin and super-admin
      var expireDate = new Date();
      expireDate = new Date(expireDate.getTime() + (120 * 60 * 1000));
      $cookies.putObject('user', tempUser, {
        expires: expireDate
      });
      _customerId = id;
    }

    function isAdminCustomerSet() {
      return ($cookies.getObject('user') && $cookies.getObject('user').id !== -1);
    }

    function getId() {
      if (!_customerId) {
        if ($cookies.getObject('user')) {
          _customerId = $cookies.getObject('user').id;
        } else {
          _customerId = -1;
        }
      }
      return _customerId;
    }

    function setId(id) {
      _customerId = id;
    }

    function getServerAddress() {
      return _serverAddress;
    }

    function getImageAddress() {
      return _imageAddress;
    }

    // TODO: Create customerFactory and move these there
    function getCustomer() {
      return _customer;
    }

    function loadCustomer() {
      var customerId = getId();
      if (customerId && customerId !== -1) { 	console.log("loading customer from user factory id="+customerId);
        $http({
          method: 'GET',
          url: _serverAddress + 'customer/' + customerId
        }).then(function (response) {
          _customer = response.data;
        });
      }
    }

    function setCustomer(customer) {
      _customer = customer;
      _customerId = customer !== null ? customer.id : null;
    }

    function getPaymentUrl() {
      if (!_paymentUrl) {
        $http({
          method: 'GET',
          url: _serverAddress + 'paymentUrl',
          transformResponse: function (response) {
            return response;
          }
        }).then(function (response) {
          _paymentUrl = response.data;
        });
      }
      return _paymentUrl;
    }

    function getStatesList() {
      return [
        {
          "id": "AA",
          "name": "Armed Forces Americas"
        },
        {
          "id": "AE",
          "name": "Armed Forces Africa, Canada, Europe, Middle East"
        },
        {
          "id": "AK",
          "name": "Alaska"
        },
        {
          "id": "AL",
          "name": "Alabama"
        },
        {
          "id": "AP",
          "name": "Armed Forces Pacific"
        },
        {
          "id": "AR",
          "name": "Arkansas"
        },
        {
          "id": "AZ",
          "name": "Arizona"
        },
        {
          "id": "CA",
          "name": "California"
        },
        {
          "id": "CO",
          "name": "Colorado"
        },
        {
          "id": "CT",
          "name": "Connecticut"
        },
        {
          "id": "DC",
          "name": "District Of Columbia"
        },
        {
          "id": "DE",
          "name": "Delaware"
        },
        {
          "id": "FL",
          "name": "Florida"
        },
        {
          "id": "GA",
          "name": "Georgia"
        },
        {
          "id": "GU",
          "name": "Guam"
        },
        {
          "id": "HI",
          "name": "Hawaii"
        },
        {
          "id": "IA",
          "name": "Iowa"
        },
        {
          "id": "ID",
          "name": "Idaho"
        },
        {
          "id": "IL",
          "name": "Illinois"
        },
        {
          "id": "IN",
          "name": "Indiana"
        },
        {
          "id": "KS",
          "name": "Kansas"
        },
        {
          "id": "KY",
          "name": "Kentucky"
        },
        {
          "id": "LA",
          "name": "Louisiana"
        },
        {
          "id": "MA",
          "name": "Massachusetts"
        },
        {
          "id": "MD",
          "name": "Maryland"
        },
        {
          "id": "ME",
          "name": "Maine"
        },
        {
          "id": "MI",
          "name": "Michigan"
        },
        {
          "id": "MN",
          "name": "Minnesota"
        },
        {
          "id": "MO",
          "name": "Missouri"
        },
        {
          "id": "MS",
          "name": "Mississippi"
        },
        {
          "id": "MT",
          "name": "Montana"
        },
        {
          "id": "NC",
          "name": "North Carolina"
        },
        {
          "id": "ND",
          "name": "North Dakota"
        },
        {
          "id": "NE",
          "name": "Nebraska"
        },
        {
          "id": "NH",
          "name": "New Hampshire"
        },
        {
          "id": "NJ",
          "name": "New Jersey"
        },
        {
          "id": "NM",
          "name": "New Mexico"
        },
        {
          "id": "NV",
          "name": "Nevada"
        },
        {
          "id": "NY",
          "name": "New York"
        },
        {
          "id": "OH",
          "name": "Ohio"
        },
        {
          "id": "OK",
          "name": "Oklahoma"
        },
        {
          "id": "OR",
          "name": "Oregon"
        },
        {
          "id": "PA",
          "name": "Pennsylvania"
        },
        {
          "id": "PR",
          "name": "Puerto Rico"
        },
        {
          "id": "RI",
          "name": "Rhode Island"
        },
        {
          "id": "SC",
          "name": "South Carolina"
        },
        {
          "id": "SD",
          "name": "South Dakota"
        },
        {
          "id": "TN",
          "name": "Tennessee"
        },
        {
          "id": "TX",
          "name": "Texas"
        },
        {
          "id": "UT",
          "name": "Utah"
        },
        {
          "id": "VA",
          "name": "Virginia"
        },
        {
          "id": "VI",
          "name": "Virgin Islands"
        },
        {
          "id": "VT",
          "name": "Vermont"
        },
        {
          "id": "WA",
          "name": "Washington"
        },
        {
          "id": "WI",
          "name": "Wisconsin"
        },
        {
          "id": "WV",
          "name": "West Virginia"
        },
        {
          "id": "WY",
          "name": "Wyoming"
        },
        {
          "id": "ZZ",
          "name": "Foreign Countries"
        }
      ];
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LogoutController', LogoutController);

  LogoutController.$inject = ['$scope', 'userFactory', '$state', '$stateParams', 'claimsFactory'];

  function LogoutController($scope, userFactory, $state, $stateParams, claimsFactory) {
    var vm = this;
    userFactory.logout();
    claimsFactory.clearClaims();
    $state.transitionTo('login', $stateParams, {
      reload: true,
      inherit: false,
      notify: true
    });
  }



})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['$scope', 'userFactory', '$state', '$log', '$rootScope', 'idleFactory'];

  function LoginController($scope, userFactory, $state, $log, $rootScope, idleFactory) {
    var vm = this;

    // default validation error messages
    vm.fieldRequired = 'This field is required.';
    vm.fieldsRequired = 'These fields are required.';
    vm.lettersOnly = 'This field may only contain letters.';
    vm.numbersOnly = 'This field may only contain numbers.';
    vm.zipLength = 'This field must be five characters long.';
    vm.monthLength = 'Month must be two characters long.';
    vm.dayLength = 'Day must be two characters long.';
    vm.yearLength = 'Year must be four characters long.';
    vm.monthValid = 'Please select a valid month.';
    vm.dayValid = 'Please select a valid day.';
    vm.yearValid = 'Please select a valid year.';
    vm.tosValid = 'You must accept Terms of Use and Code of Conduct.';
    vm.loginFormValidated = false;
    vm.signupFormValidated = false;

    // start-up variables
    vm.activeTab = 'login';
    vm.currentDate = new Date();
    vm.fieldList = ['firstName', 'lastName', 'month', 'day', 'year', 'zip', 'tos'];
    vm.birthDate = {};


    // login function
    vm.login = function() {
      vm.closeAlert();
      vm.checkLoginValidation('email');
      vm.checkLoginValidation('password');
      if (vm.loginFormValidated) {
        userFactory.verifyUser(vm.username, vm.password, 'authenticate')
          .success(function (user) {
            vm.loginAlertMessage = 'Logged In:';
            vm.token = user.token;
            vm.alertType = 'success';
            userFactory.storeUser(user, function () {
				$state.go('mfa');				  
                /*if (userFactory.isAdmin()) {
                  $state.go('select-customer');
                } else if (userFactory.isSuperAdmin()) {
                  $state.go('manage-admin')
                } else {
                  idleFactory.setIdle();
                  $state.go('home');
                }*/
                $rootScope.$broadcast('user-logged-in', user);
            });
          })
          .error(function (error) {
            vm.loginAlertMessage = error.message;
            vm.token = '';
            vm.alertType = 'danger';
          });
      }
    };

    // signup function
    vm.signup = function () {
      vm.closeAlert();
      for (var x in vm.fieldList) {
        vm.checkSignupValidation(vm.fieldList[x]);
      }
      if (vm.signupFormValidated) {
        // TODO: Ask David about the following line.
        vm.birthDateString = vm.birthDate.year + '-' + (vm.birthDate.month.length === 1 ? '0' + vm.birthDate.month : vm.birthDate.month) + '-' + (vm.birthDate.day.length === 1 ? '0' + vm.birthDate.day : vm.birthDate.day);
        userFactory.register(vm.firstName, vm.lastName, vm.birthDateString, vm.zipCode)
          .success(function (customerStatus) {
            customerStatus = angular.fromJson(customerStatus);
            vm.signupAlertMessage = customerStatus.email;
            if (customerStatus.email !== 'null') {
              userFactory.setEmail(customerStatus.email);
            } else {
              userFactory.setEmail(null);
            }
            userFactory.setId(customerStatus.id);
            vm.alertType = 'success';
            $state.go('signup2');
          })
          .error(function (error) {
            if (error) vm.signupAlertMessage = error.message;
            else vm.signupAlertMessage = 'An unknown error has occurred.';
            vm.alertType = 'danger';
          });
      } else {
        vm.alertType = 'danger';
        //vm.signupAlertMessage = 'Please fill out all of the fields correctly.';
      }
    };

    vm.checkLoginValidation = function(field) {
      if (field === 'email') {
        if (vm.username) {
          vm.emailInvalid = null;
          if (!vm.username.match(/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$)/)) {
            vm.emailInvalid = 'This is not a valid email.';
          }
        } else {
          vm.emailInvalid = vm.fieldRequired;
        }
      }
      if (field === 'password') {
        if (vm.password) {
          vm.passwordInvalid = null;
        } else {
          vm.passwordInvalid = vm.fieldRequired;
        }
      }
      vm.emailInvalid || vm.passwordInvalid ? vm.loginFormValidated = false : vm.loginFormValidated = true;
    };

    vm.checkSignupValidation = function (field) {
      if (field === 'zip') {
        if (vm.zipCode) {
          vm.zipInvalid = null;
          if (vm.zipCode.length > 5 || vm.zipCode.length < 5) {
            vm.zipInvalid = vm.zipLength;
          }
          if (!vm.zipCode.match(/(^\d+$)/)) {
            vm.zipInvalid = vm.numbersOnly;
          }
        } else {
          vm.zipInvalid = vm.fieldRequired;
        }
      }
      if (field === 'firstName') {
        if (vm.firstName) {
          vm.firstInvalid = null;
        } else {
          vm.firstInvalid = vm.fieldRequired;
        }
      }
      if (field === 'lastName') {
        if (vm.lastName) {
          vm.lastInvalid = null;
        } else {
          vm.lastInvalid = vm.fieldRequired
        }

      }
      if (field === 'month') {
        vm.monthInvalid = null;
        if (vm.birthDate.month) {
          if (!vm.birthDate.month.match(/(^\d+$)/)) {
            vm.monthInvalid = vm.numbersOnly;
          }
          if (vm.birthDate.month > 12) {
            vm.monthInvalid = vm.monthValid;
          }
        } else {
          vm.monthInvalid = vm.fieldsRequired;
        }
      }
      if (field === 'day') {
        vm.dayInvalid = null;
        if (vm.birthDate.day) {
          if (!vm.birthDate.day.match(/(^\d+$)/)) {
            vm.dayInvalid = vm.numbersOnly;
          }
          /*if (vm.birthDate.day.length > 2 || vm.birthDate.day.length < 2) {
           vm.dayInvalid = vm.dayLength;
           }*/
          if (vm.birthDate.day < 1 || vm.birthDate.day > 31) {
            vm.dayInvalid = vm.dayValid;
          }
        } else {
          vm.dayInvalid = vm.fieldsRequired;
        }
      }
      if (field === 'year') {
        vm.yearInvalid = null;
        if (vm.birthDate.year) {
          if (!vm.birthDate.year.match(/(^\d+$)/)) {
            vm.yearInvalid = vm.numbersOnly;
          }
          if (vm.birthDate.year.length > 4 || vm.birthDate.year.length < 4) {
            vm.yearInvalid = vm.yearLength;
          }
          if (vm.birthDate.year < 1900 || vm.birthDate.year > vm.currentDate.getFullYear()) {
            vm.yearInvalid = vm.yearValid;
          }
        } else {
          vm.yearInvalid = vm.fieldsRequired;
        }
      }
      if (field === 'tos') {
        if (vm.tos) {
          vm.tosInvalid = null;
        } else {
          vm.tosInvalid = vm.tosValid;
        }
      }
      vm.firstInvalid ? vm.firstFieldError = 'has-error' : vm.firstFieldError = null;
      vm.lastInvalid ? vm.lastFieldError = 'has-error' : vm.lastFieldError = null;
      vm.monthInvalid || vm.dayInvalid || vm.yearInvalid ? vm.dateFieldError = 'has-error' : vm.dateFieldError = null;
      vm.zipInvalid ? vm.zipFieldError = 'has-error' : vm.zipFieldError = null;
      vm.tosInvalid ? vm.tosFieldError = 'has-error' : vm.tosFieldError = null;
      vm.firstInvalid || vm.lastInvalid || vm.monthInvalid || vm.dayInvalid || vm.yearInvalid || vm.zipInvalid || vm.tosInvalid ? vm.signupFormValidated = false : vm.signupFormValidated = true;
    };

    vm.closeAlert = function() {
      vm.loginAlertMessage = '';
      vm.signupAlertMessage = '';
    };

  }
})();

'use strict';

angular.module('app').controller('PrivacyController', function () {
  var vm = this;
});

(function () {
  'use strict';

  angular
    .module('app')
    .directive('mainNavbar', mainNavbar);

  mainNavbar.$inject = ['$cookies', 'userFactory', '$rootScope', '$state', '$location', 'billingFactory', 'claimsFactory'];

  function mainNavbar($cookies, userFactory, $rootScope, $state, $location, billingFactory, claimsFactory) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;


    function NavbarController() {
      var vm = this;

      vm.user = $cookies.getObject('user');
      
      $rootScope.$on('user-logged-in', function (e, userInfo) {
        vm.user = userInfo;
        vm.isSuperAdmin = userFactory.isSuperAdmin();
        vm.isAdmin = userFactory.isAdmin();
      });

      vm.isSuperAdmin = userFactory.isSuperAdmin();
      vm.isAdmin = userFactory.isAdmin();
      vm.isAdminCustomerSet = userFactory.isAdminCustomerSet();

      vm.endCustomerSession = function () {
        userFactory.setAdminCustomerId(-1);
        userFactory.setCustomer(null);
		claimsFactory.clearClaims();
        $state.go('select-customer');
      };

      vm.resetCustomer = function () {
         userFactory.resetCustomer();
      };

      $rootScope.$watch(function () {
        return userFactory.isAdminCustomerSet();
      }, function () {
        vm.isAdminCustomerSet = userFactory.isAdminCustomerSet();
      });

      vm.locationPath = function(path){
        $location.path(path);
      };

      vm.getUserText = function (user) {
        if (user) {
          if (vm.isAdmin) {
            return user.name;
          }
          if (user.title && (user.title === 'MD' || user.title === 'DO')) {
            return 'Dr. ' + user.lastName;
          } else {
            return user.firstName + ' ' + user.lastName;
          }
        }
      };

      vm.userNavCollapsed = true;
      vm.topNavCollapsed = true;
      vm.toggleUserNav = function () {
        vm.userNavCollapsed = !vm.userNavCollapsed;
        if (!vm.userNavCollapsed) {
          vm.topNavCollapsed = true;
        }
      };

      vm.toggleTopNav = function () {
        vm.topNavCollapsed = !vm.topNavCollapsed;
        if (!vm.topNavCollapsed) {
          vm.userNavCollapsed = true;
        }
      };

      vm.isState = function (stateName) {
        return $state.includes(stateName);
      };

      var notUserNavStates = ['login', 'logout', 'reset', 'forgot', 'forbidden', 'activation', '404'];
      $rootScope.$on('$stateChangeSuccess', function (e, current) {
        vm.isShowUserNav = vm.user && notUserNavStates.indexOf(current.name) === -1;
      });

      vm.isLoggedIn = function () {
        return userFactory.loggedIn() === 'logged-in';
      };

      vm.navButtons = {
        signUpLink: function () {
          if (userFactory.loggedIn() === 'logged-in') {
            return '/logout/';
          } else {
            return '/register/';
          }
        },
        signUpText: function () {
          if (userFactory.loggedIn() === 'logged-in') {
            return 'Log Out';
          } else {
            return 'Register';
          }
        },
        loginLink: function () {
          if (userFactory.loggedIn() === 'logged-in') {
            return null;
          } else {
            return '/user/login/';
          }
        },
        loginText: function () {
          if (vm.isLoggedIn()) {
            return null;
          } else {
            return 'My Account'
          }
        }
      };

      vm.logout = function () {
        if (vm.user) {
          $cookies.remove('user');
          vm.accountStatus = 'Sign Up / Log In';
          vm.accountStatusLink = '/user/';
        }
      };
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PasscodeController', PasscodeController);

  PasscodeController.$inject = ['$scope', 'userFactory', '$state', '$log', '$rootScope', 'idleFactory', '$timeout'];

  function PasscodeController($scope, userFactory, $state, $log, $rootScope, idleFactory, $timeout) {
    
    var vm = this;

    // default validation error messages
    vm.fieldRequired = 'A passcode is required.';
    vm.numbersOnly = 'The passcode may only contain numbers.';
    vm.passcodeLength = 'The passcode must be six characters long.';
    vm.passcodeNoMatch = 'The passcode entered is not valid. Please enter a valid passcode.';
    vm.passcodeFormValidated = false;

    // start-up variables
    vm.fieldList = ['passcode'];

    vm.isResendDisabled = true; // Start disabled
    $timeout(function() {
        vm.isResendDisabled = false; // Use $timeout to trigger Angular's digest cycle
    }, 2000);

    // mfa function
    vm.isVerifyingMfa = false;
    vm.mfa = function() {
      if (vm.isVerifyingMfa) return; // exit if already processing
      vm.isVerifyingMfa = true;
      vm.closeAlert();
      console.log("validating passcode form");
      vm.checkPasscodeValidation('passcode');
      console.log("passcode form valid? " + vm.passcodeFormValidated);
      if (vm.passcodeFormValidated) {
        console.log("invoking user factory to verify passcode");
        userFactory.verifyPasscode(vm.passcode, 'mfa')
          .success(function (passcodeVerified) {
			if (passcodeVerified) {
                if (userFactory.isAdmin()) {
                    $state.go('select-customer');
                } else if (userFactory.isSuperAdmin()) {
                    $state.go('manage-admin')
                } else {
                    idleFactory.setIdle();
                    $state.go('home');
                }			
			} else {
                vm.passcodeAlertMessage = vm.passcodeNoMatch;
                vm.token = '';
                vm.alertType = 'danger';				
            }
            vm.isVerifyingMfa = false;
          })
          .error(function (error) {
            vm.passcodeAlertMessage = error.message;
            vm.token = '';
            vm.alertType = 'danger';
			vm.isVerifyingMfa = false;
          });
      } else {
         vm.isVerifyingMfa = false;
      }
    };

    // send a new passcode function
	// renamed to confuse mobile chrome auto trigger
	vm.resendIt = function() {
        console.log("regenerating new passcode");
        userFactory.resendPasscode('mfa/otp')
          .success(function () {
            vm.passcodeAlertMessage = "A new passcode has been sent.";
            vm.token = '';
            vm.alertType = 'info';
          })
          .error(function (error) {
            vm.passcodeAlertMessage = error.message;
            vm.token = '';
            vm.alertType = 'danger';
          });	
    };

    vm.checkPasscodeValidation = function(field) {
      console.log("field="+field);
      console.log("vm.passcode="+vm.passcode);
      if (field === 'passcode') {
        if (vm.passcode) {
          if (vm.passcode.length != 6) {
            vm.passcodeInvalid = vm.passcodeLength;
          }
          if (!vm.passcode.match(/(^\d+$)/)) {
            vm.passcodeInvalid = vm.numbersOnly;
          }
        } else {
          vm.passcodeInvalid = vm.fieldRequired;        
        }
      }
      console.log("vm.passcodeInvalid="+vm.passcodeInvalid);
      vm.passcodeInvalid ? vm.passcodeFormValidated = false : vm.passcodeFormValidated = true;
      console.log("vm.passcodeFormValidated="+vm.passcodeFormValidated);
    };

    vm.closeAlert = function() {
      vm.passcodeAlertMessage = '';
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('idleFactory', idleFactory);

  idleFactory.$inject = ['$rootScope', 'Idle', '$uibModal', '$uibModalStack', '$state', 'Keepalive', '$cookies'];

  function idleFactory($rootScope, Idle, $uibModal, $uibModalStack, $state, Keepalive, $cookies) {
    var _idleStartCleanup;
    var _idleTimeoutCleanup;
    var _keepaliveCleanup;

    var service = {
      setIdle: setIdle,
      clearIdle: clearIdle
    };

    return service;

    function setIdle() {
      _idleStartCleanup = $rootScope.$on('IdleStart', idleCallback);
      _idleTimeoutCleanup = $rootScope.$on('IdleTimeout', timeoutUser);
      _keepaliveCleanup = $rootScope.$on('Keepalive', refreshSession);

      Keepalive.start();
      Keepalive.setInterval(10 * 60); // 10 minutes

      Idle.watch();
    }

    function clearIdle() {
      if (_idleStartCleanup && _idleTimeoutCleanup) {
        _idleStartCleanup();
        _idleTimeoutCleanup();
        _keepaliveCleanup();
      }
      Idle.unwatch();
      Keepalive.stop();
    }

    function idleCallback() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: '../app/components/idle/idleModal.html',
        controller: 'IdleModalController as vm'
      });
    }

    function timeoutUser() {
      $uibModalStack.dismissAll();
      $state.go('logout');
    }

    function refreshSession() {
      var expireDate = new Date();
      expireDate = new Date(expireDate.getTime() + (30 * 60 * 1000)); // 30 minutes from current time
      var user = $cookies.getObject('user');
      user.expireDate = expireDate;
      $cookies.putObject('user', user, {
        expires: expireDate
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('IdleModalController', IdleModalController);

  IdleModalController.$inject = ['$uibModalInstance'];

  function IdleModalController($uibModalInstance) {
    var vm = this;

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }

})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('HomeController', HomeController)
          .controller('BillingAlertModalController', BillingAlertModalController);


  HomeController.$inject = ['$scope', '$uibModal', 'coverageFactory', '$location', 'userFactory', '$cookies', '$window', '$http'];
  BillingAlertModalController.$inject = ['$uibModalInstance', 'coverages'];

  function HomeController($scope, $uibModal, coverageFactory, $location, userFactory, $cookies, $window, $http) {

    var vm = this;
    var coverages = coverageFactory.getItems();
    var user = $cookies.getObject('user');
    if (!userFactory.isAdmin()) {
      vm.customerFullName = user.firstName + ' ' + user.lastName;
    }

    vm.buttonOptions = [
      'Make a Payment',
      'View Coverage Details',
      'Change Address, Email, or Telephone Number',
      'Change Banking Information',
      'Contact Us'
    ];

    vm.coverageSections = {};

    vm.status = {
      isopen: false
    };

    vm.toggled = function (open) {
      console.log('Dropdown is now: ', open);
    };

    vm.toggleDropdown = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      vm.status.isopen = !vm.status.isopen;
    };

    vm.getCoverageIcon = function (coverage) {
      return coverageFactory.getTypeIcon(coverage);
    };

    vm.dropdownAction = function (index, coverage) {
      switch (index) {
        case 0:
          $location.path('/billing/');
          break;
        case 1:
          $location.url('/coverage/?status=' + coverage.status + '&id=' + coverage.id);
          break;
        case 2:
          $location.url('/profile/');
          break;
        case 3:
          //$location.url('/billing/?tab=payment_options');
          $window.open('https://powerforms.docusign.net/076e3c54-ce10-4378-93c8-cd71f2519a98?env=na2&acct=c5863cfc-a54c-440c-9d43-463d4e81dec8&accountId=c5863cfc-a54c-440c-9d43-463d4e81dec8', '_blank');
          break;
        case 4:
          $location.url('/contact-us/?number=' + coverage.certificateNumber);
          break;
      }
    };

    vm.showBillingAlerts = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/home/billing_alert_modal.html',
        controller: 'BillingAlertModalController as vm',
        resolve: {
          coverages: function () {
            return vm.alertCoverages;
          }
        }
      });
    };


    function loadCoverages() {
      
      var customer = userFactory.getCustomer();
      var has_customer = (customer!=null);
      console.log('has customer already been loaded? ' + has_customer);

      if (has_customer) {
            coverages.splice(0, coverages.length);        
            angular.forEach(customer.certificates, function (item) 
            {
                coverages.push(item);
            });
            angular.forEach(coverages, function (item) 
            {
              item.claims = coverageFactory.loadClaims(item.certificateNumber);
            });
            divideData(coverages);
   //customer = coverageFactory.getCustomer();
   vm.customerFullName = customer.firstName + ' ' + customer.lastName;
   vm.masterId = customer.masterId;

   //check if discount section would be shown or not
   var cnt = coverages.filter(function (item) {
     return item.affinityFlag === 'Y';
   }).length;
   vm.isDiscountShown = cnt > 0;

   //get the certificates that have special billing alert
   vm.alertCoverages = coverages.filter(function (item) {
     return item.alert === 'Y';
   });   
  } 
  else {
   
    coverageFactory.loadItems().then(function () {
   divideData(coverages);
   customer = coverageFactory.getCustomer();
   vm.customerFullName = customer.firstName + ' ' + customer.lastName;
   vm.masterId = customer.masterId;

   //check if discount section would be shown or not
   var cnt = coverages.filter(function (item) {
     return item.affinityFlag === 'Y';
   }).length;
   vm.isDiscountShown = cnt > 0;

   //get the certificates that have special billing alert
   vm.alertCoverages = coverages.filter(function (item) {
     return item.alert === 'Y';
   });
    });
    
  }
    }

    function divideData(coverages) {
      var coverageSections = {};
      coverages.forEach(function (item) {
        if (!coverageSections[item.status]) {
          coverageSections[item.status] = [];
        }
        coverageSections[item.status].push(item);
      });
      vm.coverageSections = coverageSections;
    }

    //divide data if there is any preloaded
    // if (coverages.length > 0) {
    //   divideData(coverages);
    // }

    //reload coverages
    loadCoverages();

  }

  function BillingAlertModalController($uibModalInstance, coverages) {
    var vm = this;

    vm.entries = coverages;
    vm.close = function () {
      $uibModalInstance.close();
    };
  }

})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('HomeDiscountController', HomeDiscountController);


  HomeDiscountController.$inject = ['$scope', 'userFactory', '$rootScope'];

  function HomeDiscountController($scope, userFactory, $rootScope) {
    var vm = this;
    vm.isAdmin = userFactory.isAdmin();
    vm.services = [
      {title: 'Automotive', description: 'Buy, lease or rent a car for less with automotive discounts', url: 'https://www.ama-assn.org/life-career/auto-discounts', icon: 'discount-automotive.png'},
      {title: 'Financial', description: 'Save money and help organize your personal life', url: 'https://www.ama-assn.org/content/ama-preferred-provider-offers-and-services-loans-and-financial-services', icon: 'discount-financial.png'},
      {title: 'Travel', description: 'See the world and save on car rentals, hotels and your next family vacation', url: 'https://www.ama-assn.org/life-career/travel-discounts', icon: 'discount-travel.png'},
      {title: 'Office', description: 'Help save on business services to keep your office running smoothly', url: 'https://www.ama-assn.org/content/ama-preferred-provider-offers-and-services-discounts-your-practice', icon: 'discount-office.png'},
      {title: 'Home', description: 'Buying, selling or freshening up your home', url: 'https://www.ama-assn.org/content/ama-preferred-provider-offers-and-services-loans-and-financial-services', icon: 'discount-home.png'},
      {title: 'Education', description: 'Start preparing for your exams and save on test prep courses ', url: 'https://www.ama-assn.org/education/ama-preferred-provider-offers-services-educational-discounts', icon: 'discount-education.png'}
    ];
    
    vm.openServiceUrl = function(url){
      if(vm.isAdmin){
        return;
      }
      $rootScope.openExternalUrl(url);
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('amaiFooter', amaiFooter)
    .controller('FooterController', FooterController);

  amaiFooter.$inject = [];
  FooterController.$inject = ['$state', 'userFactory', '$timeout', '$rootScope'];

  function amaiFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      controller: 'FooterController as vm',
      bindToController: true
    };

    return directive;
  }

  function FooterController($state, userFactory, $timeout, $rootScope) {
    var vm = this;

    $timeout(setCurrentState(), 0);

    function setCurrentState() {
      vm.currentState = $state;
    }

    vm.isLoggedIn = userFactory.loggedIn() === 'logged-in';
    $rootScope.$on('user-logged-in', function (e, userInfo) {
      vm.isLoggedIn = true;
    });
    $rootScope.$on('user-logged-out', function (e, userInfo) {
      vm.isLoggedIn = false;
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .filter("formatDate", formatDate)
    .filter('filterCoverages', filterCoverages);

  function formatDate ($filter) {
    return function (date, format, fromFormat) {
      format = format || 'M/D/YYYY';
      if (fromFormat) {
        return moment(date, fromFormat).format(format);
      } else {
        return moment(date).format(format);
      }
    };
  }

  function filterCoverages () {
    return function (input, options) {
      if (!input || !input.length || !options) {
        return input;
      }
      return input.filter(function (item) {
        if (options.status && options.status.toLowerCase() === item.status.toLowerCase()) {
          return true;
        }
        return false;
      });
    };
  }
})();

'use strict';

angular.module('app').factory('coverageFactory', function ($http, $cookies, userFactory) {
  var _serverAddress = userFactory.getServerAddress();
  var _coverages = [];
  var _customer = null;

  //will use short name if id is not defined
  var _typePerShortName = {
    'term_life': {icon: 'ico-play.png'},
    'disability': {icon: 'ico-injury.png'},
    'office_overhead_expense': {icon: 'ico-desk.png'},
    'catastrophic_major_medical': {icon: 'ico-health.png'},
    'hospital_income': {icon: 'ico-health.png'},
    'medicare_supplement': {icon: 'ico-emblem.png'},
    'retiree_medical': {icon: 'ico-emblem.png'},
    'long_term_care': {icon: 'ico-wheelchair.png'},
    'accidental_death': {icon: 'ico-play.png'},
    'dental': {icon: 'ico-dental.png'},
    'global_emergency': {icon: 'ico-global.png'},
    'prescription_drug': {icon: 'ico-prescript.png'},
    'vision': {icon: 'ico-vision.png'}
  };

  function getTypeId(shortName) {
    var escaped = getEscapedShortName(shortName);
    if (_typePerShortName[escaped] && _typePerShortName[escaped].id) {
      return _typePerShortName[escaped].id;
    }
    if (_typePerShortName[escaped]) {
      return escaped;
    } else {
      return null;
    }
  }

  function getEscapedShortName(shortName) {
    return shortName.toLowerCase().replace(/\s+/g, '_');
  }

  function getTypeIcon(coverage) {
    //var typeObj = _typePerShortName[getEscapedShortName(shortName)];
    return 'assets/images/' + (coverage.productIcon || '').toLowerCase();
  }

  var service = {
        loadItems: function () 
		{
            var customerId = userFactory.getId();
			console.log('getting customer ' + _serverAddress + 'customer/' + customerId);
			
			//else {
			
				return $http.get(_serverAddress + 'customer/' + customerId)
					.then(function (response) 
					{
						_customer = response.data;
						_coverages.splice(0, _coverages.length);
				
						console.log('pushing certificates');
						angular.forEach(response.data.certificates, function (item) 
						{
							_coverages.push(item);
							});
							return _coverages;
					})
					.then(function (coverages)
					{
						console.log('loading claims');
						angular.forEach(coverages, function (item) 
						{
							service.loadClaims(item.certificateNumber)
								.then(function (claims) {
									item.claims = claims;
								});
						});
						return coverages;
					});
			//}
      },
    getItems: function () {
      return _coverages;
    },
    setItems: function (coverages) {
      _coverages = coverages || [];
    },
    getCustomer: function () {
      return _customer;
    },
    loadClaims: function (certificateNumber) {
      console.log('loading certificate ' + _serverAddress + 'claims/' + certificateNumber + '/0');
      return $http({
        method: 'GET',
        dataType: 'text',
        url: _serverAddress + 'claims/' + certificateNumber + '/0'
      }).then(function (response) {
        console.log('loading complete for ' + certificateNumber + '. Returning content.');
        return response.data.content;
      });
    },
    loadClaimsTabText: function (shortName) {
    console.log(_serverAddress + 'claims/tabText?shortName=' + shortName);
      return $http({
        method: 'GET',
        dataType: 'text',
        url: _serverAddress + 'claims/tabText?shortName=' + shortName
      }).then(function (response) {
        return response.data.content;
      });
    },
    getTypeIcon: getTypeIcon,
    getTypeId: getTypeId
  };

  return service;

});

(function () {
  'use strict';

  angular
          .module('app')
          .directive('coverageItem', coverageItem)
          .controller('DependentsModalController', DependentsModalController)
          .controller('ImageRedirectModalController', ImageRedirectModalController);

  DependentsModalController.$inject = ['$scope', '$modalInstance', 'dependents'];
  ImageRedirectModalController.$inject = ['$scope', '$modalInstance', 'userFactory', 'certificateNumber'];

  function coverageItem(coverageFactory, userFactory, $uibModal, billingFactory, $log) {
    return {
      scope: {
        data: '='
      },
      templateUrl: 'app/components/coverage/coverage_item.html',
      controller: function ($scope) {

        //will use short name if id is not defined
        var typePerShortName = {
          'term_life': {icon: 'ico-play.png'},
          'disability': {icon: 'ico-injury.png'},
          'office_overhead_expense': {icon: 'ico-desk.png'},
          'catastrophic_major_medical': {icon: 'ico-health.png'},
          'hospital_income': {icon: 'ico-health.png'},
          'medicare_supplement': {icon: 'ico-emblem.png'},
          'retiree_medical': {icon: 'ico-emblem.png'},
          'long_term_care': {icon: 'ico-wheelchair.png'},
          'accidental_death': {icon: 'ico-play.png'},
          'dental': {icon: 'ico-dental.png'},
          'global_emergency': {icon: 'ico-global.png'},
          'prescription_drug': {icon: 'ico-prescript.png'}
        };

        $log.log($scope.data.riders);


        function typeChanged() {
          $scope.type = coverageFactory.getTypeId($scope.data.planShortName);
          $scope.iconPath = coverageFactory.getTypeIcon($scope.data);
          if ($scope.data.opened) {
            $scope.isItemOpened = true;
          }
          /*$scope.documentImages = [];
          $scope.data.certificateImages.forEach(function (item) {
            item.documentTitle = 'Certificate Image';
            $scope.documentImages.push(item);
          });
          $scope.data.scheduleImages.forEach(function (item) {
            item.documentTitle = 'Schedule Image';
            $scope.documentImages.push(item);
          });*/
          $scope.documentsOptions = {type: 'coverage', data: {certNum: $scope.data.certificateNumber}};
          $scope.certDocumentsOptions = {type: 'coverage', data: {certNum: $scope.data.certificateNumber, docType: 'CERTIFICATE DOCUMENTS'}};
          $scope.schedulePagesOptions = {type: 'coverage', data: {certNum: $scope.data.certificateNumber, docType: 'SCHEDULE PAGES'}};
        }

        function loadClaims() {
      coverageFactory.loadClaimsTabText($scope.data.planShortName).then(function (claimsTabText) {
            $scope.claimsText = claimsTabText;
        if ($scope.claimsText == undefined)
        {
            $scope.claimsText = "<p>No claims content!</p>";
        }
        //console.log("claims text = " + $scope.claimsText);
          });
        }

        $scope.isAdmin = userFactory.isAdmin();

        $scope.$watch('data.planShortName', function () {
          typeChanged();
        });


        $scope.checkPayInProgress = function (bill) {
          return billingFactory.checkPayInProgress(bill);
        };

        $scope.payNow = function (bill) {
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'app/components/billing/pay_modal.html',
            controller: 'BillingPayModalController as vm',
            resolve: {
              info: function () {
                return bill;
              }
            }
          });
        };

        $scope.openDependentsModal = function (dependents) {
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'app/components/coverage/view-dependents.html',
            controller: 'DependentsModalController as vm',
            resolve: {
              dependents: function () {
                return {
                  dependents: dependents
                };
              }
            }
          });
        };
        
        $scope.openImagesRedirectModal = function (certificateNumber) {
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'app/components/coverage/image-redirect.html',
            controller: 'ImageRedirectModalController as vm',
            resolve: {
              certificateNumber: function () {
                return certificateNumber;
              }
            }
          });
        };

        $scope.linarClaimsArray = function(paged){
          var ary = [];
          angular.forEach(paged, function(pagingSet){
            ary = ary.concat(pagingSet.content);
          });
          return ary;
        };

        $scope.$watch('isItemOpened', function (nVal) {
          if (nVal) {
            loadClaims();
          }
        });
      },
      link: function (/*scope, elem, attrs, ctrl*/) {
      }
    };
  }

  function DependentsModalController($scope, $modalInstance, dependents) {
    var vm = this;

    vm.dependents = dependents;

    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
    
    vm.isShowTerminationDate = function(dateStr){
      if(!dateStr || dateStr === '0001-01-01'){
        return false;
      }
      var current = moment();
      var tdate = moment(dateStr, 'YYYY-MM-DD');
      if(tdate.isAfter(current, 'day')){
        return false;
      }
      return true;
    };

  }

  function ImageRedirectModalController($scope, $modalInstance, userFactory, certificateNumber) {
    var vm = this;
    vm.imageAddress = userFactory.getImageAddress();
    vm.certificateNumber = certificateNumber;
    vm.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('CoverageController', CoverageController)
    .controller('CoverageModalController', CoverageModalController);

  CoverageController.$inject = ['$location', 'userFactory', 'coverageFactory', '$filter', '$uibModal'];
  CoverageModalController.$inject = ['$scope', '$modalInstance'];

  function CoverageController($location, userFactory, coverageFactory, $filter, $uibModal) {
    var vm = this;
    vm.customer = userFactory.getCustomer();
	vm.imageAddress = userFactory.getImageAddress();
	
    var params = $location.search();

    if (params.status) {
      vm['is' + params.status + 'Open'] = true;
    } else {
      vm.isActiveOpen = true;
      vm.isPendingOpen = true;
    }

    vm.coverages = coverageFactory.getItems();
    vm.filterCoverages = function (status) {
      return $filter('filterCoverages')(vm.coverages, {'status': status});
    };

    function openCoverage() {
      vm.coverages.forEach(function (item) {
        if (params.id) {
          item.opened = item.id == params.id*1;
        } else {
          item.opened = true;
        }
      });	
    }

    if (vm.coverages.length === 0) {
      coverageFactory.loadItems().then(function () {
        vm.customer = coverageFactory.getCustomer();
        openCoverage();
      });
    } else {
      openCoverage();
    }

    vm.openDental = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'coverageModal.html', // needs to be moved to a separate file
        controller: 'CoverageModalController as vm'
      });
    }
  }

  function CoverageModalController($scope) {
    var vm = this;
  }


})();

"use strict";

angular.module("app").factory("faqFactory", function () {
  var _data = {
    "Security": [
      {
        "q": "I forgot my user name. How do I log in?",
        "a": "Your user name is your email address.  If you have multiple email addresses and are unsure of which one you used, call our Contact Center at 1-888-627-5883 and a representative will assist you. "
      },
      {
        "q": "I forgot my password. How do I log in?",
        "a": "Simply enter your email address on the login page, and then click on the phrase “Forgot your password?” An email will be sent to you with instructions on how to access your account.  Or you can call our Contact Center at 1-888-627-5883 and a representative will assist you."
      },
      {
        "q": "What if I don’t have an email address?",
        "a": "An email address is required to create your online account."
      },
      {
        "q": "I have coverage through AMA Insurance but when I attempted to register, it didn’t recognize my name. ",
        "a": "In order to complete the registration, you must enter the first name, last name and zip code as shown on your most recent bill or certificate. An exact match is required. Middle initial is not required.  If your name or address on your bill is incorrect, please call our Contact Center at 1-888-627-5883 and a representative will assist you."
      },
      {
        "q": "Why should I register for an account?",
        "a": "If you have purchased coverage through AMA Insurance, you will be able to:<ul><li>conveniently manage your coverage(s)</li><li>securely pay bills</li><li>view your payment history and view or print a bill</li><li>view or print your certificate</li><li>view recent claims</li><li>view coverage details</li></ul>"
      }
    ],
    "Billing": [
      {
        "q": "What options are available to pay my bill?",
        "a": "You can pay:<ul><li><strong>Online:</strong> Pay a bill on-line 24/7 via a secure link to <a href='https://ebp.firstexpresspay.com/EBP1/webpayment.html?companyNumber=1000000027' target='_blank'>First Horizon Bank</a>.</li><li><strong>By Mail:</strong> Send a check for the amount due, along with the Bill Notice to AMA Insurance, PO Box 8646, Carol Stream, IL 60197-8646.</li><li><strong>Over the Phone:</strong> Simply call 1-888-627-5883 Monday – Friday from 8 am to 5 pm CT to make a payment over the phone.  Please have your bank routing number and checking account number available to complete the transaction.</li><li><strong>Monthly Automatic Payments:</strong<br>You can have your payments automatically sent each month through <a href='https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=076e3c54-ce10-4378-93c8-cd71f2519a98&env=na2&acct=c5863cfc-a54c-440c-9d43-463d4e81dec8&v=2' target='_blank'>Electronic Funds Transfer</a> (EFT).</li></ul>"
      },
      {
        "q": "Can I make a payment with a credit card?",
        "a": "Payment by credit card is not accepted at this time."
      },
      {
        "q": "Can I pay for 2 certificates at one time?",
        "a": "<ul><li><strong>Online:</strong> Enter each payment in a separate transaction.</li><li><strong>By Mail:</strong> If you write a check, you must enclose both payment stubs and indicate both certificate/record numbers on the check.</li></ul>"
      },
      {
        "q": "My spouse and I are both insured.  Can I pay for both coverages at the same time?",
        "a": "<ul><li><strong>Online:</strong> Enter each payment in a separate transaction. </li><li><strong>By Mail:</strong> If you write a check, you must enclose both payment stubs and indicate both certificate/record numbers on the check.</li></ul>"
      },
      {
        "q": "How can I change my billing frequency?",
        "a": "Call our Contact Center at 1-888-627-5883 Monday – Friday from 8am to 5pm CT and a representative will assist you."
      },
      {
        "q": "How do I cancel a scheduled payment?",
        "a": "Call our Contact Center at 1-888-627-5883 Monday – Friday from 8am to 5pm CT and a representative will assist you. "
      },
      {
        "q": "How can I reinstate an inactive coverage?",
        "a": "Call our Contact Center at 1-888-627-5883 Monday – Friday from 8am to 5pm CT and a representative will assist you."
      }
    ],
    "General": [
      {
        "q": "I have purchased other insurance through AMA Insurance that isn’t listed. Why can’t I see it?",
        "a": "Information contained on My Account includes only those plans that are administered by AMA Insurance.   Certain plans, such as Home & Auto, are administered by the insurance company directly.  If you need help with a plan or can’t find a plan you are looking for, use the Contact Us page to send us an email or call us for assistance at 1-888-627-5883 Monday – Friday from 8am to 5pm CT."
      },
      {
        "q": "I have an owner on my life insurance. Why can’t I make any changes to my coverage?",
        "a": "When you designate an owner other than yourself, the owner retains all rights to the insurance. The owner must contact us by phone or in writing to make any coverage, billing or address changes. The owner can call our Contact Center at 1-888-627-5883 and a representative will assist them."
      },
      {
        "q": "How can I change my beneficiary?",
        "a": "You may download a Change of Beneficiary form from the resource center at <a href=\"https://amai-wordpress-s3uploads.s3.us-east-2.amazonaws.com/uploads/2021/10/GMAD-Beneficiary-Form-9.21.pdf\" target=\"_blank\">https://amai-amai-wordpress-master-s3uploads.s3.amazonaws.com/uploads/2021/01/GMAD-COB-Form-200-3-8.19-Fillable-Form.pdf</a>. Complete and sign the form and mail it to: AMA Insurance, 330 N Wabash, Suite 39300 Chicago, IL 60611-5885, or fax it to 1-877-588-7488."
      },
      {
        "q": "How can I obtain a copy of my certificate?",
        "a": "You may view, print or save a copy of your Certificate of Insurance from the Coverage Details page.  If one isn’t available, use the Contact Us page to send us an email or call us for assistance at 1-888-627-5883 Monday – Friday from 8am to 5pm CT."
      },
      {
        "q": "How can I get a replacement ID card?",
        "a": "We provide ID cards for Medicare Supplement, Retiree Medical, Catastrophic (Excess) Major Medical & Dental Insurance plans. If you need a new card, use the Contact Us page to send us an email or call us for assistance at 1-888-627-5883 Monday – Friday from 8am to 5pm CT."
      },
      {
        "q": "I have insured dependents. Why aren’t they shown on the Dependent screen?",
        "a": "In most cases, the dependent names are reflected on this page.  However, at the time you applied for this insurance, we may not have required the dependent names on the application.  If you have family coverage and would like to add the names of your dependents, use the Contact Us page to send us an email or call us for assistance at 1-888-627-5883 Monday – Friday from 8am to 5pm CT.  "
      },
      {
        "q": "I no longer have any active dependents but they’re shown on the Dependent page. How can I remove one or more of them?",
        "a": "If you would like to remove dependents from your coverage,  use the Contact Us page to send us an email or call us for assistance at 1-888-627-5883 Monday – Friday from 8am to 5pm CT."
      }
    ],
    "Claims": [
      {
        "q": "How do I file a claim?",
        "a": "Claim submissions vary by product.  Click on the Claims tab located on the Account Summary  page or Coverage Page for specific instructions. "
      }
    ]
  };

  var service = {
    getData: function () {
      return _data;
    }
  };

  return service;

});

'use strict';

angular.module('app').controller('FaqController', function (faqFactory) {
  var vm = this;
  
  vm.faqData = faqFactory.getData();
});

'use strict';

angular.module('app').controller('ContactUsController', function ($scope, $http, userFactory, coverageFactory, $location, $log) {
  var _serverAddress = userFactory.getServerAddress();

  var params = $location.search();


  var vm = this;

  vm.emailInvalid = null;
  vm.phoneInvalid = null;

  vm.coverages = coverageFactory.getItems();
  vm.subjects = [
    'Request copy of my certificate',
    'Request replacement ID card',
    'Change my billing frequency',
    'Change my beneficiary',
    'Change a designee, payor or owner',
    'File a claim',
    'Change my coverage',
    'Add or remove dependents',
    'Other'
  ];
  vm.isSuccess = false;
  vm.customer = null;
  vm.coverage = params.number || '';

  vm.submit = function () {
    vm.isSaving = true;

    //getting the subject
    var subjects = [];
    angular.forEach(vm.subject, function (value, key) {
      if (value === true) {
        subjects.push(vm.subjects[key * 1]);
      }
    });

    $http({
      method: 'POST',
      url: _serverAddress + 'customer/contact',
      data: {
        masterId: vm.customer.masterId,
        certRegarding: vm.coverage,
        subject: subjects.join(', '),
        contactInfo: vm.contactInfo,
        comment: vm.comments,
        callTimeStart: vm.callTimeStart,
        callTimeEnd: vm.callTimeEnd
      }
    }).then(function () {
      vm.isSaving = false;
      vm.isSuccess = true;
    });
  };

  vm.isEmptyObject = function (obj) {

    // null and undefined are "empty"
    if (obj == null)
      return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)
      return false;
    if (obj.length === 0)
      return true;

    for (var key in obj) {
      if (typeof (obj[key]) !== 'undefined')
        return false;
    }
    return true;
  };

  function correctContactInfo() {
    vm.contactInfo = vm.contactType === 'email' ? angular.copy(vm.userEmail) : angular.copy(vm.userPhoneNumber);
  }

  vm.contactType = 'email';
  vm.userPhoneNumber = '';
  vm.userEmail = '';

  if (vm.coverages.length === 0) {
    //load coverages
    coverageFactory.loadItems().then(function () {
      correctData();
    });
  } else {
    correctData();
  }

  function correctData() {
    if (!params.number && vm.coverages.length === 1) {
      vm.coverage = vm.coverages[0].certificateNumber;
    }
    vm.customer = coverageFactory.getCustomer();
    if (vm.customer) {
      vm.userPhoneNumber = vm.customer.telephoneNumber;
      vm.userEmail = vm.customer.loginEmail;
    }
    correctContactInfo();
  }

  $scope.$watch('vm.contactType', function () {
    correctContactInfo();
  });

  vm.checkValidation = function (field) {
    $log.log('Field selected is: ' + field);
    var fieldValidated = false;
    if (field === 'email') {
      if (vm.contactInfo && vm.contactType === 'email') {
        vm.emailInvalid = null;
        if (!vm.contactInfo.match(/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$)/)) {
          vm.emailInvalid = 'Please enter a valid email.';
        } else {
          fieldValidated = true;
        }
      } else {
        vm.emailInvalid = 'This is a required field.';
      }
    }

    if (field === 'phone') {
      if (vm.contactInfo && vm.contactType === 'phone') {
        vm.phoneInvalid = null;
        fieldValidated = true;
      } else {
        vm.phoneInvalid = 'This is a required field.';
      }
    }
    return fieldValidated;
  }
});

(function () {
  'use strict';

  angular
    .module('app')
    .filter('filterClaims', filterClaims);

  function filterClaims() {
    return function (input, options) {
      if (!input || !input.length || !options) {
        return input;
      }
      return input.filter(function (item) {
        if (options.personName) {
          var type = options.personName.split('_')[0];
          var name = options.personName.split('_')[1];
          if ((type === 'provider' && item.providerName === name) || (type === 'patient' && item.patientName === name)) {
            return true;
          }
        }
        return false;
      });
    };
  }
})();

'use strict';

angular.module('app').factory('claimsFactory', function ($http, userFactory) {
  var _serverAddress = userFactory.getServerAddress();

  var _patients = [];
  var _providers = [];
  
  var service = {
    getProviders: function () {
      return _providers;
    },
    loadProviders: function(masterId){
      return $http({
        method: 'GET',
        url: _serverAddress + 'claims/provider/' + masterId
      }).success(function (data) {
        data = data.sort(function(a, b){
          return a[1] > b[1] ? 1 : -1;
        });
        angular.copy(data, _providers);
        return _providers;
      });
    },
    getPatients: function () {
      return _patients;
    },
    loadPatients: function(masterId){
      return $http({
        method: 'GET',
        url: _serverAddress + 'claims/patient/' + masterId
      }).success(function (data) {
        data = data.sort(function(a, b){
          return a > b ? 1 : -1;
        });
        angular.copy(data, _patients);
        return _patients;
      });
    },
    loadClaims: function(options){
      var path= _serverAddress + 'claims/' + options.masterId + '/';
      if(options.type==='provider'){
        path += 'provider/';
      }else{
        path += 'patient/';
      }
      path += options.key + '/' + options.pageNum;
      console.log(path);
      return $http({
        method: 'GET',
        url: path
      });
    },
    clearClaims: clearClaims
  };

  return service;

  function clearClaims() {
    console.log("claims have been cleared during logout");      
    if (_patients) {
            _patients = [];
        }
        if (_providers) {
            _providers = [];
        }
    }


});

(function () {
  'use strict';

  angular
          .module('app')
          .controller('ClaimsController', ClaimsController)
          .controller('ClaimDetailsModalController', ClaimDetailsModalController);

  ClaimsController.$inject = ['$uibModal', 'claimsFactory', '$scope', 'coverageFactory', '$q', 'userFactory'];
  ClaimDetailsModalController.$inject = ['$scope', '$uibModalInstance', 'claim', 'coverage'];


  function ClaimsController($uibModal, claimsFactory, $scope, coverageFactory, $q, userFactory) {
    var vm = this;

    vm.coverages = coverageFactory.getItems();
    vm.customer = userFactory.getCustomer();

    vm.personName = null;
    vm.patients = claimsFactory.getPatients();
    vm.providers = claimsFactory.getProviders();
    vm.claims = [];

    vm.noPeople = false;
    vm.loadItemsComplete = false;
    vm.loadClaimsComplete = false;

    var coverageDic = {};

    function loadPersons() {
      $q.all([
        claimsFactory.loadProviders(vm.customer.masterId),
        claimsFactory.loadPatients(vm.customer.masterId)
      ]).then(function(){
        vm.loadItemsComplete = true;
        vm.loadClaims();
        selectFirstPerson();
      });
    }

    function selectFirstPerson() {
      if (!vm.personName) {
        if (vm.providers.length > 0) {
          vm.personName = 'provider_' + vm.providers[0][0];
          vm.noPeople = false;
        } else {
          if (vm.patients.length > 0) {
            vm.personName = 'patient_' + vm.patients[0];
            vm.noPeople = false;
          } else {
            if (vm.loadItemsComplete && vm.personName == null && vm.claims.length === 0) {
              vm.noPeople = true;
            }
          }
        }
      }
    }

    vm.open = function (claim) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/claims/claim-details-modal.html',
        controller: 'ClaimDetailsModalController as vm',
        resolve: {
          claim: function () {
            return claim;
          },
          coverage: function () {
            return vm.getCoverageByNumber(claim.certificateNumber);
          }
        }
      });
    };

    vm.loadClaims = function () {
      var options = {
        pageNum: vm.currentPageNum - 1,
        type: vm.personType,
        key: vm.personKey,
        masterId: vm.customer.masterId
      };
      if (options == null || options == undefined)
      {
        console.log("skipping claims load...no options");
        return;
      }
      if (options.key == undefined || Number.isNaN(options.pageNum))
      {
        console.log("skipping claims load...invalid options");
        return;
      }

      claimsFactory.loadClaims(options).success(function (data) {
        vm.loadClaimsComplete = true;
        vm.claims = data.content;
        vm.totalItems = data.totalElements;
        vm.pageRowsNum = data.size;
        //vm.loadItemsComplete = true;

        if (vm.loadClaimsComplete && vm.claims.length === 0) {
          vm.noPeople = true;
        }
      });
    };

    vm.pageChanged = function () {
      console.log('selectedPageNum:', vm.currentPageNum);
      vm.loadClaims();
    };

    vm.getCoverageByNumber = function (num) {
      return coverageDic[num];
    };


    if (!vm.customer) {
      coverageFactory.loadItems().then(function () {
        vm.loadItemsComplete = true;
        vm.customer = coverageFactory.getCustomer();
        loadPersons();
      });
    } else {
      loadPersons();
    }

    $scope.$watch('vm.personName', function (newVal) {
      if (newVal) {
        vm.personType = newVal.split('_')[0];
        vm.personKey = newVal.split('_')[1];
        vm.currentPageNum = 1;
        vm.claims = [];
        vm.loadClaims();
      }
    });

    $scope.$watch('vm.loadItemsComplete')

    $scope.$watch('vm.coverages', function (newVal) {
      if (newVal) {
        newVal.forEach(function (coverage) {
          coverageDic[coverage.certificateNumber] = coverage;
        });
      }
    }, true);

    selectFirstPerson();
    //vm.loadClaims();
  }

  function ClaimDetailsModalController($scope, $uibModalInstance, claim, coverage) {
    var vm = this;

    vm.claim = claim;
    vm.coverage = coverage;

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('openClaimDetails', openClaimDetails)
    .controller('ClaimDetailsController', ClaimDetailsController);

  openClaimDetails.$inject = [];
  ClaimDetailsController.$inject = ['$uibModal'];

  function openClaimDetails() {
    var directive = {
      controller: 'ClaimDetailsController as vm',
      bindToController: true,
      scope: {
        claim: '=',
        coverage: '='
      },
      link: link
    };

    return directive;

    function link(scope, element) {
      element.bind('click', function (event) {
        event.preventDefault();
        scope.vm.openModal();
      })
    }
  }

  function ClaimDetailsController($uibModal) {
    var vm = this;

    vm.openModal = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/claims/claim-details-modal.html',
        controller: 'ClaimDetailsModalController as vm',
        resolve: {
          claim: function () {
            return vm.claim;
          },
          coverage: function () {
            return vm.coverage;
          }
        }
      })
    }
  }

})();

'use strict';

angular.module('app').factory('authInterceptor', function ($q, $location, $cookies) {
  return {
    request: function (config) {
      var user = $cookies.getObject('user');
      if(user){
        config.headers['x-auth-token'] = user.token;
      }
      return config;
    },
    responseError: function(response){
      if (response.status === 401 || response.status === 403) {
        $location.path('/logout/');
      }else if(response.status === 404 || response.status === -1){
        $location.path('/not-found/');
      }
      return $q.reject(response);
    }
  };
});
  
(function () {
  'use strict';

  angular
          .module('app')
          .factory('authFactory', authFactory);

  authFactory.$inject = ['$http', '$cookies', 'userFactory'];

  function authFactory($http, $cookies, userFactory) {
    var _token;
    var _serverAddress = userFactory.getServerAddress();
    var service = {
      authenticate: authenticate
    };
    return service;

    // used to prevent user from accessing pages that they shouldn't have access to
    // this is used exclusively in app.routes.js/app.states.js
    function authenticate() {
      // gets user's token from cookies, if no cookie, _token will be blank and server will return 403
      // this part might be redundant with other functions, but I left it in for now just to make sure
      if ($cookies.getObject('user')) {
        _token = $cookies.getObject('user').token;
      } else {
        _token = '';
      }
      var request = $http({
        method: 'POST',
        url: _serverAddress + 'checkToken',
        transformResponse: function (data) {
          return data;
        }
      });
      return request;
    }
  }
  
})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('SelectCustomerController', SelectCustomerController);

  SelectCustomerController.$inject = ['$scope', '$stateParams', '$state', 'userFactory', '$http', 'coverageFactory', '$rootScope'];

  function SelectCustomerController($scope, $stateParams, $state, userFactory, $http, coverageFactory, $rootScope) {
    var vm = this;

    vm.selectCustomer = function () {
      vm.checking = true;
console.log('selecting customer '+vm.masterId);	  
      $http({
        method: 'GET',
        url: userFactory.getServerAddress() + 'customer/admin/' + vm.masterId
      }).success(function (selectedCustomer) {
        vm.checking = false;
console.log('customer selected.');	  
        if (selectedCustomer) {
console.log('set coverages');	  
          coverageFactory.setItems([]);
console.log('set admin customer id');	  
          userFactory.setAdminCustomerId(selectedCustomer.id, selectedCustomer.user);
console.log('set customer');	  
          userFactory.setCustomer(selectedCustomer);
console.log('broadcast selected customer');	  
          $rootScope.$broadcast('admin.selectedCustomer', selectedCustomer);
console.log('transition to home page');	  
          $state.transitionTo('home', $stateParams, {
            reload: true,
            inherit: false,
            notify: true
          });
console.log('select customer complete');	  
        } else {
          alert('Unable to find customer with this MasterID.');
        }
      }).error(function (response) {
        vm.checking = false;
        alert('Unable to find customer with this MasterID');
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ManageAdminController', ManageAdminController)
    .controller('ManageAdminModalController', ManageAdminModalController)
    .controller('ManageAdminPwdModalController', ManageAdminPwdModalController);

  ManageAdminController.$inject = ['$scope', '$uibModal', 'adminFactory'];
  ManageAdminModalController.$inject = ['$scope', '$uibModalInstance', 'adminFactory'];
  ManageAdminPwdModalController.$inject = ['$scope', '$uibModalInstance', 'adminFactory', 'selectedAdmin'];

  function ManageAdminController($scope, $uibModal, adminFactory) {
    var vm = this;
    
    vm.admins = adminFactory.getItems();

    vm.openAdminModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'admin_modal.html', // needs to be moved to a separate file
        controller: 'ManageAdminModalController',
        resolve: {
        }
      });
    };
    
    vm.openPwdModal = function (admin) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'admin_password_modal.html',
        controller: 'ManageAdminPwdModalController',
        resolve: {
          selectedAdmin: function(){
            return admin;
          }
        }
      });
    };
    
    vm.deleteAdmin = function(admin){
      if(!confirm('Are you sure to delete this administrator?')){
        return;
      }
      admin.isDeleting = true;
      adminFactory.deleteAdmin(admin.username).success(function(){
        admin.isDeleting = false;
        adminFactory.loadItems();
      }).error(function(){
        admin.isDeleting = false;
        alert('Failed in deleting admin');
      });
    };
    
    adminFactory.loadItems();


  }
  
  function ManageAdminModalController($scope, $uibModalInstance, adminFactory){
    $scope.data = {};
    
    $scope.cancel = function(){
      $uibModalInstance.close();
    };
    
      
    //check if same email exists
    $scope.duplicatedEmail = function(){
      if(!$scope.data.email){
        return false;
      }
      return adminFactory.getItems().filter(function(item){
        return item.username === $scope.data.email;
      }).length > 0;
    };
    
    $scope.save = function(){
      if($scope.isSaving){
        return;
      }
      
      $scope.isSaving = true;
      adminFactory.createAdmin($scope.data.email, $scope.data.password).success(function(){
        adminFactory.loadItems();
        $scope.isSaving = false;
        $uibModalInstance.close();
      }).error(function(){
        $scope.isSaving = false;
        alert('Failed in creating new admin');
      });
    };
    
    $scope.$watch('data.email', function(){
      $scope.isDuplicatedEmail = $scope.duplicatedEmail();
    });
  }
  
  
  function ManageAdminPwdModalController($scope, $uibModalInstance, adminFactory, selectedAdmin){
    $scope.data = {};
    
    $scope.cancel = function(){
      $uibModalInstance.close();
    };
    
    $scope.save = function(){
      if($scope.isSaving){
        return;
      }
      $scope.isSaving = true;
      adminFactory.updateAdmin(selectedAdmin.username, $scope.data.password).success(function(){
        $scope.isSaving = false;
        $uibModalInstance.close();
      }).error(function(){
        $scope.isSaving = false;
        alert('Failed in updating password');
      });
    };
  }
})();

'use strict';

angular.module('app').factory('adminFactory', function ($http, $cookies, userFactory) {
  var _serverAddress = userFactory.getServerAddress();
  var _admins = [];

  var service = {
    loadItems: function () {
      return $http({
        method: 'GET',
        url: _serverAddress + 'user/admin/'
      }).then(function (response) {
        _admins.splice(0, _admins.length);
        angular.forEach(response.data, function (item) {
          _admins.push(item);
        });
        return _admins;
      });
    },
    getItems: function () {
      return _admins;
    },
    setItems: function(admins){
      _admins = admins || [];
    },
    createAdmin: function(email, password){
      return $http({
        method: 'POST',
        url: _serverAddress + 'user/admin/create',
        data:{
          username: email, password: password
        }
      });
    },
    updateAdmin: function(email, password){
      return $http({
        method: 'PUT',
        url: _serverAddress + 'user/admin/update',
        data:{
          username: email, password: password
        }
      });
    },
    deleteAdmin: function(email){
      return $http({
        method: 'DELETE',
        url: _serverAddress + 'user/admin/delete',
        data:{
          username: email
        },
        headers: {'Content-Type': 'application/json'}
      });
    }
  };

  return service;

});

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AdminProfileController', AdminProfileController);

  AdminProfileController.$inject = ['$scope', '$cookies', 'adminFactory'];

  function AdminProfileController($scope, $cookies, adminFactory) {
    var vm = this;
    
    vm.password = '';
    vm.confirmPassword = '';
    
    vm.reset = function(){
      vm.password = '';
      vm.confirmPassword = '';
      $scope.adminPasswordForm.$setPristine();
    };
    
    vm.save = function(){
      if(vm.isSaving){
        return;
      }
      vm.isSaving = true;
      var user = $cookies.getObject('user');
      adminFactory.updateAdmin(user.name, vm.password).success(function(){
        vm.isSaving = false;
        vm.reset();
        vm.isSuccess = true;
      }).error(function(){
        vm.isSaving = false;
        alert('Failed in updating password');
      });
    };

  }
})();

(function () {
  'use strict';

  angular
          .module('app')
          .directive('documentImagesList', documentImagesList)
          .controller('DocumentImagesController', DocumentImagesController)
          .controller('DocumentImagesModalController', DocumentImagesModalController);

  DocumentImagesController.$inject = ['userFactory', '$uibModal', '$http', '$scope', '$sce', '$filter'];
  DocumentImagesModalController.$inject = ['$uibModalInstance', 'imageItem'];

  function documentImagesList() {
    var directive = {
      restrict: 'E',
      scope: {
        options: '=',
        listTitle: '='
      },
      replace: true,
      templateUrl: 'app/components/billing/document_image_buttons.html',
      controller: DocumentImagesController,
      link: link
    };

    return directive;

    function link(scope, element) {
      /*element.bind('click', function (event) {
       event.preventDefault();
       scope.openModal(image);
       });*/
    }
  }

  function DocumentImagesController(userFactory, $uibModal, $http, $scope, $sce, $filter) {

    var serverAddress = userFactory.getServerAddress();

    $scope.openModal = function (imageItem) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/billing/document_images_modal.html',
        controller: 'DocumentImagesModalController as vm',
        size: 'lg',
        resolve: {
          imageItem: function () {
            return imageItem;
          }
        }
      });
    };

    function loadImages() {
      /*$scope.loading = true;
      $http({
        method: 'POST',
        url: serverAddress + 'image/' + $scope.options.type,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        // reformats request so that server understands it
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
          }
          return str.join('&');
        },
        data: $scope.options.data
      }).then(function (response) {
        var images = response.data;
        displayImages(images);
      }).finally(function () {
        $scope.loading = false;
      });*/
    }

    function findPairedDoc(receiveDate, images) {
      return images.filter(function (item) {
        return item.receiveDate === receiveDate && item.documentType === 'SCHEDULE PAGES';
      })[0];
    }

    function displayImages(images) {
      /*var newImages = [];
      images.forEach(function (item) {
        if (item.documentType === 'SCHEDULE PAGES' && $scope.options.data.docType === 'CERTIFICATE DOCUMENTS') {
          return;
        }
        //prompt('', serverAddress + 'image/' + item.id + '?authToken=' + userFactory.getToken());
        item.fileUrl = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + (serverAddress + 'imageContent/' + item.id + '?authToken=' + userFactory.getToken()) + '&embedded=true');
        item.isBilling = $scope.options.type === 'bill';
        if (!item.documentTitle) {
          if ($scope.options.type === 'bill') {
            item.documentTitle = 'Bill Notice';
            if (item.billNotice === '2') {
              item.documentTitle = 'Reminder Notice';
            } else if (item.billNotice === '3') {
              item.documentTitle = 'Final Notice';
            }
          } else {
            if (item.documentType === 'CERTIFICATE DOCUMENTS') {
              item.documentTitle = 'Certificate';
            } else {
              item.documentTitle = 'Schedule Page';
            }
          }
          item.documentTitle += ' - ' + $filter('formatDate')(item.receiveDate, null ,'YYYYMMDD');
        }
        if (item.documentType === 'CERTIFICATE DOCUMENTS') {
          item.paired = findPairedDoc(item.receiveDate, images);
          if (item.paired) {
            item.paired.fileUrl = $sce.trustAsResourceUrl('https://docs.google.com/gview?url=' + (serverAddress + 'imageContent/' + item.paired.id + '?authToken=' + userFactory.getToken()) + '&embedded=true');
          }
        }
        newImages.push(item);
      });
      $scope.images = newImages;
	  */
    }

    loadImages();
  }

  function DocumentImagesModalController($uibModalInstance, imageItem) {
    var vm = this;
    vm.image = imageItem;

    vm.cancel = function () {
      $uibModalInstance.close();
    };
  }

})();


(function () {
  'use strict';

  angular
    .module('app')
    .filter('recentBillFilter', recentBillFilter);

  function recentBillFilter($log) {
    return function (bills) {
      if (!bills || !bills.length) {
        return bills;
      }
      for (var i = 0; i < bills.length; i++) {
        if (i !== 0 && bills[i-1] && bills[i]) {
          if (bills[i].recordNumber === bills[i-1].recordNumber) {
            var firstDate = bills[i-1].toDate;
            var secondDate = bills[i].toDate;
            bills.splice((Number(firstDate.substring(0,4)) > Number(secondDate.substring(0,4)) ||
                          (Number(firstDate.substring(0,4)) === Number(secondDate.substring(0,4)) && Number(firstDate.substring(5, 7)) > Number(secondDate.substring(5, 7))) ||
                          (Number(firstDate.substring(0,4)) === Number(secondDate.substring(0,4)) && Number(firstDate.substring(5, 7)) > Number(secondDate.substring(5, 7)) && Number(firstDate.substring(9, 11)) > Number(secondDate.substring(9, 11)))) ? i : i-1, 1);
            i--;
          }
        }
      }
      return bills;
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('billingFactory', billingFactory);

  billingFactory.$inject = ['$http', '$cookies', 'userFactory'];

  function billingFactory($http, $cookies, userFactory) {
    var _serverAddress = userFactory.getServerAddress();
    var service = {
      updatePayMode: updatePayMode,
      updateBankInfo: updateBankInfo,
      findCustomer: findCustomer,
      trackPayment: trackPayment,
      checkPayInProgress: checkPayInProgress,
      loadBillsPaginated: loadBillsPaginated
    };
    return service;

    function updatePayMode() {
      var request = $http({
        method: 'PUT',
        url: _serverAddress + 'certificate/' + userFactory.getId(),
        data: {
          "paymentMode": "Hello!"
        }
      });
      return request;
    }

    function updateBankInfo(newCertificate) {
      return $http({
        method: 'PUT',
        url: _serverAddress + 'certificate/' + newCertificate.id,
        data: {
          "bankAccount": newCertificate.bankAccount
        }
      });
    }

    function findCustomer() {
      var request = $http({
        method: 'GET',
        url: _serverAddress + 'customer/' + userFactory.getId()
      });
      return request;
    }

    function trackPayment(billInfo){
      /*var customerId = userFactory.getId();
      var billingId = billInfo.id;
      var expireDate = new Date();
      expireDate = new Date(expireDate.getTime() + (24 * 60 * 60 * 1000)); //expire in 24 hours
      $cookies.put('pay_tr_' + customerId + '_' + billingId, 'true', {
        expires: expireDate
      });*/
      billInfo.lastPayAttempt = (new Date()).getTime();
      return $http({
        method: 'PUT',
        url: _serverAddress + 'bill/' + billInfo.id,
        data: {
          lastPayAttempt: billInfo.lastPayAttempt
        }
      });
    }

    function checkPayInProgress(billInfo){
      return billInfo.lastPayAttempt && moment().isBefore(moment(billInfo.lastPayAttempt).add(24, 'hours'));
      /*var customerId = userFactory.getId();
      var billingId = billInfo.id;
      return $cookies.get('pay_tr_' + customerId + '_' + billingId) === 'true';*/
    }
    
    function loadBillsPaginated(certificateNum, pageNum){
      pageNum = pageNum || 0;
      return $http({
        method: 'GET',
        url: _serverAddress + 'bill/' + certificateNum + '/' + pageNum
      });
    }
  }

})();

(function () {
  'use strict';

  angular
          .module('app')
          .controller('BillingController', BillingController)
          .controller('BillingModalController', BillingModalController)
          .controller('BillingPayModalController', BillingPayModalController)
    .controller('ImageRedirectModalController', ImageRedirectModalController);

  BillingController.$inject = ['$uibModal', 'billingFactory', 'userFactory', '$location', 'coverageFactory'];
  BillingModalController.$inject = ['$uibModalInstance', 'billingFactory', 'info'];
  BillingPayModalController.$inject = ['$uibModalInstance', '$sce', '$document', 'billingFactory', 'userFactory', 'info'];
  ImageRedirectModalController.$inject = ['$uibModalInstance', 'userFactory', 'certificateNumber'];

  function BillingController($uibModal, billingFactory, userFactory, $location, coverageFactory) {
    var vm = this;
    var params = $location.search();

    vm.billingSummaryData = [];
    vm.paymentOptionsData = [];
    vm.billingHistoryData = [];

    vm.customer = userFactory.getCustomer();
    vm.isAdmin = userFactory.isAdmin();
    vm.billsLoaded = false;

    vm.getCoverageIcon = function (coverage) {
      return coverageFactory.getTypeIcon(coverage);
    };

    //if (vm.customer) {
    //  populate(vm.customer);
    //}
    //else {
    //  billingFactory.findCustomer()
    //          .success(function (customer) {
    //            vm.customer = customer;
    //            userFactory.setCustomer(vm.customer);
    //            populate(vm.customer);
    //          })
    //          .error(function (data) {
    //            console.log(data);
    //          });
    //}
 
    billingFactory.findCustomer()
      .success(function (customer) {
        vm.customer = customer;
        userFactory.setCustomer(vm.customer);
        populate(vm.customer);
		vm.billsLoaded = true;
      })
      .error(function (data) {
        console.log(data);
      });

    // uses customer (from billingFactory) to populate billing variables
    function populate(customer) {
      vm.billingSummaryData = [];
      vm.paymentOptionsData = [];
      vm.billCoverages = customer.certificates.filter(function (item) {
        return item.noCostFlag === 'N' && !(item.status === 'Pending' && item.bills.length === 0);
      });
      if (vm.billCoverages.length > 0) {
        vm.selected = vm.billCoverages[0];
      }
      var i, j, certificate, bill;
      for (i in vm.billCoverages) {
        certificate = vm.billCoverages[i];
        if (certificate.bills.content.length > 0) {
          bill = certificate.bills.content[0];
          vm.billingSummaryData.push({
            id: bill.id,
            image: 'ico-health.png',
            title: certificate.planName,
            shortName: certificate.planShortName,
            productIcon: certificate.productIcon,
            recordNumber: certificate.certificateNumber,
            fromDate: bill.coverageFromDate,
            toDate: bill.coverageToDate,
            amountDue: bill.amountDue,
            status: bill.status,
            billNumber: bill.billNumber,
            hasImage: bill.hasImage,
            lastPayAttempt: bill.lastPayAttempt
          });
        }

        vm.paymentOptionsData.push({
          certId: certificate.id,
          recordNumber: certificate.certificateNumber,
          title: certificate.planName,
          frequency: certificate.paymentMode.substring(0, 1) + certificate.paymentMode.substring(1).toLowerCase(),
          bankName: (certificate.bankAccount && certificate.bankAccount.bankName) ? certificate.bankAccount.bankName : 'Not Applicable',
          bankNumber: certificate.bankAccount ? certificate.bankAccount.accountNumber : '',
          routingNumber: certificate.bankAccount ? certificate.bankAccount.routingNumber : '',
          accountType: certificate.bankAccount ? certificate.bankAccount.accountType : ''
        });

        if (certificate === vm.selected) {
          selectCertificate(certificate);
        }
      }

      vm.noCostCoverages = customer.certificates.filter(function (item) {
        return item.noCostFlag === 'Y';
      });

    }

    // selects certificate for viewing on Billing History tab
    function selectCertificate(certificate) {
      vm.totalItems = certificate.bills.totalElements;
      vm.pageRowsNum = certificate.bills.size;
      vm.currentPageNum = 1;
      processHistoryData(certificate.bills.content);
    }

    function processHistoryData(bills){
      vm.billingHistoryData = [];
      angular.forEach(bills, function(bill){
        vm.billingHistoryData.push({
          id: bill.id,
          fromDate: bill.coverageFromDate,
          toDate: bill.coverageToDate,
          paymentDate: bill.paidDate,
          amountPaid: bill.amountPaid,
          hasImage: bill.hasImage,
          lastPayAttempt: bill.lastPayAttempt,
          docImagesOptions: {
            type: 'bill',
            data: {billNumber: bill.billNumber}
          },
          view: true
        });
      });
    }

    vm.pageChanged = function(){
      console.log('selectedPageNum:', vm.currentPageNum);
      billingFactory.loadBillsPaginated(vm.selected.certificateNumber, vm.currentPageNum-1).success(function(bills){
        processHistoryData(bills.content)
      });
    };

    vm.selectCertificate = selectCertificate;

    vm.isPaymentOptionsTabActive = params.tab === 'payment_options';

    vm.editBank = function (bankInfo) {
      var currentBill = bankInfo;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'bankModal.html', // needs to be moved to a separate file
        controller: 'BillingModalController as vm',
        resolve: {
          info: function () {
            return {
              bankInfo: bankInfo
            };
          }
        }
      });

      modalInstance.result.then(function (newBankInfo) {
        currentBill.bankName = newBankInfo.bankName;
        currentBill.bankNumber = newBankInfo.bankNumber;
        currentBill.routingNumber = newBankInfo.routingNumber;
		currentBill.accountType = newBankInfo.accountType;
      });
    };

    vm.payNow = function (bill) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/billing/pay_modal.html',
        controller: 'BillingPayModalController as vm',
        resolve: {
          info: function () {
            return bill;
          }
        }
      });
    };

 vm.openImagesRedirectModal = function (certificateNumber) {
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'app/components/billing/image-redirect.html',
            controller: 'ImageRedirectModalController as vm',
            resolve: {
              certificateNumber: function () {
                return certificateNumber;
              }
            }
          });
    };

    vm.checkPayInProgress = function (bill) {
      return billingFactory.checkPayInProgress(bill);
    };
  }

  function BillingModalController($uibModalInstance, billingFactory, info) {

    var vm = this;

    vm.currentBankName = info.bankInfo.bankName;
    vm.currentRoutingNumber = info.bankInfo.routingNumber;
    vm.currentAccountNumber = info.bankInfo.bankNumber;
    vm.currentAccountType = info.bankInfo.accountType;

    vm.bankInfo = {
      bankName: info.bankInfo.bankName,
      routingNumber: info.bankInfo.routingNumber,
      accountNumber: info.bankInfo.bankNumber,
      accountType: info.bankInfo.accountType
    };
    vm.newInformation = {
      bankAccount: vm.bankInfo,
      id: info.bankInfo.certId
    };

    vm.fieldRequired = 'This field is required.';

    vm.checkValidation = function (field) {
      vm.formValidated = false;
      // Email Validations
      if (field === 'accountName' || field === 'submit') {
        if (vm.bankInfo.bankName) {
          vm.accountNameInvalid = null;
        } else {
          vm.accountNameInvalid = vm.fieldRequired;
        }
      }

      if (field === 'routingNumber' || field === 'submit') {
        if (vm.bankInfo.routingNumber) {
          vm.routingNumberInvalid = null;
          if (!vm.bankInfo.routingNumber.match(/(\d)+/g) || !isValidAbaNumber(vm.bankInfo.routingNumber)) {
            vm.routingNumberInvalid = 'Please enter a valid routing number.';
          }
        } else {
          vm.routingNumberInvalid = vm.fieldRequired;
        }
      }

      if (field === 'accountNumber' || field === 'submit') {
        if (vm.bankInfo.accountNumber) {
          vm.accountNumberInvalid = null;
          if (!vm.bankInfo.accountNumber.match(/(^[0-9]*$)+/g)) {
            vm.accountNumberInvalid = 'Please enter a valid account number.';
          }
        } else {
          vm.accountNumberInvalid = vm.fieldRequired;
        }
      }

      if (field === 'submit') {
        vm.checkValidation('accountName');
        vm.checkValidation('routingNumber');
        vm.checkValidation('accountNumber');
        vm.accountNameInvalid || vm.routingNumberInvalid || vm.accountNumberInvalid ? vm.formValidated = false : vm.formValidated = true;
      }


    };

    vm.update = function () {
      vm.checkValidation('submit');

      if (vm.formValidated) {
        billingFactory.updateBankInfo(vm.newInformation)
                .then(function successCallback(result) {
                  $uibModalInstance.close(vm.newInformation.bankAccount);
                }, function errorCallback(error) {
                  vm.routingNumberInvalid = error.data;
                  vm.accountNumberInvalid = error.data;
                });
      }
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

  }

  function BillingPayModalController($uibModalInstance, $sce, $document, billingFactory, userFactory, info) {
    var vm = this;

    vm.paymentUrl = $sce.trustAsResourceUrl(userFactory.getPaymentUrl());
    vm.bill = info;
    vm.customer = userFactory.getCustomer();
    vm.trackPay = function () {
      billingFactory.trackPayment(info);
      $uibModalInstance.close();
      var form = $document[0].getElementById('paymentForm');
      if (form) {
        form.submit();
      }
    };
  }

  function ImageRedirectModalController($uibModalInstance, userFactory, certificateNumber) {
    var vm = this;
    vm.imageAddress = userFactory.getImageAddress();
    vm.certificateNumber = certificateNumber;
    vm.cancel = function () {
  $uibModalInstance.dismiss('cancel');
    };
  }

  function isValidAbaNumber(routingNumber) {
    // ABA Checksum Function - Based off of code from http://www.brainjar.com/js/validation/
    var sum = 0;
    for (var i = 0; i < routingNumber.length; i += 3) {
      sum += parseInt(routingNumber.charAt(i), 10) * 3
              + parseInt(routingNumber.charAt(i + 1), 10) * 7
              + parseInt(routingNumber.charAt(i + 2), 10);
    }
    return ((sum !== 0) && (sum % 10 === 0));
  }


})();

'use strict';

angular.module('app').controller('ActivationController', function ($http, $location, userFactory, $scope) {
  var _serverAddress = userFactory.getServerAddress();

  var vm = this;


  vm.activate = function () {
    vm.isSuccess = false;
    vm.errorMsg = '';
    vm.activating = true;
    
    var _token = $location.search().verification_token;

    $http({
      method: 'PUT',
      url: _serverAddress + 'user/activate/' + _token,
      transformResponse: function (response) {
        return response;
      }
    }).then(function (response) {
      vm.isSuccess = true;
    }, function (response) {
      vm.isError = true;
      vm.errorMsg = response.data;
    }).finally(function () {
      vm.activating = false;
    });
  };

  $scope.$watch(function(){
    return $location.search().verification_token;
  }, function(nVal){
    vm.activate();
  });
});

(function() {
  'use strict';

  angular
    .module('app')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');

    // checks if user is logged in or not
    // passes back rejected promise if not, resolved promise if true
    function authenticated(authFactory, $q) {
      var deferred = $q.defer();
      authFactory.authenticate()
        .then(function(authenticate) {
          if (authenticate.data === 'true') {
            deferred.resolve();
          } else {
            deferred.reject();
          }
        });
      return deferred.promise;
    }

    // every new state that should include a usernav must have it as a view
    $stateProvider
      .state('home', {
        url: '/home/',
        views: {
          'content': {
            templateUrl: 'app/components/home/home.html',
            controller: 'HomeController as vm'
          }
        }
      })
      .state('discount', {
        url: '/discount/',
        views: {
          'content': {
            templateUrl: 'app/components/home/discount.html',
            controller: 'HomeDiscountController as vm'
          }
        }
      })
      .state('billing', {
        url: '/billing/',
        views: {
          'content': {
            templateUrl: 'app/components/billing/billing.html',
            controller: 'BillingController as vm'
          }
        }
      })
      .state('coverage', {
        url: '/coverage/',
        views: {
          'content': {
            'templateUrl': 'app/components/coverage/coverage.html',
            controller: 'CoverageController as vm'
          }
        }
      })
      .state('contact', {
        url: '/contact-us/',
        views: {
          'content': {
            'templateUrl': 'app/components/contact-us/form.html',
            controller: 'ContactUsController as vm'
          }
        }
      })
      .state('claims', {
        url: '/claims/',
        views: {
          'content': {
            'templateUrl': 'app/components/claims/claims.html',
            controller: 'ClaimsController as vm'
          }
        }
      })
      .state('faq', {
        url: '/faq/',
        views: {
          'content': {
            'templateUrl': 'app/components/faq/list.html',
            controller: 'FaqController as vm'
          }
        }
      })
      .state('tos', {
        url: '/terms/',
        views: {
          'content': {
            templateUrl: 'app/components/tos/tos.html'
          }
        }
      })
      .state('coc', {
        url: '/code/',
        views: {
          'content': {
            templateUrl: 'app/components/coc/code-of-conduct.html'
          }
        }
      })
      .state('privacy', {
        url: '/privacy/',
        views: {
          'content': {
            templateUrl: 'app/components/privacy/privacy.html',
            controller: 'PrivacyController as vm'
          }
        }
      })
      .state('activation', {
        url: '/user/activate',
        views: {
          'content': {
            templateUrl: 'app/components/activation/activate.html',
            controller: 'ActivationController as vm'
          }
        }
      })
      .state('profile', {
        url: '/profile/',
        views: {
          'content': {
            'templateUrl': 'app/components/profile/profile.html',
            controller: 'ProfileController as vm'
          }
        }
      })
      .state('signup', {
        url: '/register/',
        views: {
          'content': {
            templateUrl: 'app/components/user/signup/signup.html',
            controller: 'SignupController as vm'
          }
        }
      })
      .state('signup2', {
        url: '/user/signup2/',
        views: {
          'content': {
            templateUrl: 'app/components/user/signup/signup2.html',
            controller: 'Signup2Controller as vm'
          }
        }
      })
      .state('login', {
        url: '/',
        views: {
          'content': {
            templateUrl: 'app/components/user/login.html',
            controller: 'LoginController as vm'
          }
        }
      })
      .state('mfa', {
        url: '/mfa/',
        views: {
          'content': {
            templateUrl: 'app/components/mfa/passcode.html',
            controller: 'PasscodeController as vm'
          }
        }
      })
      .state('forgot', {
        url: '/user/forgot/',
        views: {
          'content': {
            templateUrl: 'app/components/user/forgot/forgot.html',
            controller: 'ForgotController as vm'
          }
        }
      })
      .state('reset', {
        url: '/user/reset?token',
        views: {
          'content': {
            templateUrl: 'app/components/user/forgot/reset.html',
            controller: 'ResetController as vm'
          }
        }
      })
      .state('select-customer', {
        url: '/admin/select-customer/',
        views: {
          'content': {
            templateUrl: 'app/components/admin/select-customer.html',
            controller: 'SelectCustomerController as vm'
          }
        }
      })
      .state('admin-profile', {
        url: '/admin/profile/',
        views: {
          'content': {
            templateUrl: 'app/components/admin/admin-profile.html',
            controller: 'AdminProfileController as vm'
          }
        }
      })
      .state('manage-admin', {
        url: '/manage-admin/',
        views: {
          'content': {
            templateUrl: 'app/components/admin/manage-admin.html',
            controller: 'ManageAdminController as vm'
          }
        }
      })
      .state('logout', {
        url: '/logout/',
        views: {
          'content': {
            templateUrl: 'app/components/user/logout.html',
            controller: 'LogoutController as vm'
          }
        }
      })
      .state('404', {
        url: '/not-found/',
        views: {
          'content': {
            templateUrl: 'app/components/404/404.html'
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
          .module('app')
          .config(configBlock)
          .run(runBlock)
          .controller('MainController', MainController)
          .controller('OnLeaveModalController', OnLeaveModalController);

  MainController.$inject = ['$rootScope', 'userFactory', 'billingFactory', '$http'];
  OnLeaveModalController.$inject = ['$uibModalInstance', 'options'];

  function configBlock($httpProvider, $locationProvider, IdleProvider) {
    $locationProvider.html5Mode(true);
    IdleProvider.idle(15 * 60); // waits 15 minutes before telling user they are going to be logged out
    IdleProvider.timeout(60); // waits 1 minute after logout notification before logging the user out
    $httpProvider.interceptors.push('authInterceptor');
  }

  /** @ngInject */
  function runBlock($rootScope, $state, $document, $uibModal) {
    //$rootScope.$on('$stateChangeError', function () {
    //  // Redirect user to error page
    //  $state.go('forbidden');
    //});

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      $document[0].body.scrollTop = 0;
    });

    //define gateway function which is called whenever leaving the website
    $rootScope.openExternalUrl = function (url) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/home/onleave_modal.html',
        controller: 'OnLeaveModalController as vm',
        resolve: {
          options: function () {
            return {
              url: url
            };
          }
        }
      });
    };
  }

  function OnLeaveModalController($uibModalInstance, options) {
    var vm = this;

    vm.options = options;
    vm.close = function () {
      $uibModalInstance.close();
    };
  }

  function MainController($rootScope, userFactory, billingFactory, $http) {

    var vm = this;

    vm.customer = userFactory.getCustomer();
    vm.joinableAMA = false;

    function setCustomerInfo() {
      if (userFactory.loggedIn() !== 'logged-in') {
        vm.joinableAMA = false;
        return;
      }
      if (!vm.customer) {
        vm.joinableAMA = false;
        loadCustomerInfo();
        return;
      }
      var membershipCode = '';
      vm.customer.certificates.filter(function (item) {
        if (item.membershipCode) {
          membershipCode = item.membershipCode;
        }
      });
      vm.isAdmin = userFactory.isAdmin();
      vm.joinableAMA = membershipCode === 'Non-Member';
    }

    function loadCustomerInfo() {
      if (userFactory.getId() !== -1) {
        billingFactory.findCustomer()
                .success(function (customer) {
                  vm.customer = customer;
                  userFactory.setCustomer(vm.customer);
                  setCustomerInfo();
                });
      }
    }

    vm.joinAMA = function () {
      if (!vm.isAdmin) {
        $rootScope.openExternalUrl('https://commerce.ama-assn.org/membership/');
      }
    };

    vm.isLoggedIn = function () {
      return userFactory.loggedIn() === 'logged-in';
    };

    $rootScope.$on('user-logged-in', function () {
      setCustomerInfo();
    });
    $rootScope.$on('admin.selectedCustomer', function (e, customerInfo) {
      vm.customer = customerInfo;
      setCustomerInfo();
    });

    setCustomerInfo();
  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/ga.html","<script async=\"\" src=\"https://www.googletagmanager.com/gtag/js?id=UA-5261862-10\"></script><script>\n  window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n  gtag(\'js\', new Date());\n\n  gtag(\'config\', \'UA-5261862-10\');\n</script>");
$templateCache.put("app/components/404/404.html","<div class=\"not-found-content\"><div class=\"row\"><div class=\"col-md-12\"><h2>404 - Page Not Found</h2><p>We are sorry the page you requested is temporarily unavailable.</p><p>For immediate assistance, please contact our Customer Care Center at 1-888-627-5883, Monday – Friday from 8am to 5 pm CT.</p></div></div></div>");
$templateCache.put("app/components/activation/activate.html","<div class=\"main-content\"><div class=\"activation-content\"><div ng-show=\"vm.activating\"><h2>Your account is being activated</h2></div><div ng-show=\"vm.errorMsg\" class=\"ng-hide\"><h2 class=\"text-danger\">{{vm.errorMsg}}</h2></div><div ng-show=\"vm.isSuccess\" class=\"ng-hide\"><h2 class=\"text-success\">Your account is now active. <a ui-sref=\"login\">Log in here.</a></h2></div></div></div>");
$templateCache.put("app/components/admin/admin-profile.html","<div class=\"main-content\"><div class=\"admin-content admin-profile\"><form name=\"adminPasswordForm\" ng-submit=\"vm.save()\"><h3>Change Password</h3><div class=\"form-group\" ng-class=\"{\'has-error\': adminPasswordForm.password.$dirty && adminPasswordForm.password.$invalid}\"><label for=\"password\">New Password</label> <input type=\"password\" class=\"form-control\" ng-model=\"vm.password\" id=\"password\" name=\"password\" required=\"\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': adminPasswordForm.confirmPassword.$dirty && adminPasswordForm.confirmPassword.$invalid}\"><label for=\"confirmPassword\">Confirm Password</label> <input type=\"password\" class=\"form-control\" ng-model=\"vm.confirmPassword\" id=\"confirmPassword\" name=\"confirmPassword\" required=\"\"></div><div class=\"form-group\"><button class=\"btn btn-custom\" type=\"submit\" ng-disabled=\"vm.isSaving || adminPasswordForm.$invalid || vm.password !== vm.confirmPassword\">{{vm.isSaving ? \'Saving...\' : \'Save\'}}</button></div><div class=\"alert alert-danger\" ng-show=\"vm.password && vm.confirmPassword && vm.password !== vm.confirmPassword\">Password does not match</div><div class=\"alert alert-success\" ng-show=\"!adminPasswordForm.$dirty && vm.isSuccess\">Password has been changed successfully!</div></form></div></div>");
$templateCache.put("app/components/admin/admin-select.html","<div class=\"main-content\"><div><h1>Super-User Control Panel</h1></div><div>Search for user by...</div><div>Dropdown select list with options</div><div>{{ vm.test }}</div></div>");
$templateCache.put("app/components/admin/manage-admin.html","<div class=\"main-content\"><div class=\"admin-content manage-admin\"><div class=\"admin-header\"><h1>Manage Administrators</h1></div><div class=\"table-responsive\"><table class=\"table table-striped\" align=\"center\"><thead><tr><th>&numero;</th><th>Email</th><th></th></tr></thead><tbody><tr ng-repeat=\"admin in vm.admins\"><td>{{$index+1}}</td><td>{{admin.username}}</td><td><button class=\"btn btn-sm btn-info\" ng-click=\"vm.openPwdModal(admin)\">Password</button> <button class=\"btn btn-sm btn-danger\" ng-click=\"vm.deleteAdmin(admin)\" ng-disabled=\"admin.isDeleting\">Delete</button></td></tr></tbody></table><button class=\"btn btn-primary\" ng-click=\"vm.openAdminModal()\">Add new administrator</button></div></div></div><script type=\"text/ng-template\" id=\"admin_modal.html\"><div class=\"manage-admin-modal\"> <div class=\"modal-header\"> <h1 class=\"modal-title\">New Administrator</h1> </div> <form name=\"adminForm\" ng-submit=\"save()\"> <div class=\"modal-body\"> <!--<div class=\"form-group\" ng-class=\"{\'has-error\': adminForm.firstName.$dirty && adminForm.firstName.$invalid}\"> <label for=\"firstName\">First Name</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.firstName\" id=\"firstName\" name=\"firstName\" required> </div> <div class=\"form-group\" ng-class=\"{\'has-error\': adminForm.lastName.$dirty && adminForm.lastName.$invalid}\"> <label for=\"lastName\">Last Name</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.lastName\" id=\"lastName\" name=\"lastName\" required> </div>--> <div class=\"form-group\" ng-class=\"{\'has-error\': adminForm.emailAddress.$dirty && adminForm.emailAddress.$invalid}\"> <label for=\"emailAddress\">Email address</label> <input type=\"email\" class=\"form-control\" ng-model=\"data.email\" id=\"emailAddress\" name=\"emailAddress\" required> </div> <div class=\"alert alert-danger\" ng-show=\"isDuplicatedEmail\"> This email address has already been used </div> <div class=\"form-group\" ng-class=\"{\'has-error\': adminForm.password.$dirty && adminForm.password.$invalid}\"> <label for=\"password\">Password</label> <input type=\"password\" class=\"form-control\" ng-model=\"data.password\" id=\"password\" name=\"password\" required> </div> <div class=\"form-group\" ng-class=\"{\'has-error\': adminForm.confirmPassword.$dirty && adminForm.confirmPassword.$invalid}\"> <label for=\"confirmPassword\">Confirm Password</label> <input type=\"password\" class=\"form-control\" ng-model=\"data.confirmPassword\" id=\"confirmPassword\" name=\"confirmPassword\" required> </div> <div class=\"alert alert-danger\" ng-show=\"data.password && data.confirmPassword && data.password!==data.confirmPassword\" style=\"margin-bottom: 0px;\"> Password does not match </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button> <button class=\"btn btn-custom\" type=\"submit\" ng-disabled=\"isSaving || adminForm.$invalid || isDuplicatedEmail\">{{isSaving ? \'Saving...\' : \'Save\'}}</button> </div> </form> </div></script><script type=\"text/ng-template\" id=\"admin_password_modal.html\"><div class=\"manage-admin-modal\"> <div class=\"modal-header\"> <h1 class=\"modal-title\">Update Admin Password</h1> </div> <form name=\"adminPasswordForm\" ng-submit=\"save()\"> <div class=\"modal-body\"> <div class=\"form-group\" ng-class=\"{\'has-error\': adminPasswordForm.password.$dirty && adminPasswordForm.password.$invalid}\"> <label for=\"password\">Password</label> <input type=\"password\" class=\"form-control\" ng-model=\"data.password\" id=\"password\" name=\"password\" required> </div> <div class=\"form-group\" ng-class=\"{\'has-error\': adminPasswordForm.confirmPassword.$dirty && adminPasswordForm.confirmPassword.$invalid}\"> <label for=\"confirmPassword\">Confirm Password</label> <input type=\"password\" class=\"form-control\" ng-model=\"data.confirmPassword\" id=\"confirmPassword\" name=\"confirmPassword\" required> </div> <div class=\"alert alert-danger\" ng-show=\"data.password && data.confirmPassword && data.password!==data.confirmPassword\" style=\"margin-bottom: 0px;\"> Password does not match </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancel</button> <button class=\"btn btn-custom\" type=\"submit\" ng-disabled=\"isSaving || adminPasswordForm.$invalid || data.password!==data.confirmPassword\">{{isSaving ? \'Saving...\' : \'Save\'}}</button> </div> </form> </div></script>");
$templateCache.put("app/components/admin/select-customer.html","<div class=\"main-content\"><div class=\"admin-content select-customer\"><div class=\"admin-header\"><h1>Select Customer</h1></div><form class=\"form-inline\" name=\"form\" ng-submit=\"vm.selectCustomer()\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.masterId\" name=\"masterId\" placeholder=\"Enter customer\'s master ID\" required=\"\"></div><button type=\"submit\" class=\"btn btn-default btn-primary\" ng-disabled=\"form.$invalid || vm.checking\">Submit</button></form></div></div>");
$templateCache.put("app/components/billing/billing.html","<div class=\"main-content container-fluid\"><div class=\"billing-content container-fluid\"><div class=\"loading-text\" ng-show=\"!vm.billsLoaded\">Loading page...<br><br><div class=\"loader\"></div></div><div class=\"loading-text\" ng-show=\"vm.billsLoaded && vm.billingSummaryData.length == 0\"><h3>No billing records were found.</h3><br><br></div><uib-tabset justified=\"true\" ng-show=\"vm.billingSummaryData.length != 0\"><uib-tab heading=\"Billing Summary\"><div class=\"billing-tab table-responsive\"><table class=\"table billing-table table-striped\"><colgroup><col width=\"8%\"><col width=\"auto\"><col width=\"20%\"><col width=\"15%\"><col width=\"13%\"></colgroup><thead><tr class=\"billing-header\"><th></th><th></th><th>Coverage Period</th><th>Amount Due</th><th>Payment Status</th><th></th></tr></thead><tr class=\"summary-row\" ng-repeat=\"bill in vm.billingSummaryData| recentBillFilter\"><td><img ng-src=\"{{vm.getCoverageIcon(bill)}}\"></td><td><ul><li>{{ bill.title}}</li><li>Certificate/ Record #: {{ bill.recordNumber}}</li></ul></td><td><ul><li><strong>From:</strong> {{ bill.fromDate| formatDate}}</li><li><strong>To:</strong> {{ bill.toDate| formatDate}}</li></ul></td><td><ul><li>{{ bill.amountDue | currency}}</li></ul></td><td><div ng-if=\"bill.amountDue\"><form method=\"post\" id=\"paymentForm\" action=\"https://amainsure.com/support/pay-online/\" target=\"_blank\"><button class=\"btn btn-custom\" type=\"submit\" ng-show=\"!vm.checkPayInProgress(bill)\" ng-if=\"bill.status === \'Open\' || !bill.status\" ng-disabled=\"vm.isAdmin\">Pay Now</button> <span ng-show=\"vm.checkPayInProgress(bill)\" ng-if=\"bill.status === \'Open\' || !bill.status\">Payment in Progress</span> <span ng-if=\"bill.status === \'E\'\">EFT Payment Scheduled</span> <span ng-if=\"bill.status === \'W\'\">Payment Waived</span> <span ng-if=\"bill.status === \'P\'\" class=\"text-success\">Paid</span> <span ng-if=\"bill.status === \'L\'\" class=\"text-danger\">Coverage Lapsed/Never Activated</span></form></div><div ng-if=\"!bill.amountDue\">No payment due at this time</div></td></tr><tr class=\"nocost-items-title\" ng-show=\"vm.noCostCoverages.length > 0\"><td colspan=\"5\">Coverage provided at no cost</td></tr><tr class=\"summary-row\" ng-repeat=\"coverage in vm.noCostCoverages\"><td><img ng-src=\"{{vm.getCoverageIcon(coverage)}}\"></td><td><ul><li>{{ coverage.planName}}</li><li>Certificate/ Record #: {{ coverage.certificateNumber}}</li></ul></td><td><ul><li><strong>From:</strong> {{ coverage.originalEffectiveDate| formatDate}}</li><li><strong>To:</strong> {{ coverage.coveragePaidToDate| formatDate}}</li></ul></td><td></td><td></td></tr></table></div></uib-tab><uib-tab heading=\"Payment Options\" active=\"vm.isPaymentOptionsTabActive\"><div class=\"billing-tab table-responsive\"><table class=\"billing-table table table-striped\"><colgroup><col width=\"35%\"><col width=\"20%\"><col width=\"45%\"></colgroup><thead><tr class=\"billing-header\"><th>Coverage</th><th>Payment Frequency</th><th>Bank Information</th></tr></thead><tr class=\"options-row\" ng-repeat=\"bill in vm.paymentOptionsData\"><td><ul><li>{{ bill.title}}</li></ul></td><td><div><ul><li>{{ bill.frequency}}</li></ul></div></td><td><div class=\"col-xs-6\"><ul><li ng-show=\"bill.bankName !== \'Not Applicable\' && bill.routingNumber\">{{ bill.routingNumber}}</li><li ng-show=\"bill.bankName !== \'Not Applicable\' && bill.bankNumber\">{{ bill.bankNumber.slice(-4)}}</li></ul></div><div class=\"col-xs-6 text-left\"></div></td></tr></table></div></uib-tab></uib-tabset></div><div class=\"contact-sidebar clearfix\"><h2>Contact Us</h2><ul class=\"contact-main\"><li class=\"h3\">Phone</li><li>1-888-627-5883</li><li class=\"h3\">Fax</li><li>1-877-588-7488</li><li class=\"h3\">Email</li><li>wecare@amainsure.com</li></ul><ul><li class=\"h4\">Customer Care Hours</li><li>8 am - 5 pm CT, Monday - Friday</li><li class=\"h4\">Mailing Address</li><li>AMA Insurance Agency, Inc.<br>330 N. Wabash Ave. &#8226 Suite 39300<br>Chicago, IL 60611-5885</li></ul><ul><li class=\"h4\">Send Claims To</li><li>AMA Insurance Agency, Inc.<br>PO Box 804238<br>Chicago, IL 60680 - 4104</li></ul><ul><li class=\"h4\">Send Payments To</li><li>AMA Insurance Agency, Inc.<br>PO Box 8646<br>Carol Stream, IL 60197 - 8646</li></ul><h2>Quick links</h2><ul><li ng-if=\"main.joinableAMA\"><a href=\"\" ng-click=\"main.joinAMA()\" ng-disabled=\"main.isAdmin\" class=\"btn btn-custom btn-orange btn-join-ama\">Join AMA</a></li><li><a ui-sref=\"faq\" class=\"btn-primary btn btn-custom\">Frequently Asked Questions</a></li></ul></div></div><script type=\"text/ng-template\" id=\"bankModal.html\"><div class=\"modal-header\"> <h1 class=\"modal-title\">Edit Bank Information</h1> </div> <div class=\"modal-body\"> <div class=\"address-modal\"> <div class=\"clearfix\"> <div class=\"current-address-box\"> <div class=\"col-xs-12\"> <p class=\"bold\">Current Information:<br /> <span class=\"text-muted text-address\"> <!--<span>{{ vm.currentBankName }}</span>--> <span>{{ vm.currentRoutingNumber }}</span> <span>{{ vm.currentAccountNumber }}</span> <span>{{ vm.currentAccountTyp }}</span> </span> </p> </div> </div> </div> <div> <form class=\"personal-form address-change-form clearfix\"> <p class=\"bold col-xs-12\">Update Information: </p> <hr> <!-- <label>Bank Name: </label> <div> <input type=\"text\" name=\"accountName\" value=\"\" placeholder=\"Bank Name\" ng-model=\"vm.bankInfo.bankName\" ng-blur=\"vm.checkValidation(\'accountName\')\"> <div class=\"validation-error\" ng-show=\"vm.accountNameInvalid\"> <p>{{ vm.accountNameInvalid }}</p> </div> </div> --> <label>Routing Number: </label> <div> <input type=\"text\" name=\"routingNumber\" value=\"\" maxlength=\"9\" placeholder=\"Routing Number\" ng-model=\"vm.bankInfo.routingNumber\" ng-blur=\"vm.checkValidation(\'routingNumber\')\"> <div class=\"validation-error\" ng-show=\"vm.routingNumberInvalid\"> <p>{{ vm.routingNumberInvalid }}</p> </div> </div> <label>Account Number: </label> <div> <input type=\"text\" name=\"accountNumber\" value=\"\" placeholder=\"Account Number\" ng-model=\"vm.bankInfo.accountNumber\" ng-blur=\"vm.checkValidation(\'accountNumber\')\"> <div class=\"validation-error\" ng-show=\"vm.accountNumberInvalid\"> <p>{{ vm.accountNumberInvalid }}</p> </div> </div> <label>Account Type: </label> <div> <select class=\"visible-inline-xs form-control\" class=\"form-control\" name=\"accountType\" ng-model=\"vm.bankInfo.accountType\"> <option value=\"C\">Checking</option> <option value=\"S\">Savings</option> </select> </div> </form> <!--<div class=\"validation-error\" ng-show=\"vm.addressInvalid\"> <p>{{ vm.addressInvalid }}</p> </div>--> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-mousedown=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-custom\" type=\"button\" ng-click=\"vm.update()\">Update</button> </div></script>");
$templateCache.put("app/components/billing/document_image_buttons.html","<div class=\"document-image-buttons-wrap\"><div class=\"list-title plan-name\" ng-if=\"listTitle\">Coverage Documents</div><div><a href=\"https://amainsure.hylandcloud.com/203AppNet/docpop/docpop.aspx?KT114_0_0_0=01&KT116_0_0_0={{data.certificateNumber}}&clienttype=html&cqid=116\" target=\"_blank\">View Documents</a></div></div>");
$templateCache.put("app/components/billing/document_images_modal.html","<div class=\"document-images-modal\"><div class=\"modal-body\"><iframe ng-src=\"{{vm.image.fileUrl}}\" frameborder=\"0\"></iframe></div><div class=\"modal-footer\"><button class=\"btn btn-default pull-right\" type=\"button\" ng-click=\"vm.cancel()\">Close</button></div></div>");
$templateCache.put("app/components/billing/image-redirect.html","<div class=\"notification-modal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Please note:</h4></div><div class=\"modal-body\">You will be redirected to a third-party portal to view the images.</div><div class=\"modal-footer\"><a ng-href=\"{{vm.imageAddress}}?KT114_0_0_0=01&KT116_0_0_0={{vm.certificateNumber}}&clienttype=html&cqid=116\" target=\"_blank\" ng-click=\"vm.cancel()\" class=\"btn btn-primary btn-lg\">Continue</a></div></div>");
$templateCache.put("app/components/billing/pay_modal.html","<div class=\"notification-modal\"><form ng-submit=\"vm.trackPay()\" method=\"post\" id=\"paymentForm\" action=\"{{vm.paymentUrl}}\" target=\"_blank\"><div class=\"modal-header\"><h1 class=\"modal-title\">Pay Now</h1></div><div class=\"modal-body\">We are taking you to the secure online payment system, maintained by First Horizon Bank. Once you’ve completed your transaction, you can return to myaccount.amainsure.com. <input type=\"hidden\" name=\"customerId\" value=\"{{vm.bill.recordNumber}}\"> <input type=\"hidden\" name=\"customerName\" value=\"{{vm.customer.firstName + \' \' + vm.customer.lastName}}\"> <input type=\"hidden\" name=\"amountOwed\" value=\"{{vm.bill.amountDue}}\"> <input type=\"hidden\" name=\"companyNumber\" value=\"1000000027\"></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-lg\" type=\"submit\">Continue to First Horizon</button></div></form></div>");
$templateCache.put("app/components/coc/code-of-conduct.html","<div class=\"main-content\"><div class=\"tos-content\"><h1>Code of Conduct</h1><p>By accessing and using this website you agree to the following Code of Conduct, which are incorporated into the Terms of Use. If you do not agree to the Code of Conduct, Terms of Use, and Privacy Policy, you must immediately terminate use of this site.</p><p>To help AMA Insurance Agency, Inc. (“AMA Insurance”) maintain dialogue that is relevant and respectful of the rights of others, you understand that when you submit comments, posts or images on this website, you will not:</p><ul><li>Spread false and/or defamatory information.</li><li>Include content that is discriminatory, abusive, vulgar, hateful, harassing, obscene, profane, sexually oriented, threatening, invasive of a person\'s privacy or right to publicity, or otherwise violative of any law.</li><li>Infringe on copyrights, trademarks or trade secrets.</li><li>Post content that includes private and/or personal information, such as home phone numbers and email addresses.</li><li>Seek medical advice (consult your personal physician) or disclose personal health information.</li><li>Promote commercial services and products, or causes.</li><li>Post in manner that would constitute spamming (e.g., posting with such frequency or repetitiveness that others may be discouraged from posting, posts that are irrelevant to the topic and/or AMA Insurance\'s mission, and \"follow me\" posts) or trolling (defined as comments that appear intended to send the discussion in a fruitless direction).</li></ul><p>Content that is posted in violation of this policy may be blocked, removed, or otherwise altered. Repeat violations of this Code of Conduct may cause the author to be blocked or prevented from posting content. By submitting content on this website, you grant to AMA Insurance a perpetual, non-exclusive, fully paid and royalty-free, transferable, sub-licensable, worldwide license to use, download, duplicate, display, distribute, modify and create derivative works of that content without your further approval or permission and without compensation by AMA Insurance.</p><p>As a courtesy, please do not send commercial messages directly to participants on this social media platform unless specifically invited to do so by such individual. Complaints about unsolicited commercial messages are taken very seriously.</p><h4>Disclaimer:</h4><p>AMA Insurance is not responsible for the opinions or claims of other users posted to this website and we do not typically confirm the accuracy of postings. User-generated content, such as comments or posts, represent the views of those providing the content, and do not necessarily represent the views or policy of AMA Insurance. References or links (provided by AMA Insurance or by a user) to products or services do not constitute endorsements by AMA Insurance.</p><p>This Code of Conduct may be amended or modified at any time.</p></div></div>");
$templateCache.put("app/components/claims/claim-details-modal.html","<div class=\"modal-header\"><h1 class=\"modal-titler\">Claim Details</h1></div><div class=\"modal-body\"><div class=\"details-modal\"><div><table class=\"table table-striped\"><tr><th>Provider Name</th><td align=\"right\">{{ vm.claim.providerName }}</td></tr><tr><th>Name of Patient</th><td align=\"right\">{{ vm.claim.patientName }}</td></tr><tr><th>Date of Service</th><td align=\"right\">{{ vm.claim.serviceDate | formatDate}}</td></tr><tr><th>Plan Short Name</th><td align=\"right\">{{ vm.coverage.planShortName }}</td></tr><tr><th>Description of Benefit</th><td align=\"right\">{{ vm.claim.claimType }}</td></tr><tr><th>Claim Charge Amount</th><td align=\"right\">{{ vm.claim.claimBillAmount | currency:undefined:2 }}</td></tr><tr><th>Claim Amount Paid</th><td align=\"right\">{{ vm.claim.claimAmountPaid | currency:undefined:2 }}</td></tr><tr><th>Deductible Amount</th><td align=\"right\">{{ vm.claim.deductibleAmount | currency:undefined:2 }}</td></tr><tr><th>Date Claim Processed</th><td align=\"right\">{{ vm.claim.processDate | formatDate }}</td></tr><tr><th>Status</th><td align=\"right\">{{ vm.claim.claimStatus }}</td></tr><tr><th>Claim Number</th><td align=\"right\">{{vm.claim.claimNumber}}</td></tr></table></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default pull-right\" type=\"button\" ng-mousedown=\"vm.cancel()\">Close</button></div>");
$templateCache.put("app/components/claims/claims.html","<div class=\"main-content\"><div class=\"claims-content\"><div class=\"loading-text\" ng-show=\"!vm.loadItemsComplete\"><br><br>Loading page...<br><br><br><br><div class=\"loader\"></div></div><div class=\"loading-text\" ng-show=\"(vm.claims.length === 0 || !vm.loadItemsComplete) && !vm.noPeople\"><br><br>Loading page...<br><br><br><br><div class=\"loader\"></div></div><div class=\"container-fluid\" ng-if=\"vm.noPeople\"><h3 class=\"text-center\" style=\"color:red;padding-top:25px\">No claims have been processed by AMA Insurance.</h3></div><div class=\"container-fluid\"><div class=\"table-selector\" ng-if=\"!vm.noPeople && (vm.providers.length > 0 || vm.patients.length > 0)\"><h1>Select Provider or Patient</h1><div class=\"clearfix\"><select class=\"form-control form-select\" ng-model=\"vm.personName\"><optgroup label=\"Providers\"><option value=\"provider_{{ provider[0] }}\" ng-repeat=\"provider in vm.providers\">{{ provider[1] }}</option></optgroup><optgroup label=\"Patients\"><option value=\"patient_{{ patient }}\" ng-repeat=\"patient in vm.patients\">{{ patient }}</option></optgroup></select></div></div><div class=\"table-responsive\" ng-show=\"vm.claims.length > 0\"><table class=\"table claims-table table-hover table-striped\"><colgroup><col class=\"col-name\"><col class=\"col-date\"><col class=\"col-plan\"><col class=\"col-desc\"><col class=\"col-amount\"></colgroup><thead><tr><th class=\"row-patient\" ng-if=\"vm.personType === \'provider\'\">Patient</th><th class=\"row-provider\" ng-if=\"vm.personType === \'patient\'\">Provider</th><th>Date</th><th>Plan</th><th>Description</th><th>Amount</th></tr></thead><tbody><tr open-claim-details=\"\" claim=\"claim\" coverage=\"vm.getCoverageByNumber(claim.certificateNumber)\" ng-repeat=\"claim in vm.claims\"><td ng-if=\"vm.personType===\'provider\'\">{{ claim.patientName }}</td><td ng-if=\"vm.personType===\'patient\'\">{{ claim.providerName }}</td><td>{{ claim.serviceDate | formatDate }}</td><td>{{ vm.getCoverageByNumber(claim.certificateNumber).planShortName }}</td><td>{{ claim.claimType }}</td><td class=\"amount h3\"><span class=\"label label-default\">{{ claim.claimBillAmount | currency:undefined:2 }}</span></td></tr></tbody></table></div><div class=\"text-center\" ng-show=\"vm.claims.length > 0\"><ul uib-pagination=\"\" total-items=\"vm.totalItems\" ng-model=\"vm.currentPageNum\" items-per-page=\"vm.pageRowsNum\" force-ellipses=\"true\" rotate=\"true\" max-size=\"10\" num-pages=\"vm.numDisplayPages\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" ng-change=\"vm.pageChanged()\" class=\"pagination-sm\" boundary-link-numbers=\"true\"></ul></div></div></div><div class=\"contact-sidebar clearfix\"><h2>Contact Us</h2><ul class=\"contact-main\"><li class=\"h3\">Phone</li><li>1-888-627-5883</li><li class=\"h3\">Fax</li><li>1-877-588-7488</li><li class=\"h3\">Email</li><li>wecare@amainsure.com</li></ul><ul><li class=\"h4\">Customer Care Hours</li><li>8 am - 5 pm CT, Monday - Friday</li><li class=\"h4\">Mailing Address</li><li>AMA Insurance Agency, Inc.<br>330 N. Wabash Ave. &#8226 Suite 39300<br>Chicago, IL 60611-5885</li></ul><ul><li class=\"h4\">Send Claims To</li><li>AMA Insurance Agency, Inc.<br>PO Box 804238<br>Chicago, IL 60680 - 4104</li></ul><ul><li class=\"h4\">Send Payments To</li><li>AMA Insurance Agency, Inc.<br>PO Box 8646<br>Carol Stream, IL 60197 - 8646</li></ul><h2>Quick links</h2><ul><li ng-if=\"main.joinableAMA\"><a href=\"\" ng-click=\"main.joinAMA()\" ng-disabled=\"main.isAdmin\" class=\"btn btn-custom btn-orange btn-join-ama\">Join AMA</a></li><li><a ui-sref=\"faq\" class=\"btn-primary btn btn-custom\">Frequently Asked Questions</a></li></ul></div></div>");
$templateCache.put("app/components/contact-us/form.html","<div class=\"main-content\"><div class=\"contact-form-wrapper\"><div class=\"alert alert-success text-center\" ng-show=\"vm.isSuccess\"><i class=\"fa fa-check\"></i> Contact request has been sent successfully!</div><form class=\"form-horizontal contact-form\" name=\"contactForm\" ng-show=\"!vm.isSuccess\"><div class=\"tip-text\">At AMA Insurance, we take pride in providing outstanding service to each and every customer we serve. Whenever you have a question or comment, let us know - we\'re here to help.</div><div class=\"alert alert-warning\"><i class=\"fa fa-exclamation-triangle\"></i> Although this site is secure, email is not a secure method of communication. Do not disclose any confidential information here.</div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"sel_coverage\"><span class=\"asterisk\">*</span> Regarding:</label><div class=\"col-md-9\"><select ng-model=\"vm.coverage\" id=\"sel_coverage\" class=\"form-control\" name=\"coverage\" required=\"\"><option ng-if=\"vm.coverages.length > 1\" value=\"\">Select a coverage</option><option ng-repeat=\"cov in vm.coverages\" value=\"{{cov.certificateNumber}}\">{{cov.planName}} {{cov.certificateNumber}}</option></select></div></div><div style=\"border-bottom:1px solid lightgray; padding-bottom:5px\"><div class=\"form-group\"><label class=\"col-md-3 control-label\"><span class=\"asterisk\">*</span> Subject:</label><div class=\"col-md-7\"><div class=\"checkbox\" ng-repeat=\"subject in vm.subjects\"><label><input type=\"checkbox\" value=\"{{subject}}\" name=\"subject\" ng-model=\"vm.subject[$index]\" ng-false-value=\"\" ng-true-value=\"true\"> {{subject}}</label></div></div></div><div class=\"form-group\" ng-if=\"vm.subject === \'Other\'\"><label class=\"col-md-3 control-label\"><span class=\"asterisk\">*</span> Comments:</label><div class=\"col-md-7\"><textarea class=\"form-control\" ng-model=\"vm.comments\" name=\"comments\" required=\"\"></textarea></div></div></div><div class=\"form-group bottom-area\"><label class=\"col-md-4 control-label\"><span class=\"asterisk\">*</span> Please contact me by:</label><div class=\"col-md-7\"><label><input type=\"radio\" ng-model=\"vm.contactType\" name=\"contactType\" ng-click=\"contactForm.contactInfo.$setValidity(\'email problem\', vm.checkValidation(\'email\'))\" value=\"email\">email</label> <label><input type=\"radio\" ng-model=\"vm.contactType\" name=\"contactType\" ng-click=\"contactForm.contactInfo.$setValidity(\'phone problem\', vm.checkValidation(\'phone\'))\" value=\"phone\">phone</label> &nbsp;<span ng-switch=\"vm.contactType\" style=\"transition: none\"><input style=\"transition:none\" ng-switch-when=\"email\" type=\"text\" ng-model=\"vm.contactInfo\" name=\"contactInfo\" class=\"form-control inline\" ng-blur=\"contactForm.contactInfo.$setValidity(\'email problem\', vm.checkValidation(\'email\'))\"> <input style=\"transition:none\" ng-switch-when=\"phone\" type=\"text\" ng-model=\"vm.contactInfo\" name=\"contactInfo\" class=\"form-control inline\" ng-blur=\"contactForm.contactInfo.$setValidity(\'phone problem\', vm.checkValidation(\'phone\'))\" ui-mask=\"(999) 999-9999\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"x\" required=\"\"></span></div><div ng-if=\"vm.emailInvalid && vm.contactType === \'email\'\" class=\"col-md-offset-4 col-md-8 validation-error\"><p>{{ vm.emailInvalid }}</p></div><div ng-if=\"vm.phoneInvalid && vm.contactType === \'phone\'\" class=\"col-md-offset-4 col-md-8 validation-error\"><p>{{ vm.phoneInvalid }}</p></div></div><div ng-if=\"vm.contactType === \'phone\'\" class=\"form-group times-wrapper\"><label class=\"col-md-4 control-label\">Best Time to Call:</label><div class=\"col-md-6\"><input type=\"text\" ng-model=\"vm.callTimeStart\" name=\"callTimeStart\" class=\"form-control inline\"> to <input type=\"text\" ng-model=\"vm.callTimeEnd\" name=\"callTimeEnd\" class=\"form-control inline\"></div></div><div class=\"form-group\"><div class=\"alert alert-info\" ng-show=\"vm.contactInfo && ((vm.contactType === \'email\' && vm.userEmail !== vm.contactInfo) || (vm.contactType === \'phone\' && vm.userPhoneNumber !== vm.contactInfo))\">This change will be used for us to communicate with you regarding this request. If you want to change your phone number/email address permanently, please update your Profile.</div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><button class=\"btn btn-primary btn-lg\" ng-click=\"vm.submit()\" ng-disabled=\"contactForm.$invalid || vm.isSaving || vm.isEmptyObject(vm.subject)\">Submit</button></div></div></form></div><div class=\"contact-sidebar clearfix\"><h2>Contact Us</h2><ul class=\"contact-main\"><li class=\"h3\">Phone</li><li>1-888-627-5883</li><li class=\"h3\">Fax</li><li>1-877-588-7488</li><li class=\"h3\">Email</li><li>wecare@amainsure.com</li></ul><ul><li class=\"h4\">Customer Care Hours</li><li>8 am - 5 pm CT, Monday - Friday</li><li class=\"h4\">Mailing Address</li><li>AMA Insurance Agency, Inc.<br>330 N. Wabash Ave. &#8226 Suite 39300<br>Chicago, IL 60611-5885</li></ul><ul><li class=\"h4\">Send Claims To</li><li>AMA Insurance Agency, Inc.<br>PO Box 804238<br>Chicago, IL 60680 - 4104</li></ul><ul><li class=\"h4\">Send Payments To</li><li>AMA Insurance Agency, Inc.<br>PO Box 8646<br>Carol Stream, IL 60197 - 8646</li></ul></div></div>");
$templateCache.put("app/components/faq/list.html","<div class=\"main-content\"><div class=\"faq-content\"><uib-tabset><uib-tab heading=\"{{category}}\" ng-repeat=\"(category, data) in vm.faqData\"><uib-accordion close-others=\"false\"><uib-accordion-group is-open=\"dataItem.opened\" ng-repeat=\"dataItem in data\"><uib-accordion-heading>{{$index+1}}. {{dataItem.q}}</uib-accordion-heading><div ng-bind-html=\"dataItem.a\"></div></uib-accordion-group></uib-accordion></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/components/home/billing_alert_modal.html","<div class=\"billing-alert-modal\"><div class=\"modal-header\"><h1 class=\"modal-title\">Special Billing Alert</h1></div><div class=\"modal-body\" style=\"padding: 20px;\"><div class=\"alert-item\" ng-repeat=\"entry in vm.entries\"><div class=\"row\"><div class=\"col-md-6\"><strong>{{entry.planName}}</strong></div><div class=\"col-md-6\">Certificate/ Record #: {{entry.certificateNumber}}</div></div><div class=\"row\"><div class=\"col-md-12\"><p ng-bind-html=\"entry.alertMessage\"></p></div></div></div></div><div class=\"modal-footer\"><button ng-click=\"vm.close()\" class=\"btn btn-primary btn-lg\">Close</button></div></div>");
$templateCache.put("app/components/home/discount.html","<div class=\"main-content container-fluid\"><div class=\"discount-content\"><div class=\"col-xs-12\"><h2>Discounts to help meet your Professional and Personal Needs</h2><p class=\"expl\">The AMA Preferred Provider Offers and Services Program is designed to provide you the savings you may need at every step of the journey from medical school to becoming a practicing physician. This Program is made available through the American Medical Association.</p><div class=\"services-list row\"><div class=\"service-item\" ng-repeat=\"service in vm.services\"><div class=\"inner\"><div class=\"img-wrap\"><img ng-src=\"assets/images/{{service.icon}}\"></div><div class=\"info\"><a class=\"title\" href=\"\" ng-click=\"vm.openServiceUrl(service.url)\" ng-disabled=\"vm.isAdmin\">{{service.title}}</a><div class=\"description\">{{service.description}}</div></div></div></div></div><p class=\"contact-wrap\">Question? <a href=\"mailto:MVP@ama-assn.org\" ng-disabled=\"vm.isAdmin\">Contact AMA preferred providers offers and services program</a></p></div></div></div>");
$templateCache.put("app/components/home/home.html","<div class=\"main-content container-fluid\"><div class=\"home-content\"><div class=\"col-xs-12\"><h2 class=\"customer-name\">{{ vm.customerFullName}} <a class=\"icon-billing-alert\" ng-click=\"vm.showBillingAlerts()\" ng-if=\"vm.alertCoverages.length > 0\"><i class=\"fa fa-exclamation-triangle\"></i> Special Billing Alert</a></h2></div><div class=\"loading-text\" ng-show=\"vm.alertCoverages == null || !vm.customerFullName\">Loading page...<br><br><div class=\"loader\"></div></div><div class=\"status-container\" ng-repeat=\"(status, section) in vm.coverageSections\"><h1 class=\"status-header\">{{ status}}</h1><div class=\"certificate-box\" ng-repeat=\"entry in section\"><div class=\"certificate-header clearfix\"><div class=\"certificate-icon\"><img ng-src=\"{{vm.getCoverageIcon(entry)}}\"></div><div class=\"certificate-title\"><h2>{{ entry.planName}}</h2></div></div><div class=\"certificate-details\"><ul><li>Certificate/ Record #: <span>{{ entry.certificateNumber}}</span></li><li ng-if=\"entry.bills.length > 0\">Coverage Period: <span>{{entry.bills[0].coverageFromDate| formatDate}} to {{entry.bills[0].coverageToDate| formatDate}}</span></li><li>{{ entry.paymentMode}} Premium: <span>{{ entry.premiumAmount | currency }}</span></li><li ng-show=\"entry.status === \'Pending\' || status === \'Inactive\'\">Coverage Status: <span>{{ entry.coverageStatus}}</span></li></ul></div><div class=\"certificate-dropdown\"><div class=\"btn-group\" uib-dropdown=\"\"><button id=\"single-button\" type=\"button\" class=\"btn btn-primary btn-lg btn-custom\" uib-dropdown-toggle=\"\">I would like to... <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" ng-repeat=\"option in vm.buttonOptions\"><a href=\"\" ng-click=\"vm.dropdownAction($index, entry)\">{{ option}}</a></li><li role=\"menuitem\" ng-if=\"entry.cob === \'Y\'\"><a href=\"https://amai-wordpress-s3uploads.s3.us-east-2.amazonaws.com/uploads/2021/10/GMAD-Beneficiary-Form-9.21.pdf\" target=\"_blank\" ng-if=\"entry.cob === \'Y\'\">Change my Beneficiary</a></li><li role=\"menuitem\" ng-if=\"entry.settlementDay === \'0\' && !entry.bankAccount.bankName && !entry.bankAccount.accountNumber && entry.bankAccount.routingNumber === \'0\' && !entry.bankAccount.accountType\" popover-placement=\"top\" popover-trigger=\"\'mouseenter\'\" popover-class=\"dark\" uib-popover=\"Electronic Funds Transfer (EFT) allows payments to be made monthly through automatic withdrawal from your checking account.\" popover-append-to-body=\"true\"><a href=\"https://www.amainsure.com/assets/eft_03162015.pdf\" target=\"_blank\">Change Automatic Payments</a></li><li role=\"menuitem\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-class=\"dark\" uib-popover=\"A Secondary Addressee is a person who you designate to receive a copy of a second bill or lapse notice in order to prevent the unintentional lapse of your insurance coverage.\" popover-append-to-body=\"true\"><a href=\"https://amai-amai-wordpress-master-s3uploads.s3.amazonaws.com/uploads/2020/08/Third-Party-Designee-Form.pdf\" target=\"_blank\">Add or Change Secondary Addressee</a></li><li role=\"menuitem\" popover-placement=\"top\" popover-trigger=\"mouseenter\" popover-class=\"dark\" uib-popover=\"View documents\" popover-append-to-body=\"true\"><a href=\"https://amainsure.hylandcloud.com/203AppNet/docpop/docpop.aspx?KT114_0_0_0=01&KT116_0_0_0={{ entry.certificateNumber}}&clienttype=html&cqid=115\" target=\"_blank\">View Documents</a></li></ul></div></div></div></div></div><div class=\"contact-sidebar clearfix\"><h2>Contact Us</h2><ul class=\"contact-main\"><li class=\"h3\">Phone</li><li>1-888-627-5883</li><li class=\"h3\">Fax</li><li>1-877-588-7488</li><li class=\"h3\">Email</li><li>wecare@amainsure.com</li></ul><ul><li class=\"h4\">Customer Care Hours</li><li>8 am - 5 pm CT, Monday - Friday</li><li class=\"h4\">Mailing Address</li><li>AMA Insurance Agency, Inc.<br>330 N. Wabash Ave. &#8226 Suite 39300<br>Chicago, IL 60611-5885</li></ul><ul><li class=\"h4\">Send Claims To</li><li>AMA Insurance Agency, Inc.<br>PO Box 804238<br>Chicago, IL 60680 - 4104</li></ul><ul><li class=\"h4\">Send Payments To</li><li>AMA Insurance Agency, Inc.<br>PO Box 8646<br>Carol Stream, IL 60197 - 8646</li></ul><h2>Quick links</h2><ul><li ng-if=\"main.joinableAMA\"><a href=\"\" ng-click=\"main.joinAMA()\" ng-disabled=\"main.isAdmin\" class=\"btn btn-custom btn-orange btn-join-ama\">Join AMA</a></li><li><a ui-sref=\"faq\" class=\"btn-primary btn btn-custom\">Frequently Asked Questions</a></li></ul></div></div>");
$templateCache.put("app/components/home/onleave_modal.html","<div class=\"onleave-modal\"><div class=\"modal-header\"><h1 class=\"modal-title\">Please note:</h1></div><div class=\"modal-body\"><p>By clicking \"continue\" below you will be taken away from the AMA Insurance Agency, Inc. website.</p><p>Do you wish to leave this site?</p></div><div class=\"modal-footer\"><a href=\"\" ng-click=\"vm.close()\">cancel</a> <a ng-href=\"{{vm.options.url}}\" target=\"_blank\" ng-click=\"vm.close()\" class=\"btn btn-primary btn-lg\">Continue &raquo;</a></div></div>");
$templateCache.put("app/components/footer/footer.html","<div class=\"footer\"><p class=\"footer-text\" ng-if=\"vm.currentState.includes(\'home\') || vm.currentState.includes(\'coverage\')\">Information contained on My Account includes only those plans that are administered by AMA Insurance. Certain plans, such as Home & Auto, are administered by the insurance company directly. If you need help with a plan or can’t find a plan you are looking for, use the Contact Us page to send us an email or call us for assistance at 1-888-627-5883 Monday – Friday from 8am to 5pm CT.</p><p class=\"footer-text\" ng-if=\"vm.currentState.includes(\'coverage\') || vm.currentState.includes(\'billing\')\">Only the last two years of images are available from this site. If you need something further, please contact Customer Service.</p><p class=\"footer-text\">Changes made on this website will not be reflected on all impacted systems for up to 2 business days.</p><ul><li><a class=\"nav-link\" ui-sref=\"contact\" ng-show=\"vm.isLoggedIn\">Contact Us</a></li><li><a class=\"nav-link\" ui-sref=\"faq\">FAQ</a></li><li><a class=\"nav-link\" href=\"https://www.amainsure.com/\" target=\"_blank\">AMAInsure.com</a></li><li><a class=\"nav-link\" ui-sref=\"tos\">Terms of Use</a></li><li><a class=\"nav-link\" ui-sref=\"coc\">Code of Conduct</a></li><li><a class=\"nav-link\" ui-sref=\"privacy\">Privacy Policy</a></li></ul><img class=\"footer-seal\" src=\"/assets/images/fpo-seal.png\"></div>");
$templateCache.put("app/components/coverage/_billing_info.html","<div class=\"row\"><div class=\"col-sm-7 plan-name\">{{data.planName}}<div ng-show=\"data.carrierName\">{{data.carrierName}}</div></div></div><div class=\"row\"><div class=\"col-md-6 info-details\"><ul><li><label>Certificate/Record:</label> {{data.certificateNumber}}</li><li><label>Billing Address:</label> {{data.billingAddress.addressLine1}}<br><div ng-show=\"data.billingAddress.addressLine2 != null\">{{data.billingAddress.addressLine2}}</div><div ng-show=\"data.billingAddress.addressLine3 != null\">{{data.billingAddress.addressLine3}}</div>{{data.billingAddress.city}}, {{data.billingAddress.state}} {{data.billingAddress.zipCode}}</li><li ng-if=\"data.designee.name\"><label><em uib-popover=\"A person designated to receive a copy of a second bill or lapse notice in order to prevent unintentional lapse of coverage\" popover-append-to-body=\"true\" popover-class=\"dark\" popover-placement=\"right\" popover-trigger=\"\'mouseenter\'\">Designee:</em></label> {{data.designee.name}}<br>{{data.designee.address.addressLine1}}<br><div ng-show=\"data.designee.address.addressLine2 != null\">{{data.designee.address.addressLine2}}</div><div ng-show=\"data.designee.address.addressLine3 != null\">{{data.designee.address.addressLine3}}</div>{{data.designee.address.city}}, {{data.designee.address.state}} {{data.designee.address.zipCode}}</li><li ng-if=\"data.payor.name\"><label>Payor:</label> {{data.payor.name}}<br>{{data.payor.address.addressLine1}}<br><div ng-show=\"data.payor.address.addressLine2 != null\">{{data.payor.address.addressLine2}}</div><div ng-show=\"data.payor.address.addressLine3 != null\">{{data.payor.address.addressLine3}}</div>{{data.payor.address.city}}, {{data.payor.address.state}} {{data.payor.address.zipCode}}</li></ul></div></div><div class=\"row\" ng-show=\"data.noCostFlag === \'N\'\"><div class=\"col-md-12\"><div class=\"clearfix\"></div><p ng-if=\"data.status === \'Pending\' && data.bills.length === 0\"><br>Coverage details will be displayed after the underwriter approves the application for insurance.</p><div class=\"table-responsive\" ng-if=\"!(data.status === \'Pending\' && data.bills.length === 0)\"><table class=\"table table-striped\"><col width=\"40%\"><col width=\"30%\"><col width=\"30%\"><tr><th>Coverage Period</th><th>Amount Due</th><th>Payment Status</th></tr><tr ng-repeat=\"bill in data.bills.content\"><td>{{bill.coverageFromDate| formatDate}} &nbsp;to&nbsp; {{bill.coverageToDate| formatDate}}</td><td>{{bill.amountDue| currency}}</td><td><div ng-if=\"bill.amountDue\"><button class=\"btn btn-sm btn-primary\" ng-if=\"bill.status === \'Open\' || !bill.status\" ng-click=\"payNow(bill)\" ng-show=\"!checkPayInProgress(bill)\" ng-disabled=\"isAdmin\">Pay Now</button> <span ng-show=\"checkPayInProgress(bill)\" ng-if=\"bill.status === \'Open\' || !bill.status\">Payment in Progress</span> <span ng-if=\"bill.status === \'E\'\">EFT Payment Scheduled</span> <span ng-if=\"bill.status === \'W\'\">Payment Waived</span> <span ng-if=\"bill.status === \'P\'\" class=\"text-success\">Paid</span> <span ng-if=\"bill.status === \'L\'\" class=\"text-danger\">Coverage Lapsed/Never Activated</span></div><div ng-if=\"!bill.amountDue\">No payment due at this time</div></td></tr><tr ng-show=\"data.bills.length === 0\"><td colspan=\"4\" class=\"text-center\">There is no information to be displayed</td></tr></table></div></div></div><script type=\"text/ng-template\" id=\"designee_detail.html\"><div> {{data.designee.name}}<br> {{data.designee.address.addressLine1}}.<br> {{data.designee.address.city}}, {{data.designee.address.state}} {{data.designee.address.zipCode}} </div></script><script type=\"text/ng-template\" id=\"payor_detail.html\"><div> {{data.payor.name}}<br> {{data.payor.address.addressLine1}}.<br> {{data.payor.address.city}}, {{data.payor.address.state}} {{data.payor.address.zipCode}} </div></script><script type=\"text/ng-template\" id=\"bank_detail.html\"><div class=\"coverage-bank-detail\"> <!--<p><label>Bank Name:</label> {{data.bankAccount.bankName}}</p>--> <p><label>Type:</label> {{data.bankAccount.accountType}}</p> <p><label>Number:</label> {{data.bankAccount.accountNumber}}</p> <p><label>Routing Number:</label> {{data.bankAccount.routingNumber}}</p> </div></script>");
$templateCache.put("app/components/coverage/_detail_accidental_death.html","<div class=\"row\"><div class=\"col-md-6 col-lg-5\"><label>{{data.benefitDescription}}:</label> {{data.benefitAmount | currency:undefined:2}}</div></div>");
$templateCache.put("app/components/coverage/_detail_catastrophic_major_medical.html","<div class=\"row\"><div class=\"col-md-6 col-lg-5\"><span ng-show=\"data.deductibleAmount > 0\">Deductible:</span> {{data.deductibleAmount | currency}}</div></div>");
$templateCache.put("app/components/coverage/_detail_dental.html","");
$templateCache.put("app/components/coverage/_detail_disability.html","<div class=\"row\"><div class=\"col-md-12\"><label>{{ data.benefitDescription }}:</label> {{ data.benefitAmount | currency:undefined:2 }}</div><div class=\"col-md-12\">{{ data.eliminationPeriod }} {{ data.elimPeriodDescription }} <span ng-show=\"data.eliminationPeriod > 0\">Elimination Period</span></div><div class=\"col-md-12 rider-label\" ng-if=\"data.riders.length > 0\"><label style=\"font-weight:700\">Riders</label></div><div class=\"col-md-12\" ng-repeat=\"rider in data.riders\"><label>{{ rider.name }} {{ rider.benefitDescription }}</label><span ng-show=\"rider.benefitAmount\">: {{ rider.benefitAmount | currency:undefined:2 }}</span></div></div>");
$templateCache.put("app/components/coverage/_detail_global_emergency.html","");
$templateCache.put("app/components/coverage/_detail_hospital.html","");
$templateCache.put("app/components/coverage/_detail_hospital_income.html","<div class=\"row\"><div class=\"col-md-6 col-lg-5\"><label>{{data.benefitDescription}}:</label> {{data.benefitAmount | currency:undefined:2}}</div></div>");
$templateCache.put("app/components/coverage/_detail_long_term_care.html","<div class=\"row\"><div class=\"col-md-12\"><label>{{data.benefitDescription}}:</label> {{data.benefitAmount | currency:undefined:2}}</div><div class=\"col-md-12\">{{data.eliminationPeriod}} {{data.elimPeriodDescription}} <span ng-show=\"data.eliminationPeriod > 0\">Elimination Period</span></div><div class=\"col-md-12 rider-label\" ng-if=\"data.riders.length > 0\"><label style=\"font-weight:700\">Riders</label></div><div class=\"col-md-12\" ng-repeat=\"rider in data.riders\"><label>{{ rider.name }} {{ rider.benefitDescription }}</label><span ng-show=\"rider.benefitAmount\">: {{ rider.benefitAmount | currency:undefined:2 }}</span></div></div>");
$templateCache.put("app/components/coverage/_detail_medicare_supplement.html","");
$templateCache.put("app/components/coverage/_detail_office_overhead_expense.html","<div class=\"row\"><div class=\"col-md-12\"><label>{{data.benefitDescription}}:</label> {{data.benefitAmount | currency:undefined:2}}</div><div class=\"col-md-6 col-lg-5\">{{data.eliminationPeriod}} {{data.elimPeriodDescription}} <span ng-show=\"data.eliminationPeriod > 0\">Elimination Period</span></div><div class=\"col-md-6\">{{data.benefitPeriod}} {{data.benefitPeriodDescription}} <span ng-show=\"data.benefitPeriod > 0\">Benefit Period</span></div></div>");
$templateCache.put("app/components/coverage/_detail_prescription_drug.html","");
$templateCache.put("app/components/coverage/_detail_retiree_medical.html","");
$templateCache.put("app/components/coverage/_detail_term_life.html","<div class=\"row\"><div class=\"col-md-12\"><label>{{data.benefitDescription}}:</label> {{data.benefitAmount | currency:undefined:2}}</div><div class=\"col-md-12 rider-label\" ng-if=\"data.riders.length > 0\"><label style=\"font-weight:700\">Riders</label></div><div class=\"col-md-12\" ng-repeat=\"rider in data.riders\"><label>{{ rider.name }} {{ rider.benefitDescription }}</label><span ng-show=\"rider.benefitAmount\">: {{ rider.benefitAmount | currency:undefined:2 }}</span></div></div>");
$templateCache.put("app/components/coverage/_detail_vision.html","");
$templateCache.put("app/components/coverage/coverage.html","<div class=\"main-content\"><div class=\"coverage-content\"><div class=\"loading-text\" ng-show=\"!!vm.filterCoverages(\'Active\').length == 0 + !!vm.filterCoverages(\'Pending\').length == 0 + !!vm.filterCoverages(\'Inactive\').length == 0\">Loading page...<br><br><div class=\"loader\"></div></div><div class=\"activity-pane\"><uib-accordion close-others=\"false\"><div uib-accordion-group=\"\" class=\"status-pane\" is-open=\"vm.isActiveOpen\" ng-if=\"vm.filterCoverages(\'Active\').length>0\"><uib-accordion-heading>Active <i class=\"toggler\">{{vm.isActiveOpen?\'HIDE\':\'SHOW\'}}</i></uib-accordion-heading><uib-accordion close-others=\"false\"><coverage-item data=\"coverageItem\" ng-repeat=\"coverageItem in vm.filterCoverages(\'Active\')\"></coverage-item></uib-accordion></div><div uib-accordion-group=\"\" class=\"status-pane\" is-open=\"vm.isPendingOpen\" ng-if=\"vm.filterCoverages(\'Pending\').length>0\"><uib-accordion-heading>Pending <i class=\"toggler\">{{vm.isPendingOpen?\'HIDE\':\'SHOW\'}}</i></uib-accordion-heading><uib-accordion close-others=\"false\"><coverage-item data=\"coverageItem\" ng-repeat=\"coverageItem in vm.filterCoverages(\'Pending\')\"></coverage-item></uib-accordion></div><div uib-accordion-group=\"\" class=\"status-pane\" is-open=\"vm.isInactiveOpen\" ng-if=\"vm.filterCoverages(\'Inactive\').length>0\"><uib-accordion-heading>Inactive <i class=\"toggler\">{{vm.isInactiveOpen?\'HIDE\':\'SHOW\'}}</i></uib-accordion-heading><uib-accordion close-others=\"false\"><coverage-item data=\"coverageItem\" ng-repeat=\"coverageItem in vm.filterCoverages(\'Inactive\')\"></coverage-item></uib-accordion></div></uib-accordion></div><div class=\"footer-text\" style=\"text-align:center;\">Only the last 2 years of images are available from this site. If you need something further, please contact Customer Service.</div></div><div class=\"contact-sidebar clearfix\"><h2>Contact Us</h2><ul class=\"contact-main\"><li class=\"h3\">Phone</li><li>1-888-627-5883</li><li class=\"h3\">Fax</li><li>1-877-588-7488</li><li class=\"h3\">Email</li><li>wecare@amainsure.com</li></ul><ul><li class=\"h4\">Customer Care Hours</li><li>8 am - 5 pm CT, Monday - Friday</li><li class=\"h4\">Mailing Address</li><li>AMA Insurance Agency, Inc.<br>330 N. Wabash Ave. &#8226 Suite 39300<br>Chicago, IL 60611-5885</li></ul><ul><li class=\"h4\">Send Claims To</li><li>AMA Insurance Agency, Inc.<br>PO Box 804238<br>Chicago, IL 60680 - 4104</li></ul><ul><li class=\"h4\">Send Payments To</li><li>AMA Insurance Agency, Inc.<br>PO Box 8646<br>Carol Stream, IL 60197 - 8646</li></ul><h2>Quick links</h2><ul><li ng-if=\"main.joinableAMA\"><a href=\"\" ng-click=\"main.joinAMA()\" ng-disabled=\"main.isAdmin\" class=\"btn btn-custom btn-orange btn-join-ama\">Join AMA</a></li><li><a ui-sref=\"faq\" class=\"btn-primary btn btn-custom\">Frequently Asked Questions</a></li></ul></div></div><script type=\"text/ng-template\" id=\"group-template.html\"><div class=\"panel {{panelClass || \'panel-default\'}}\"> <div class=\"panel-heading\"> <h4 class=\"panel-title\" style=\"color:#fa39c3\"> <a href tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span ng-class=\"{\'text-muted\': isDisabled}\">{{heading}}</span></a> </h4> </div> <div class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\"> <div class=\"panel-body\" style=\"text-align: right\" ng-transclude></div> </div> </div></script><script type=\"text/ng-template\" id=\"coverageModal.html\"><div class=\"modal-header\"> <h1 class=\"modal-title\">Leaving Site</h1> </div> <div class=\"modal-body\"> <p>We are taking you to a website maintained by MetLife, the underwriter of your Dental Insurance Plan, that will open in a new window. Once you’ve completed your transaction, you can return to myaccount.amainsure.com.</p> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary btn-lg\" type=\"submit\">Continue to MetLife</button> </div></script>");
$templateCache.put("app/components/coverage/coverage_item.html","<div uib-accordion-group=\"\" class=\"certificate-pane\" is-open=\"isItemOpened\"><uib-accordion-heading><img class=\"icon\" ng-src=\"{{iconPath}}\"> {{data.planShortName}} <i class=\"fa\" ng-class=\"{\'fa-chevron-down\': !isItemOpened, \'fa-chevron-up\': isItemOpened}\"></i></uib-accordion-heading><uib-tabset justified=\"true\" class=\"certificate-tabset\"><uib-tab heading=\"Coverage Detail\" class=\"certificate-tab-left certificate-tab\"><div class=\"detail\"><div class=\"row\"><div class=\"col-md-6 col-lg-5 plan-name\">{{data.planName}}<div ng-show=\"data.carrierName\">{{data.carrierName}}</div></div><div class=\"col-md-6\" ng-show=\"data.agentName\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label>Certificate/Record:</label> {{data.certificateNumber}}</div><div class=\"col-md-6 col-lg-5\"><label>Effective:</label> {{data.originalEffectiveDate| formatDate}}</div><div class=\"col-md-6\" ng-if=\"(data.status.toLowerCase() === \'active\' ? data.coveragePaidToDate : data.coverageTerminationDate) !== \'0001-01-01\'\"><label>{{ data.status.toLowerCase() === \'active\' ? \'Coverage Paid To\' : \'Term Date\' }}:</label> {{ (data.status.toLowerCase() === \'active\' ? data.coveragePaidToDate : data.coverageTerminationDate) | formatDate }}</div></div><div ng-if=\"type\" ng-include=\"\'app/components/coverage/_detail_\' + type + \'.html\'\"></div><div class=\"row address\" ng-show=\"data.owner.name\"><div class=\"col-md-12\"><label>Owner:</label><div class=\"content\">{{ data.owner.name }}<br>{{ data.owner.address.addressLine1 }}.<br>{{ data.owner.address.city }}, {{ data.owner.address.state }} {{ data.owner.address.zipCode }}</div></div></div><div class=\"row address\" ng-show=\"data.assigneeName\"><div class=\"col-md-12\"><label>Assignee:</label><div class=\"content\">{{ data.assigneeName }}<br>{{ data.assigneeAddress.addressLine1 }}.<br>{{ data.assigneeAddress.city }}, {{ data.assigneeAddress.state }} {{ data.assigneeAddress.zipCode }}</div></div></div><div class=\"row\"><div class=\"col-md-12\"><button ng-show=\"data.dependents.length > 0\" class=\"btn btn-custom\" ng-click=\"openDependentsModal(data.dependents)\"><span class=\"fa fa-users\"></span>&nbsp; View Dependents</button></div></div><div class=\"row\"><div class=\"col-md-12 document-images-cont\"><div class=\"document-image-buttons-wrap\"><div class=\"list-title plan-name\" ng-if=\"listTitle\">Coverage Documents</div><div><button class=\"btn btn-custom\" ng-click=\"openImagesRedirectModal(data.certificateNumber)\"><span class=\"fa fa-file-text-o\"></span>&nbsp; View Documents</button></div></div></div></div></div></uib-tab><uib-tab heading=\"Billing Information\" class=\"certificate-tab certificate-tab-center\"><div class=\"billing\"><div ng-include=\"\'app/components/coverage/_billing_info.html\'\"></div></div></uib-tab><uib-tab heading=\"Claims\" class=\"certificate-tab certificate-tab-right\"><div class=\"row\"><div class=\"col-md-6 col-lg-5 plan-name\">{{data.planName}}<div ng-show=\"data.carrierName\">{{data.carrierName}}</div></div></div><div class=\"row\"><div class=\"col-md-12\"><label>Certificate/Record:</label> {{data.certificateNumber}}</div></div><br><div class=\"claim\" ng-if=\"data.claims.length === 0\" ng-bind-html=\"claimsText\"></div><div class=\"table-responsive\" ng-if=\"data.claims.length > 0\"><table class=\"table claims-table table-hover table-striped\"><colgroup><col class=\"col-name\"><col class=\"col-date\"><col class=\"col-plan\"><col class=\"col-desc\"><col class=\"col-amount\"></colgroup><thead><tr><th class=\"row-patient\">Patient</th><th class=\"row-provider\">Provider</th><th>Date</th><th>Plan</th><th>Description</th><th>Amount</th></tr></thead><tbody><tr open-claim-details=\"\" claim=\"claim\" coverage=\"data\" ng-repeat=\"claim in data.claims track by $index\"><td>{{ claim.patientName }}</td><td>{{ claim.providerName }}</td><td>{{ claim.serviceDate| formatDate }}</td><td>{{ data.planShortName }}</td><td>{{ claim.claimType }}</td><td class=\"amount h3\"><span class=\"label label-default\">{{claim.claimBillAmount| currency:undefined:2}}</span></td></tr></tbody></table></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/components/coverage/image-redirect.html","<div class=\"notification-modal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Please note:</h4></div><div class=\"modal-body\">You will be redirected to a third-party portal to view the images.</div><div class=\"modal-footer\"><a ng-href=\"{{vm.imageAddress}}?KT114_0_0_0=01&KT116_0_0_0={{vm.certificateNumber}}&clienttype=html&cqid=115\" target=\"_blank\" ng-click=\"vm.cancel()\" class=\"btn btn-primary btn-lg\">Continue</a></div></div>");
$templateCache.put("app/components/coverage/view-dependents.html","<div class=\"notification-modal\"><div class=\"modal-header\"><h1 class=\"modal-title\">Dependents</h1></div><div class=\"modal-body\"><div ng-repeat=\"dependent in vm.dependents.dependents\"><h4>{{ dependent.firstName}} {{ dependent.lastName}}</h4><div class=\"col-xs-6\"><p>Date of Birth:</p></div><div class=\"col-xs-6\"><p>{{ dependent.dateOfBirth| formatDate }}</p></div><div class=\"col-xs-6\"><p>Effective Date:</p></div><div class=\"col-xs-6\"><p>{{ dependent.effectiveDate| formatDate }}</p></div><div ng-if=\"vm.isShowTerminationDate(dependent.terminationDate)\"><div class=\"col-xs-6\"><p>Termination Date:</p></div><div class=\"col-xs-6\"><p>{{ dependent.terminationDate| formatDate }}</p></div></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-custom\" type=\"button\" ng-click=\"vm.cancel()\">Continue</a></div></div>");
$templateCache.put("app/components/idle/idleModal.html","<div class=\"modal-header\"><h1 class=\"modal-title\">Inactivity Warning</h1></div><div class=\"modal-body container\"><p>Our system times you out after 15 minutes of inactivity, press the button below or take any action to remain logged in.</p></div><div class=\"modal-footer\"><button class=\"btn btn-custom\" ng-click=\"vm.cancel()\">Stay Logged In</button></div>");
$templateCache.put("app/components/mfa/passcode.html","<div class=\"passcode-content\"><div class=\"row\"><div class=\"pascode-container col-md-12\"><div class=\"col-xs-12\"><h3>Enter Your One Time Passcode</h3></div><div class=\"col-xs-12\"><h5>A one time passcode has been sent to your email address on file. To help verify your identity please enter the passcode here. Your passcode will expire in 10 minutes.</h5></div><form ng-submit=\"vm.mfa()\" class=\"form-control form-control-passcode\"><div class=\"form-group\"><div class=\"col-xs-12\"><label for=\"passcode\">Enter 6-digit code:</label> <input type=\"text\" id=\"passcode\" name=\"passcode\" inputmode=\"numeric\" pattern=\"[0-9]{6}\" maxlength=\"6\" autocomplete=\"one-time-code\" ng-model=\"vm.passcode\" required=\"\"> <button type=\"submit\" class=\"btn btn-custom\" ng-disabled=\"vm.isVerifyingMfa\">Verify</button></div></div></form><div class=\"col-xs-12\" style=\"padding-top:25px;\"><h5>Didn\'t receive a passcode?</h5></div><div class=\"col-xs-12\" style=\"\"><h5><button type=\"button\" class=\"text-link-button\" ng-click=\"vm.resendIt()\" ng-disabled=\"vm.isResendDisabled\">Resend the passcode.</button></h5></div><div class=\"col-xs-12\" style=\"padding-top:25px;\"><uib-alert style=\"text-align:center\" ng-show=\"vm.passcodeAlertMessage\" type=\"{{ vm.alertType }}\" close=\"vm.closeAlert()\">{{ vm.passcodeAlertMessage }}</uib-alert></div></div></div></div><div class=\"bg-full\"></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top\"><button type=\"button\" class=\"navbar-toggle toggle-usermenu ng-hide\" ng-click=\"vm.toggleUserNav()\" ng-show=\"vm.isShowUserNav\"><span class=\"sr-only\">Toggle user menu</span> <span class=\"fa fa-bars\"></span></button><div class=\"logo visible-xs-block\"></div><div class=\"collapse navbar-collapse mobile-usernav-wrapper\" uib-collapse=\"vm.userNavCollapsed\" ng-include=\"\'app/components/navbar/usernav.html\'\"></div><div class=\"navbar-utility\"><ul class=\"nav navbar-nav navbar-right\"><li ng-show=\"vm.isLoggedIn() && !vm.isAdmin\" class=\"ng-hide nav-user-contact\"><a ui-sref=\"contact\" class=\"nav-user\">Contact Us <i class=\"fa fa-envelope phone-hide\"></i></a></li><li ng-show=\"vm.isLoggedIn() && vm.isAdmin\" class=\"ng-hide nav-user-contact\"><a ui-sref=\"admin-profile\" class=\"nav-user\">Admin Profile</a></li><li ng-if=\"vm.isSuperAdmin\" class=\"nav-admin\"><a ui-sref=\"manage-admin\">Administrators</a></li><li ng-show=\"vm.isLoggedIn()\" class=\"ng-hide nav-user-profile\"><a class=\"nav-user\">Welcome {{vm.getUserText(vm.user)}}</a></li><li ng-if=\"!vm.isAdmin\" class=\"nav-user-tel\"><a href=\"tel:18886275883\" class=\"nav-user\">1.888.627.5883 <i class=\"fa fa-phone phone-hide\"></i></a></li><li ng-show=\"!vm.isLoggedIn()\" class=\"nav-user-login\"><a class=\"nav-user\" ng-href=\"{{ vm.navButtons.loginLink()}}\">{{ vm.navButtons.loginText()}} <i class=\"fa fa-angle-double-right phone-hide\"></i></a></li><li class=\"nav-user-signup\" ng-show=\"vm.isLoggedIn()\"><a class=\"nav-user\" ng-href=\"{{ vm.navButtons.signUpLink()}}\">{{ vm.navButtons.signUpText()}} <i class=\"fa fa-angle-double-right phone-hide\"></i></a></li><li ng-if=\"vm.isAdmin && vm.isLoggedIn()\" class=\"nav-admin-group\"><a href=\"\" ng-click=\"vm.resetCustomer(vm.customer.masterId)\" ng-if=\"vm.isAdminCustomerSet\">Reset Customer</a></li><li ng-if=\"vm.isAdmin && vm.isLoggedIn()\" class=\"nav-admin-group\"><a ui-sref=\"select-customer\" ng-if=\"!vm.isAdminCustomerSet\">Select Customer</a> <a href=\"\" ng-click=\"vm.endCustomerSession()\" ng-if=\"vm.isAdminCustomerSet\">End Customer Session</a></li></ul></div></nav><div><a href=\"https://www.amainsure.com\" target=\"_blank\"><div class=\"logo\"></div></a></div><div ng-show=\"vm.isShowUserNav\" class=\"navbar-secondary navbar\" ng-include=\"\'app/components/navbar/usernav.html\'\"></div>");
$templateCache.put("app/components/navbar/usernav.html","<ul class=\"nav navbar-nav user-nav nav-justified\" ng-click=\"vm.userNavCollapsed=true;\" ng-hide=\"vm.isAdmin && !vm.isAdminCustomerSet\"><li ng-class=\"{active: (vm.isState(\'home\') || vm.isState(\'discount\'))}\" ng-click=\"vm.locationPath(\'/home/\')\"><a class=\"left-nav\">Home</a></li><li ng-class=\"{active: vm.isState(\'coverage\')}\" ng-click=\"vm.locationPath(\'/coverage/\')\"><a>Coverage</a></li><li ng-class=\"{active: vm.isState(\'billing\')}\" ng-click=\"vm.locationPath(\'/billing/\')\"><a>Billing</a></li><li ng-class=\"{active: vm.isState(\'claims\')}\" ng-click=\"vm.locationPath(\'/claims/\')\"><a>Claims</a></li><li ng-class=\"{active: vm.isState(\'profile\')}\" ng-click=\"vm.locationPath(\'/profile/\')\"><a>Profile</a></li></ul>");
$templateCache.put("app/components/privacy/privacy.html","<div class=\"main-content\"><div class=\"privacy-content\"><h2>Privacy Policy</h2><h4>AMA Insurance Agency Inc. Privacy Notices</h4><p>We are committed to protecting your privacy, both on the internet and offline. The statements listed below are provided for your information:</p><h3><a href=\"https://www.amainsure.com/privacy-policy-hipaa/general-privacy-policy.html\" target=\"_blank\">Privacy Policy</a></h3><p>Our general privacy policy applies to the entire customer relationship, and not just to the use of this web site. This policy describes our privacy practices concerning the collection and use of personal and financial information we receive from individuals who seek to obtain, obtain or have obtained products or services from us</p><h3><a href=\"https://www.amainsure.com/privacy-policy-hipaa/online-privacy-policy.html\" target=\"_blank\">Online Privacy Policy</a></h3><p>This policy describes our privacy practices for this web site.</p><h3><a href=\"https://www.amainsure.com/privacy-policy-hipaa/hipaa-notice-privacy-practices.html\" target=\"_blank\">HIPAA Notice of Privacy Practices</a></h3><p>The Health Insurance Portability and Accountability Act of 1996, and federal regulations adopted under it, establishes privacy standards for the health services industry for the confidentiality of individuals\' protected health information. The law and regulations thereunder require AMA Insurance Agency, Inc. to take specific steps to notify our customers (who are enrolled in any of the coverages listed below) about our privacy practices and to avoid improper use and disclosure of protected health information.</p><p>The following is a list of the American Medical Association Sponsored insurance coverages to which our Notice of Privacy Practices is applicable:</p><p>Medicare Supplement (underwritten by Transamerica Life Insurance Company, Transamerica Financial Life Insurance Company and Transamerica Premier Life Insurance Company)</p><p>Catastrophic Major Medical and Excess Major Medical (underwritten by The United States Life Insurance Company in the City of New York)</p><p>Hospital Income (underwritten by New York Life Insurance Company)</p><p>Long Term Care (underwritten by Hartford Life Insurance Company, Provident Life and Accident Insurance Company and Provident Life and Casualty Insurance Company)</p><h3><a href=\"https://www.amainsure.com/privacy-policy-hipaa/hipaa-notices-of-underwriters.html\" target=\"_blank\">Underwriters\' HIPAA Notices</a></h3></div></div>");
$templateCache.put("app/components/profile/profile.html","<div class=\"main-content\"><div class=\"profile-content\"><div class=\"loading-text\" ng-show=\"vm.customerName == null\">Loading page...<br><br><div class=\"loader\"></div></div><div class=\"customer-name\" ng-show=\"vm.customerName != null\"><h1>{{ vm.customerName}} {{ vm.customerTitle}}</h1></div><div class=\"info-container\" ng-show=\"vm.customerName != null\"><div class=\"profile-info\"><table class=\"table table-condensed\"><colgroup><col style=\"width:130px\"><col style=\"width:auto\"></colgroup><thead><tr><th colspan=\"2\"><h3>Personal Information</h3></th></tr></thead><tbody><tr><th>Login Address:</th><td>{{ vm.loginEmail}} <button ng-click=\"vm.open(\'Login Email\', vm.loginEmail)\" ng-disabled=\"vm.isAdmin\" class=\"btn btn-small btn-default\">edit <i class=\"fa fa-pencil\"></i></button></td></tr><tr><th>Email Address:</th><td>{{ vm.emailAddress}} <button ng-click=\"vm.open(\'Email Address\', vm.emailAddress)\" ng-disabled=\"vm.isAdmin\" class=\"btn btn-small btn-default\">edit <i class=\"fa fa-pencil\"></i></button></td></tr><tr><th>Birth Date:</th><td>{{ vm.birthDate | formatDate }}</td></tr><tr class=\"phone-row\"><th>Home #:</th><td>{{ vm.homePhone }} <button ng-click=\"vm.open(\'Home Phone\', vm.homePhone)\" class=\"btn btn-small btn-default\" ng-disabled=\"vm.isAdmin\">edit <i class=\"fa fa-pencil\"></i></button> <button ng-click=\"vm.removePhone(\'Home Phone\')\" class=\"btn btn-small btn-default btn-remove\" ng-disabled=\"!vm.homePhone || vm.isAdmin\">remove <i class=\"fa fa-trash\"></i></button></td></tr><tr class=\"phone-row\"><th>Office #:</th><td>{{ vm.officePhone }} <button ng-click=\"vm.open(\'Office Phone\', vm.officePhone)\" class=\"btn btn-small btn-default\" ng-disabled=\"vm.isAdmin\">edit <i class=\"fa fa-pencil\"></i></button> <button ng-click=\"vm.removePhone(\'Office Phone\')\" class=\"btn btn-small btn-default btn-remove\" ng-disabled=\"!vm.officePhone || vm.isAdmin\">remove <i class=\"fa fa-trash\"></i></button></td></tr><tr class=\"phone-row\"><th>Cell #:</th><td>{{ vm.mobilePhone }} <button ng-click=\"vm.open(\'Cell Phone\', vm.mobilePhone)\" class=\"btn btn-small btn-default\" ng-disabled=\"vm.isAdmin\">edit <i class=\"fa fa-pencil\"></i></button> <button ng-click=\"vm.removePhone(\'Cell Phone\')\" class=\"btn btn-small btn-default btn-remove\" ng-disabled=\"!vm.mobilePhone || vm.isAdmin\">remove <i class=\"fa fa-trash\"></i></button></td></tr><tr ng-if=\"vm.membershipCode\" ng-class=\"{\'active-status-row-prev\': vm.isAdmin}\"><th nowrap=\"\">AMA Membership:</th><td>{{ vm.membershipCode }} <button ng-show=\"vm.membershipCode===\'Non-Member\'\" ng-click=\"vm.joinAMA()\" ng-disabled=\"vm.isAdmin\" class=\"btn btn-small btn-custom btn-orange\">Join AMA</button></td></tr><tr ng-if=\"vm.isAdmin\" class=\"active-status-row\"><th>Active:</th><td ng-if=\"vm.notRegistered\">Not Registered</td><td ng-if=\"!vm.notRegistered\">{{ vm.enabledStatus ? \'Yes\': \'No\' }} <button ng-click=\"vm.activeUser(vm.loginEmail)\" ng-hide=\"vm.enabledStatus\" class=\"btn btn-small btn-default\">Activate</button></td></tr></tbody></table></div></div><div class=\"info-container\" ng-show=\"vm.customerName != null\"><div class=\"profile-info\"><table class=\"table table-condensed\"><colgroup><col style=\"width:100px\"><col style=\"width:auto\"></colgroup><thead><tr><th colspan=\"2\"><h3>Address Information</h3></th></tr></thead><tbody><tr><th>Address:</th><td>{{ vm.address.addressLine1}}<br><span class=\"user-address\" ng-show=\"vm.address.addressLine2\">{{ vm.address.addressLine2}}<br></span> <span class=\"user-address\" ng-show=\"vm.address.addressLine3\">{{ vm.address.addressLine3}}<br></span> {{ vm.address.city}}, {{ vm.address.state}} {{ vm.address.zipCode}} <button ng-click=\"vm.open(\'of Address\', vm.address)\" ng-disabled=\"vm.isAdmin\" class=\"btn btn-small btn-default\">edit <i class=\"fa fa-pencil\"></i></button></td></tr></tbody></table></div></div></div><div class=\"contact-sidebar\"><h2>Contact Us</h2><ul class=\"contact-main\"><li class=\"h3\">Phone</li><li>1-888-627-5883</li><li class=\"h3\">Fax</li><li>1-877-588-7488</li><li class=\"h3\">Email</li><li>wecare@amainsure.com</li></ul><ul><li class=\"h4\">Customer Care Hours</li><li>8 am - 5 pm CT, Monday - Friday</li><li class=\"h4\">Mailing Address</li><li>AMA Insurance Agency, Inc.<br>330 N. Wabash Ave. &#8226 Suite 39300<br>Chicago, IL 60611-5885</li><li class=\"h4\">Send Claims To</li><li>AMA Insurance Agency, Inc.<br>PO Box 804238<br>Chicago, IL 60680 - 4104</li><li class=\"h4\">Send Payments To</li><li>AMA Insurance Agency, Inc.<br>PO Box 8646<br>Carol Stream, IL 60197 - 8646</li></ul><h2>Quick links</h2><ul><li><a ui-sref=\"faq\" class=\"btn-primary btn btn-custom\">Frequently Asked Questions</a></li></ul></div></div><script type=\"text/ng-template\" id=\"profileModal.html\"><div class=\"modal-header\"> <h1 class=\"modal-title\">Change {{ vm.selected.name }}</h1> </div> <div class=\"modal-body\"> <!-- Update Email Address Modal --> <div class=\"personal-modal\" ng-show=\"vm.selected.name === \'Email Address\'\"> <div class=\"clearfix\"> <div class=\"col-xs-12\"> <p class=\"bold\">Current Email Address: <span class=\"visible-inline-xs text-muted\">{{ vm.selected.value }}</span></p> </div> </div> <form class=\"personal-form personal-change-form\"> <div class=\"form-group\"> <label>New Email Address: </label> <input type=\"text\" name=\"contact-info\" value=\"\" class=\"form-control\" placeholder=\"Email\" ng-model=\"vm.emailAddress\" ng-blur=\"vm.checkValidation(vm.selected.name)\"> <div class=\"validation-error\" ng-show=\"vm.emailAddressInvalid\"> <p>{{ vm.emailAddressInvalid }}</p> </div> </div> </form> </div> <!-- Update Login Email Modal --> <div class=\"personal-modal\" ng-show=\"vm.selected.name === \'Login Email\'\"> <div class=\"clearfix\"> <div class=\"col-xs-12\"> <p class=\"bold\">Current Login Email: <span class=\"visible-inline-xs text-muted\">{{ vm.selected.value }}</span></p> </div> </div> <form class=\"personal-form personal-change-form\"> <div class=\"form-group\"> <label>New Login Email: </label> <input type=\"text\" name=\"contact-info\" value=\"\" class=\"form-control\" placeholder=\"Email\" ng-model=\"vm.loginEmail\" ng-blur=\"vm.checkValidation(vm.selected.name)\"> <div class=\"validation-error\" ng-show=\"vm.loginEmailInvalid\"> <p>{{ vm.loginEmailInvalid }}</p> </div> </div> </form> </div> <!-- Update Phone Number Modal --> <div class=\"personal-modal\" ng-show=\"vm.isPhone\"> <div class=\"clearfix\"> <div class=\"col-xs-12\"> <p class=\"bold\">Current Phone Number: <span class=\"visible-inline-xs text-muted\">{{ vm.selected.value }}</span> </p> </div> </div> <form class=\"personal-form personal-change-form phone-form\"> <div class=\"form-group col-xs-12\"> <label>New Phone Number: </label> <input type=\"text\" name=\"contact-info\" value=\"\" class=\"form-control\" ng-model=\"vm.phone\" ng-blur=\"vm.checkValidation(vm.selected.name)\" ui-mask=\"(999) 999-9999\" ui-mask-placeholder ui-mask-placeholder-char=\"x\"> <div class=\"validation-error\" ng-show=\"vm.phoneInvalid\"> <p>{{ vm.phoneInvalid }}</p> </div> </div> <div class=\"form-group\"> <label class=\"checkbox\"> <input type=\"checkbox\" name=\"mobile-phone\" ng-model=\"vm.isMobilePhone\" ng-disabled=\"vm.selected.name===\'Cell Phone\'\"> This is a mobile phone. </label> </div> <div class=\"form-group\" ng-if=\"vm.isMobilePhone\"> By clicking the \"I agree button\" below, I verify that this is my mobile number and consent to receive calls and text messages via automated technology to this number regarding product offers by or on behalf of AMA Insurance. I understand that consent is not required to make a purchase. </div> <div class=\"form-group\" ng-if=\"vm.isMobilePhone\"> <label class=\"checkbox\"> <input type=\"checkbox\" name=\"agree-marketing\" ng-model=\"vm.isMarketPhone\"> I agree. </label> </div> </form> </div> <!-- Update Address Info Modal --> <div class=\"address-modal\" ng-show=\"vm.selected.name === \'of Address\'\"> <div class=\"clearfix\"> <div class=\"current-address-box\"> <div class=\"col-md-3 sans-padding-right\"> <p class=\"bold\">Current Information:</p> </div> <div class=\"col-md-8\"> <p> <span class=\"text-muted text-address\"> <span>{{ vm.selected.value.addressLine1 }}</span> <span ng-show=\"vm.selected.value.addressLine2\">{{ vm.selected.value.addressLine2 }}</span> <span ng-show=\"vm.selected.value.addressLine3\">{{ vm.selected.value.addressLine3 }}</span> <span>{{ vm.selected.value.city }}, {{ vm.selected.value.state }} {{ vm.selected.value.zipCode }}</span> </span> </p> </div> </div> </div> <div> <form class=\"personal-form address-change-form clearfix\"> <p class=\"bold col-xs-12\">Update Information: </p> <hr> <label>Address Line 1: </label> <div> <input type=\"text\" name=\"address1\" value=\"\" placeholder=\"Address Line 1\" ng-model=\"vm.addressLine1\" ng-blur=\"vm.checkValidation(\'addressLine1\')\"> <div class=\"validation-error\" ng-show=\"vm.addressLine1Invalid\"> <p>{{ vm.addressLine1Invalid }}</p> </div> </div> <label>Address Line 2: </label> <div> <input type=\"text\" name=\"address2\" value=\"\" placeholder=\"Address Line 2\" ng-model=\"vm.addressLine2\" ng-blur=\"vm.checkValidation(\'addressLine2\')\"> <div class=\"validation-error\" ng-show=\"vm.addressLine2Invalid\"> <p>{{ vm.addressLine2Invalid }}</p> </div> </div> <label>Address Line 3: </label> <div> <input type=\"text\" name=\"address2\" value=\"\" placeholder=\"Address Line 3\" ng-model=\"vm.addressLine3\" ng-blur=\"vm.checkValidation(\'addressLine3\')\"> <div class=\"validation-error\" ng-show=\"vm.addressLine3Invalid\"> <p>{{ vm.addressLine3Invalid }}</p> </div> </div> <label>City: </label> <div> <input type=\"text\" name=\"city\" value=\"\" placeholder=\"City\" ng-model=\"vm.city\" ng-blur=\"vm.checkValidation(\'city\')\"> <div class=\"validation-error\" ng-show=\"vm.cityInvalid\"> <p>{{ vm.cityInvalid }}</p> </div> </div> <label>State: </label> <div> <select class=\"form-control\" name=\"state\" placeholder=\"State\" ng-model=\"vm.state\" ng-blur=\"vm.checkValidation(\'state\')\" ng-options=\"item.id as item.name for item in vm.allStates track by item.id\"> </select> <div class=\"validation-error\" ng-show=\"vm.stateInvalid\"> <p>{{ vm.stateInvalid }}</p> </div> </div> <label>Zip Code: </label> <div> <input type=\"text\" class=\"form-control\" name=\"zip\" value=\"\" placeholder=\"5-Digit ZIP\" maxlength=\"5\" ng-model=\"vm.zipCode\" ng-blur=\"vm.checkValidation(\'zip\')\"> <div class=\"validation-error\" ng-show=\"vm.zipInvalid\"> <p>{{ vm.zipInvalid }}</p> </div> </div> </form> <div class=\"validation-error\" ng-show=\"vm.addressInvalid\"> <p>{{ vm.addressInvalid }}</p> </div> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-mousedown=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-custom\" type=\"button\" ng-click=\"vm.update()\">Update</button> </div></script>");
$templateCache.put("app/components/tos/tos.html","<div class=\"main-content\"><div class=\"tos-content\"><h1>Terms of Use</h1><h4>TERMS AND CONDITIONS OF USE<br>AMA INSURANCE AGENCY, INC. WEBSITES</h4><p>By accessing or using any of the Internet properties of AMA Insurance Agency, Inc. (&quot;AMA Insurance&quot;) including, without limitation, <a href=\"http://www.amainsure.com/\" target=\"_blank\">www.amainsure.com</a>, and any others released by AMA Insurance from time to time (collectively referred to as the &quot;AMA Insurance websites&quot;) you agree to comply with and be bound by these Terms and Conditions of Use (&quot;Terms of Use&quot;). You may also accept these Terms of Use during the registration process or login process, which contain the express acknowledgement that you have read and agree to these Terms of Use.</p><p>Please read these Terms of Use carefully as well as AMA Insurance\'s <a href=\"https://www.amainsure.com/privacy-policy-hipaa.html\" target=\"_blank\">Privacy Policy</a> which is incorporated herein by reference. <strong>If you do not agree to these Terms of Use and the Privacy Policy, you must immediately terminate your use of the AMA Insurance websites.</strong></p><p><strong>You may <span class=\"underlined\">print or save a copy</span> <i class=\"fa fa-file-pdf-o\"></i> of these Terms of Use for your records.</strong></p><p>1. <span class=\"underlined\">License Grant</span>. You are granted a personal, revocable, limited, non-exclusive, non-transferable license to access and use the AMA Insurance websites conditioned on your continued acceptance of, and compliance with, these Terms of Use. You may use the AMA Insurance websites and the AMA Insurance Content (as defined below) for your noncommercial personal use and for no other purpose. AMA Insurance reserves the right to bar, restrict or suspend any user\'s access to the AMA Insurance websites, and/or to terminate this license at any time for any reason. AMA Insurance reserves any rights not explicitly granted in these Terms of Use.</p><p>2. <span class=\"underlined\">License Restrictions</span>. Unless otherwise expressly stated in these Terms of Use or you receive AMA Insurance\'s prior written consent, you may not modify, translate, create derivative works of, copy, distribute, market, display, remove or alter any proprietary notices or labels from, lease, sell, sublicense, clone, transfer, decompile, reverse engineer, or incorporate into any information retrieval system (electronic or mechanical), the AMA Insurance websites, any AMA Insurance Content (as defined below), or any portion thereof. Further, you may not (i) use the AMA Insurance websites for any unauthorized or illegal purpose or activity including, but not limited to, any activity to obtain or attempt to obtain unauthorized access to the AMA Insurance websites, including AMA Insurance Content; (ii) interfere with the proper working of the AMA Insurance websites including, but not limited to, the transmission of any virus, worm, trap door, back door, timer, clock, Trojan horse, or other limiting routine, instruction or design; or (iii) interfere with any other person\'s use and enjoyment of the AMA Insurance websites.</p><p>3. <span class=\"underlined\">Your Acceptance; Revisions to Terms of Use</span>. The AMA Insurance websites are available only to individuals who can enter into legally binding contracts under applicable law. These Terms of Use constitute a legally binding agreement between you and AMA Insurance regarding your use and access to the AMA Insurance websites. <strong>By using the AMA Insurance websites you agree to the Terms of Use.</strong>You may also accept these Terms of Use during the registration process or login process, which contain the express acknowledgement that you have read and agree to these Terms of Use.</p><p>AMA Insurance reserves the right to revise these Terms of Use at any time in its sole discretion by posting revised Terms of Use to the AMA Insurance websites. Your use of the AMA Insurance websites signifies your acceptance of all the terms and conditions contained within the Terms of Use posted at the time of your use. You will be responsible for regularly reviewing the Terms of Use posted to the AMA Insurance websites. No revision to these Terms of Use, including to the Arbitration provision set forth in Section 23, shall apply to a controversy or claim of which AMA Insurance had actual notice on or before the date of any such revision.</p><p>4. <span class=\"underlined\">AMA Insurance Policies; Additional Terms and Conditions</span>. AMA Insurance\'s <a href=\"https://www.amainsure.com/privacy-policy-hipaa.html\" target=\"_blank\">Privacy Policy</a> , as well as other additional terms and conditions applicable to certain portions of the AMA Insurance websites (collectively &quot;Additional Terms and Conditions&quot;) are incorporated herein by reference. To the extent that there is a conflict between these Terms of Use and any Additional Terms and Conditions for the activity in which you choose to participate, the Additional Terms and Conditions shall govern.</p><p>5. <span class=\"underlined\">Click-Through Agreements</span>. Before using certain areas of the AMA Insurance websites you may be asked to indicate your acceptance of additional special terms and conditions by clicking a button marked &quot;I Accept&quot; &quot;I Agree&quot; &quot;Okay&quot; &quot;I Consent&quot; or other words or actions that similarly acknowledge your consent or acceptance of a Click-Through Agreement. To the extent there is a conflict between these Terms of Use and any Click-Through Agreement for the activity in which you choose to participate, the Click Through Agreement will govern.</p><p>6. <span class=\"underlined\">Personal Login Information</span>. Certain features and areas of the AMA Insurance websites are available only with registration, login and/or a paid subscription. If you are required to register and select a unique login and password (&quot;Personal Login Information&quot;), you must keep your Personal Login Information confidential. Your Personal Login Information is personal to you and you may not allow any third party to use it under any circumstances. AMA Insurance is not liable for any harm caused by or related to the theft, misappropriation, disclosure, or unauthorized use of your Personal Login Information. You must <a href=\"https://www.amainsure.com/about-us/contact-us.html\" target=\"_blank\">contact AMA Insurance</a> immediately if you become aware of or believe there is or may have been any unauthorized use of your Personal Login Information, or otherwise wish to deactivate your Personal Login Information due to security concerns.</p><p>7. <span class=\"underlined\">Privacy Policy</span>. For information about AMA Insurance\'s data protection practices and AMA Insurance\'s use and protection of your personal information, please read AMA Insurance\'s <a href=\"https://www.amainsure.com/privacy-policy-hipaa.html\" target=\"_blank\">Privacy Policy</a> which is incorporated into and made a part of these Terms of Use.</p><p>8. <span class=\"underlined\">User Obligations</span>. You warrant that you will abide by all applicable local, state, national and international laws and regulations with respect to your use of the AMA Insurance websites and not interfere with the use and enjoyment of the AMA Insurance websites by other users or with AMA Insurance\'s operation and management of the AMA Insurance websites. You will, at all times, provide true, accurate, current, authorized, and complete information when submitting information or materials on the AMA Insurance websites, including, without limitation, information required to be provided through an AMA Insurance registration form. If any false, inaccurate, untrue, unauthorized or incomplete information is submitted by you, AMA Insurance reserves the right to terminate your access and use of the AMA Insurance websites. You warrant that you will not impersonate any other person or entity, whether actual or fictitious, when using the AMA Insurance websites, or defame or otherwise harm any party, including AMA Insurance, through your use of the AMA Insurance websites.</p><p>9. <span class=\"underlined\">User-Generated Content</span>. AMA Insurance does not claim ownership of content that you post on or through the AMA Insurance websites, such as comments or posts that you submit on forums, blogs, or other websites (&quot;User-Generated Content&quot;). When submitting User-Generated Content, you will abide by the <span class=\"underlined\">Code of Conduct</span> which is incorporated herein by reference. You also acknowledge that you alone are fully responsible for the User-Generated Content you submit and that you own or have the rights to use the User-Generated Content. You agree that by submitting the User-Generated Content, you hereby grant to AMA Insurance a perpetual, non-exclusive, fully paid and royalty-free, transferable, sub-licensable, worldwide license to use, download, duplicate, display, distribute, modify and creative derivative works of the User-Generated Content, subject to AMA Insurance\'s <a href=\"https://www.amainsure.com/privacy-policy-hipaa.html\" target=\"_blank\">Privacy Policy</a>.</p><p>10. <span class=\"underlined\">Proprietary Rights</span>. The content of the AMA Insurance websites includes, without limitation, (i) AMA Insurance\'s trademarks, service marks, logos, brands, and brand names, trade dress and trade names and other distinctive identification (collectively the &quot;AMA Insurance Marks&quot;); and (ii) information, data, materials, interfaces, computer code, databases, products, services, software applications and tools, text, images, photographs, audio and video material, and artwork, and (iii) the design, structure, selection, compilation, assembly, coordination, expression, functionalities, applications, look and feel, and arrangement of any content contained in or available through the AMA Insurance websites (the items identified in subsections (i) (ii) and (iii) shall be collectively referred to herein as the &quot;AMA Insurance Content&quot;). The AMA Insurance Content is the property of AMA Insurance, its licensors, sponsors, partners, advertisers, content providers or other third parties and is protected by law including, but not limited to, United States copyright, trade secret, patent, and trademark law, as well as other state, national and international laws, treaties and regulations. The reproduction, transmission, distribution, sale, publication, broadcast, circulation or dissemination of any AMA Insurance Content by you, or by you through any other person or entity, is prohibited unless express written consent is separately obtained from AMA Insurance or the owner of such content if AMA Insurance is not the owner. Any use of the AMA Insurance Marks without AMA Insurance\'s express written consent is strictly prohibited. You may not alter, delete, obscure or conceal any copyright or other notices appearing in the AMA Insurance Content, including any such notices appearing on any AMA Insurance Content you are permitted to download, transmit, display, print, or reproduce from the AMA Insurance websites.</p><p>11. <span class=\"underlined\">Responsibility for Use of the Internet and the AMA Insurance Websites</span>. Use of the Internet and the AMA Insurance websites is solely at your risk and is subject to all applicable local, state, national and international laws and regulations. AMA Insurance does not guarantee the confidentiality or security of any communication or other material transmitted to or from the AMA Insurance websites over the Internet or other communication network. AMA Insurance shall not be obligated to correct or update the AMA Insurance websites, the AMA Insurance Content or the User-Generated Content and AMA Insurance shall not be liable for omissions, typographical errors, or out-of-date information which may appear on the AMA Insurance websites.</p><p>12. <span class=\"underlined\">Professional Advisory Disclaimer</span>. The AMA Insurance Content is provided for informational purposes only and is not intended as medical advice, or as a substitute for the medical advice of a physician. Further, the AMA Insurance Content is not intended as financial advice or as a substitute for obtaining financial advice from a qualified financial advisor. Therefore, you should not rely solely upon this AMA Insurance Content in making any financial decision, including any decision to buy a product from AMA Insurance or any other company. The AMA Insurance Content is not an offer to sell or a solicitation of an offer to buy any security, service, or product. The AMA Insurance websites are not intended to provide legal or tax advice. Please consult your legal or tax professional for specific information.</p><p>13. <span class=\"underlined\">Patient Information</span>. The AMA Insurance websites, including any public forums which you may access via the AMA Insurance websites, may contain confidential patient information (&quot;Patient Information&quot;). State and federal laws, as well as ethical and licensure requirements, may impose obligations with respect to patient confidentiality that may limit your ability to receive, disclose, or make use of Patient Information, including transmitting Patient Information to others. You warrant that you will comply with all laws that may directly or indirectly govern your retrieval, use, transmission, processing, receipt, reporting, disclosure, or storage of Patient Information. You are solely responsible for obtaining and maintaining any patient consents, if applicable, and all other consents or permissions required by law or advisable with respect to your retrieval, use, transmission, processing, receipt, reporting, disclosure or storage of Patient Information. You shall be solely responsible for your retrieval, use or misuse, transmission, processing, receipt, reporting, disclosure or storage of Patient Information.</p><p>14. <span class=\"underlined\">Third Party Information</span>. The AMA Insurance websites may feature materials, information, products, and services provided by third parties. Any such information, including but not limited to articles, press clippings, opinions, advice, statements, services, offers, User-Generated Content or other information made available by third parties such as content providers and other users of the AMA Insurance websites are those of the respective third party and not of AMA Insurance or its affiliates. AMA Insurance makes no representation with respect to, nor does it guarantee or endorse, the quality, non-infringement, accuracy, completeness, timeliness, or reliability of such third party materials, information, services or products.</p><p>15. <span class=\"underlined\">Advertisers</span>. The AMA Insurance websites may contain advertisements of third parties. The inclusion of advertisements on the AMA Insurance websites does not imply endorsement of the advertised products or services by AMA Insurance. AMA Insurance shall not be responsible for any loss or damage of any kind incurred as a result of the presence of such advertisements on the AMA Insurance websites. Further, AMA Insurance shall not be responsible or liable for the statements or conduct of any third party advertisers appearing on the AMA Insurance websites. You shall be solely responsible for any correspondence or transactions you have with any third party advertisers.</p><p>16. <span class=\"underlined\">Links to Third Party Websites</span>. The AMA Insurance websites may provide links (including any link through an on-line banner advertisement) to other sites on the Internet for your convenience. These other sites are maintained by third parties over which AMA Insurance exercises no control. The appearance of any such third party links (provided by AMA Insurance or by a third party) is not intended to endorse any particular company or product. If you decide to access any of the third party sites linked to the AMA Insurance websites, you do so entirely at your own risk.</p><p>17. <span class=\"underlined\">Links to AMA Insurance websites and AMA Insurance Content</span>. Links posted by third parties to the AMA Insurance websites and/or AMA Insurance Content may not use the AMA Insurance Marks and shall not suggest that AMA Insurance promotes or otherwise endorses any third party products, business relationships, services, causes, campaigns, websites, content, or information. Any links to any portion of the AMA Insurance websites shall be the responsibility of the linking party. AMA Insurance reserves the right to require any linking party to disable or remove any link that violates AMA Insurance\'s rights or causes interruption or deterioration of AMA Insurance Content.</p><p>18. <span class=\"underlined\">Warranties Disclaimed</span>. THE AMA INSURANCE WEBSITES AND AMA INSURANCE CONTENT ARE PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE.&quot; NEITHER AMA INSURANCE, ITS AFFILIATES (INCLUDING THE AMERICAN MEDICAL ASSOCIATION), SUBSIDIARIES, EMPLOYEES, OFFICERS, OR TRUSTEES NOR ANY OF ITS AGENTS, REPRESENTATIVES, SUPPLIERS, ADVERTISERS, PROMOTIONAL PARTNERS, OR LICENSORS (COLLECTIVELY, THE &quot;AMA INSURANCE PARTIES&quot;) PROVIDE ANY EXPRESS OR IMPLIED REPRESENTATION OR WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY REPRESENTATION OR WARRANTY THAT (i) THE AMA INSURANCE WEBSITES OR AMA INSURANCE CONTENT, OR ANY RESULTS THAT MAY BE OBTAINED BY YOU, ARE COMPLETE, ACCURATE, RELIABLE OR NON-INFRINGING; (ii) ACCESS TO THE AMA INSURANCE WEBSITES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE; (iii) THE QUALITY OF ANY PRODUCTS, SERVICES, INFORMATION OR OTHER MATERIAL PURCHASED OR OBTAINED BY YOU THROUGH THE AMA INSURANCE WEBSITES WILL MEET YOUR EXPECTATIONS; OR (iv) AMA INSURANCE CONTENT WILL REMAIN UNCHANGED OR ACCESSIBLE ON THE AMA INSURANCE WEBSITES. ALL WARRANTIES, EXPRESS OR IMPLIED, ARE DISCLAIMED TO THE FULLEST EXTENT PERMITTED BY LAW INCLUDING, WITHOUT LIMITATION, ANY WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND/OR NON-INFRINGEMENT OF INTELLECTUAL PROPERTY.</p><p>19. <span class=\"underlined\">Limitation of Liability</span>. THE AMA INSURANCE PARTIES SHALL NOT BE LIABLE, AND DISCLAIM ANY LIABILITY, FOR ANY CLAIM, LOSS OR DAMAGE, DIRECT OR INDIRECT, INCLUDING, WITHOUT LIMITATION, COMPENSATORY, CONSEQUENTIAL, INCIDENTAL, INDIRECT, SPECIAL, EXEMPLARY OR PUNITIVE DAMAGES OF ANY KIND WHATSOEVER IN CONNECTION WITH, AS A RESULT OF, OR ARISING (i) OUT OF THE USE OF OR INABILITY TO USE THE AMA INSURANCE WEBSITES AND/OR ANY AMA INSURANCE CONTENT; (ii) FROM ANY INTERRUPTION IN THE AVAILABILITY OF THE AMA INSURANCE WEBSITES AND/OR AMA INSURANCE CONTENT; (iii) FROM ANY LOSS OF DATA AND/OR FROM ANY EQUIPMENT FAILURE; (iv) OUT OF THE PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES RESULTING FROM ANY PROBLEMS WITH THE GOODS, CONTENT AND/OR SERVICES PURCHASED OR OBTAINED FROM THE AMA INSURANCE WEBSITES, OR TRANSACTIONS ENTERED INTO, THROUGH OR FROM THE AMA INSURANCE WEBSITES; (v) FROM UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (vi) FROM STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE AMA INSURANCE WEBSITES; (vii) FROM ANY DELAY OR FAILURE OF THE AMA INSURANCE WEBSITES ARISING OUT OF CAUSES BEYOND AMA INSURANCE\'S CONTROL; (viii) OUT OF THE USE OF, REFERENCE TO, OR RELIANCE ON, THE AMA INSURANCE CONTENT; (ix) OUT OF ANY THIRD PARTY MATERIALS, INFORMATION, PRODUCTS AND SERVICES CONTAINED ON, OR ACCESSED THROUGH, THE AMA INSURANCE WEBSITES; (x) OUT OF ANY CONTENT, MATERIALS, ACCURACY OF INFORMATION, AND/OR QUALITY OF THE PRODUCTS, SERVICES OR MATERIALS PROVIDED BY OR ADVERTISED ON THIRD PARTY WEBSITES; OR (xi) OUT OF ANY OTHER MATTER RELATING TO THE AMA INSURANCE WEBSITES OR AMA INSURANCE CONTENT.</p><p>In the event you are dissatisfied with, or dispute, these Terms of Use, the AMA Insurance websites and/or the AMA Insurance Content, your sole right and exclusive remedy is to terminate your use of the AMA Insurance websites, even if that right or remedy is deemed to fail of its essential purpose. You confirm that AMA Insurance has no other obligation, liability or responsibility to you or any other party.</p><p>20. <span class=\"underlined\">Exclusions Permitted by Law</span>. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR CONDITIONS OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR LOSS OR DAMAGE CAUSED BY NEGLIGENCE, BREACH OF CONTRACT OR BREACH OF IMPLIED TERMS, OR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, ONLY THE ABOVE LIMITATIONS IN SECTIONS 18 AND 19 WHICH ARE LAWFUL IN YOUR JURISDICTION WILL APPLY TO YOU AND AMA INSURANCE\'S LIABILITY WILL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.</p><p>21. <span class=\"underlined\">Indemnification</span>. To the fullest extent permitted by law, you shall defend, indemnify, and hold harmless the AMA Insurance Parties from and against all claims arising from or in any way related to your use of the AMA Insurance websites and/or AMA Insurance Content, a violation by you of these Terms of Use, or any other actions connected with your use of the AMA Insurance websites and/or AMA Insurance Content, including any liability or expense, losses, damages (actual and consequential), suits, judgments, litigation costs and attorneys\' fees. AMA Insurance will provide prompt written notice of any such claims, but failure to provide such notice will not release you from any of your obligations pursuant to this Section except to the extent that you are actually prejudiced by such failure, and will not relieve you from any other liability that you may have to the AMA Insurance Parties other than under this Section.</p><p>22. <span class=\"underlined\">Term</span>. These Terms of Use will take effect at the time you begin using the AMA Insurance websites. AMA Insurance reserves the right, with or without notice, at any time and for any reason to deny you access to the AMA Insurance websites or to any portion thereof. You may at any time cease to use the AMA Insurance website, but all applicable provisions of these Terms of Use will continue to apply.</p><p>23. <span class=\"underlined\">Arbitration; Venue</span>. Any controversy or claim (&quot;Claim&quot;) you have arising out of or relating to these Terms of Use shall be resolved by a single impartial arbitrator pursuant to proceedings administered by the American Arbitration Association under its rules for resolution of commercial disputes. Any such Claim shall be brought solely by you as an individual and not as part of, or as a representative of, a class. The arbitration shall be held in Chicago, Illinois. All submissions to the arbitrator, the proceedings and the award shall be confidential. The arbitration shall be conducted on an expedited basis with minimal discovery. The arbitrator\'s award shall be final and binding. The courts of the State of Illinois and/or the United States District Court for the Northern District of Illinois shall have exclusive jurisdiction and venue over (i) any action concerning the enforcement of an arbitration award, or (ii) if arbitration is not permitted by law, then any Claim you have arising out of or relating to these Terms of Use. You agree to unconditionally and irrevocably submit to the exclusive jurisdiction and venue of such courts and you will not object to such jurisdiction and venue on the grounds of lack of personal jurisdiction, inconvenient forum or otherwise. EACH PARTY IRREVOCABLY WAIVES ANY AND ALL RIGHT TO TRIAL BY JURY IN ANY LEGAL PROCEEDING ARISING OUT OF OR RELATED TO THESE TERMS OF USE. AMA Insurance reserves all rights and remedies available to it, in law or equity, with respect to any matter relating to these Terms of Use.</p><p>Neither party consents or agrees to any arbitration on a class or representative basis, and the arbitrator shall have no authority to proceed with an arbitration on a class or representative basis. No arbitration will be consolidated with any other arbitration proceeding without the consent of all parties. Any claim or controversy as to the enforceability of this arbitration provisions restriction on your right to participate in or pursue a class action or classwide arbitration shall be brought only in the United States District Court for the Northern District of Illinois or any State of Illinois court located in Cook County, Illinois.</p><p>24. <span class=\"underlined\">Governing Law</span>. These Terms of Use and all matters regarding your use of the AMA Insurance websites shall be governed by, construed in accordance with, and enforced under the laws of the State of Illinois applicable to contracts made and executed and wholly performed in the State of Illinois, without regard to choice of law principles. Neither the Uniform Computer Information Transaction Act nor the United Nations Convention on Contracts for International Sale of Goods apply and their applicability is expressly excluded. Printed copies of any and all agreements and/or notices in electronic form shall be admissible in any legal, investigative or regulatory proceedings.</p><p>25. <span class=\"underlined\">Waiver and Severability</span>. The failure of AMA Insurance to exercise or enforce any right or provision in these Terms of Use shall not constitute a waiver of such right or provision. If any provision of these Terms of Use is found by a court of competent jurisdiction to be invalid, illegal, or unenforceable, such provision shall be enforced to the fullest extent of the law, and all other provisions shall remain in full force and effect.</p><p>26. <span class=\"underlined\">Complete Agreement</span>. These Terms of Use, together with any revisions, any Additional Terms and Conditions incorporated by reference, and any Click-through Agreement, constitutes the entire agreement between you and AMA Insurance relating to the AMA Insurance websites and its use by you, and supersedes any previous written or oral communication regarding use of the AMA Insurance websites. The AMA Insurance websites are intended to be consistent with and in furtherance of the AMA\'s <a href=\"http://www.ama-assn.org/go/policyfinder\" target=\"_blank\">policies adopted by the AMA House of Delegates</a>.</p><p>27. <span class=\"underlined\">Contact Information</span>. If you have any questions or concerns regarding these Terms of Use or the AMA Insurance websites, please visit our &quot;<a href=\"https://www.amainsure.com/about-us/contact-us.html\" target=\"_blank\">Contact Us</a>&quot; page.</p><p>28. <span class=\"underlined\">Statute of Limitations</span>. Regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to your use of the AMA Insurance websites must be filed by you within one (1) year after such claim or cause of action arose or be forever barred.</p><p>29. <span class=\"underlined\">Use of AMA Insurance websites and AMA Insurance Content outside of the United States</span>. AMA Insurance makes no claims regarding access or use of the AMA Insurance websites or the AMA Insurance Content outside of the United States. If you use or access the AMA Insurance websites or the AMA Insurance Content outside of the United States, you do so at your own risk and are responsible for compliance with the laws and regulations of your jurisdiction as well as these Terms of Use.</p><p>30. <span class=\"underlined\">DMCA Notification Requirements</span>. Pursuant to the Digital Millennium Copyright Act of 1998, 17 U.S.C. §512(c), if you believe in good faith that a copyrighted work has been reproduced on this website without authorization in a way that constitutes copyright infringement, you may send a notice to: AMA Insurance Agency, Inc., 330 N. Wabash Avenue, Suite 39300, Chicago, Illinois 60611-5885; Attention, Office of General Counsel, Telephone: 1-888-627-5883; Fax: 1-877-588-7488, E-mail: <span class=\"underlined\">dmca_claims@amainsure.com</span>. Your notice must contain, at a minimum, (i) a physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed; (ii) identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single AMA Insurance website are covered by a single notification, a representative list of such works at that site; (iii) identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit AMA Insurance to locate the material; (iv) information reasonably sufficient to permit AMA Insurance to contact you, such as an address, telephone number, and, if available, an electronic mail address at which you may be contacted; (v) a statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law; and (vi) a statement that the information in the notification is accurate, and under penalty of perjury, that you are authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.</p><p>Revised Nov. 2, 2015</p></div></div>");
$templateCache.put("app/components/user/login.html","<div class=\"login-content\"><div class=\"row\"><div class=\"welcome-text col-md-4\"><h2>Welcome to My Account</h2><p>Secure access to your coverage information 24/7. Login or Register your account at your convenience.</p><ul><li>View your Account Details and Documents</li><li>Make Premium Payments</li><li>View Billing and Claims</li><li>Make changes</li></ul></div><div class=\"col-md-6 login-signup-nav\"><ul class=\"nav nav-tabs nav-justified\"><li ng-class=\"{ active: vm.activeTab === \'login\' }\"><a href=\"\" ng-click=\"vm.activeTab = \'login\'\">Returning Customer<br>Login</a></li><li ng-class=\"{ active: vm.activeTab === \'signup\' }\"><a href=\"\" ng-click=\"vm.activeTab = \'signup\'\">First Time User<br>Create My Account</a></li></ul></div><div class=\"login-signup-container col-md-8\"><div class=\"col-md-6\"><div ng-show=\"vm.activeTab === \'login\'\" class=\"tab-login\"><div class=\"col-xs-12\"><h3>Returning Customer<br>Login</h3></div><div class=\"col-xs-12\"><h5>For security purposes, we strongly recommend that password length be at least 14 characters.</h5></div><form ng-submit=\"vm.login()\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-xs-12\"><label class=\"control-label\">Email Address</label> <input type=\"text\" name=\"username\" value=\"\" class=\"form-control\" placeholder=\"Email\" ng-model=\"vm.username\" ng-blur=\"vm.checkLoginValidation(\'email\')\"><div class=\"validation-error\" ng-show=\"vm.emailInvalid\"><p>{{ vm.emailInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><label class=\"control-label\">Password</label> <input type=\"password\" name=\"password\" value=\"\" class=\"form-control\" placeholder=\"Password\" ng-model=\"vm.password\" ng-blur=\"vm.checkLoginValidation(\'password\')\"><div class=\"validation-error\" ng-show=\"vm.passwordInvalid\"><p>{{ vm.passwordInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><p class=\"submit\"><button type=\"submit\" name=\"commit\" class=\"btn btn-custom\">Log In</button></p><a ui-sref=\"forgot\">Forgot Your Password?</a></div></div><div class=\"col-xs-12\"><uib-alert style=\"text-align:center\" ng-show=\"vm.loginAlertMessage\" type=\"{{ vm.alertType }}\" close=\"vm.closeAlert()\">{{ vm.loginAlertMessage }}</uib-alert></div></form></div></div><div class=\"col-md-6 signup-container\"><div ng-show=\"vm.activeTab === \'signup\'\" class=\"tab-signup\"><div class=\"col-xs-12\"><h3>First Time User<br>Create My Account</h3></div><form ng-submit=\"vm.signup()\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-xs-12\" ng-class=\"vm.firstFieldError\"><label class=\"control-label\">First Name</label> <input type=\"text\" name=\"first-name\" value=\"\" class=\"form-control\" placeholder=\"First Name\" ng-model=\"vm.firstName\" ng-blur=\"vm.checkSignupValidation(\'firstName\')\"><div class=\"validation-error\" ng-show=\"vm.firstInvalid\"><p>{{ vm.firstInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\" ng-class=\"vm.lastFieldError\"><label class=\"control-label\">Last Name</label> <input type=\"text\" name=\"last-name\" value=\"\" class=\"form-control\" placeholder=\"Last Name\" ng-model=\"vm.lastName\" ng-blur=\"vm.checkSignupValidation(\'lastName\')\"><div class=\"validation-error\" ng-show=\"vm.lastInvalid\"><p>{{ vm.lastInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\" ng-class=\"vm.dateFieldError\"><label class=\"control-label\">Date of Birth</label><div class=\"clearfix\"><div class=\"month-input\"><input type=\"text\" name=\"month\" value=\"\" placeholder=\"MM\" maxlength=\"2\" ng-model=\"vm.birthDate.month\" ng-blur=\"vm.checkSignupValidation(\'month\')\"></div><div class=\"day-input\"><input type=\"text\" name=\"day\" value=\"\" placeholder=\"DD\" maxlength=\"2\" ng-model=\"vm.birthDate.day\" ng-blur=\"vm.checkSignupValidation(\'day\')\"></div><div class=\"year-input\"><input type=\"text\" name=\"year\" value=\"\" placeholder=\"YYYY\" maxlength=\"4\" ng-model=\"vm.birthDate.year\" ng-blur=\"vm.checkSignupValidation(\'year\')\"></div><div class=\"validation-error\" ng-show=\"vm.monthInvalid || vm.dayInvalid || vm.yearInvalid\"><p>{{ vm.monthInvalid || vm.dayInvalid || vm.yearInvalid }}</p></div></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\" ng-class=\"vm.zipFieldError\"><label class=\"control-label\">ZIP Code</label> <input type=\"text\" class=\"form-control\" name=\"zip\" placeholder=\"5-Digit ZIP\" maxlength=\"5\" ng-model=\"vm.zipCode\" ng-blur=\"vm.checkSignupValidation(\'zip\')\"><div class=\"validation-error\" ng-show=\"vm.zipInvalid\"><p>{{ vm.zipInvalid}}</p></div></div></div><div class=\"checkbox form-group\"><div class=\"col-xs-12\" ng-class=\"vm.tosFieldError\"><label><input type=\"checkbox\" ng-model=\"vm.tos\"> I accept the <a ui-sref=\"tos\">Terms of Use</a> and <a ui-sref=\"coc\">Code of Conduct</a></label><div class=\"validation-error\" ng-show=\"vm.tosInvalid\"><p>{{ vm.tosInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-12\"><p class=\"submit\"><button type=\"submit\" name=\"submit\" class=\"btn btn-custom\">Continue</button></p></div></div><div class=\"col-xs-offset-1 col-xs-10\"><uib-alert ng-show=\"vm.signupAlertMessage\" type=\"{{ vm.alertType}}\" close=\"vm.closeAlert()\">{{ vm.signupAlertMessage}}</uib-alert></div></form></div></div></div></div></div><div class=\"bg-full\"></div>");
$templateCache.put("app/components/user/logout.html","<div class=\"container-fluid\"><div class=\"jumbotron text-center\"><h1>{{ vm.logoutMessage }}</h1></div></div>");
$templateCache.put("app/components/user/forgot/forgot.html","<div class=\"login-content forgot-pw-content\"><div class=\"main-content\"><h2>Change Password</h2><p>Please enter your email address below to receive an email with instructions on how to change your password.</p><form ng-submit=\"vm.forgot()\" class=\"form-horizontal\"><div class=\"form-group\"><input type=\"text\" name=\"email\" value=\"\" class=\"form-control\" placeholder=\"Email\" ng-model=\"vm.email\" ng-blur=\"vm.checkValidation()\"><div class=\"validation-error\" ng-show=\"vm.invalid\"><p>{{ vm.invalid}}</p></div></div><div class=\"form-group\"><p class=\"submit\"><input class=\"btn btn-custom\" type=\"submit\" name=\"commit\" value=\"Continue\"></p><uib-alert ng-show=\"vm.alertMessage\" type=\"{{ vm.alertType }}\" close=\"vm.closeAlert()\">{{ vm.alertMessage }} {{ vm.token }}</uib-alert></div></form></div></div><div class=\"bg-full\"></div>");
$templateCache.put("app/components/user/forgot/reset.html","<div class=\"login-content\"><div class=\"main-content\"><div class=\"col-xs-12\"><div class=\"lead\"><h2>New Password</h2>Please enter your new password below. <button class=\"help-mark\" type=\"button\" popover-placement=\"bottom\" popover-trigger=\"\'focus\'\" popover-class=\"password-requirements\" uib-popover-template=\"\'app/components/user/signup/password_requirements_popover.html\'\" popover-append-to-body=\"true\">?</button></div><form ng-submit=\"vm.reset()\"><div class=\"form-group\"><input type=\"password\" name=\"password\" class=\"form-control\" value=\"\" placeholder=\"New Password\" ng-model=\"vm.password\" ng-blur=\"vm.checkValidation(\'password\')\"><ul class=\"validation-error\" ng-show=\"vm.passwordInvalid.length > 1\"><li ng-repeat=\"err in vm.passwordInvalid\">{{ err }}</li></ul><div class=\"validation-error\" ng-show=\"vm.passwordInvalid.length === 1\"><p>{{ vm.passwordInvalid[0] }}</p></div></div><div class=\"form-group\"><input type=\"password\" name=\"confrim-password\" class=\"form-control\" value=\"\" placeholder=\"Confirm Password\" ng-model=\"vm.password2\" ng-blur=\"vm.checkValidation(\'password2\')\"><div class=\"validation-error\" ng-show=\"vm.password2Invalid\"><p>{{ vm.password2Invalid}}</p></div></div><p class=\"submit\"><input type=\"submit\" name=\"commit\" value=\"Change Password\" class=\"btn btn-custom\" ng-disabled=\"vm.saving\"></p><uib-alert ng-show=\"vm.alertMessage\" type=\"{{ vm.alertType}}\" close=\"vm.closeAlert()\">{{ vm.alertMessage}}</uib-alert></form><br></div></div></div><div class=\"bg-full\"></div>");
$templateCache.put("app/components/user/signup/password_requirements_popover.html","<div><strong>Password Requirements</strong> Passwords must be at least 14 characters long and contain at least one of each of the following categories:<ul><li>Uppercase Letter</li><li>Lowercase Letter</li><li>Number</li><li>Any of the following special characters<br>!@#$%^&*()[]{}</li></ul>It may not contain your email address or Tax ID Number</div>");
$templateCache.put("app/components/user/signup/signup.html","<div class=\"form-container\"><div class=\"signup-content\"><div class=\"col-xs-offset-1 col-xs-10\"><h2>Create My Account</h2></div><form ng-submit=\"vm.signup()\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-xs-10 col-xs-offset-1\" ng-class=\"vm.firstFieldError\"><label class=\"control-label\">First Name</label> <input type=\"text\" name=\"first-name\" value=\"\" class=\"form-control\" placeholder=\"First Name\" ng-model=\"vm.firstName\" ng-blur=\"vm.checkValidation(\'firstName\')\"><div class=\"validation-error\" ng-show=\"vm.firstInvalid\"><p>{{ vm.firstInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-10 col-xs-offset-1\" ng-class=\"vm.lastFieldError\"><label class=\"control-label\">Last Name</label> <input type=\"text\" name=\"last-name\" value=\"\" class=\"form-control\" placeholder=\"Last Name\" ng-model=\"vm.lastName\" ng-blur=\"vm.checkValidation(\'lastName\')\"><div class=\"validation-error\" ng-show=\"vm.lastInvalid\"><p>{{ vm.lastInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-10 col-xs-offset-1\" ng-class=\"vm.dateFieldError\"><label class=\"control-label\">Date of Birth</label><div class=\"clearfix\"><div class=\"month-input\" style=\"padding:0\"><input type=\"text\" name=\"month\" value=\"\" placeholder=\"MM\" maxlength=\"2\" ng-model=\"vm.birthDate.month\" ng-blur=\"vm.checkValidation(\'month\')\"></div><div class=\"day-input\" style=\"padding:0\"><input type=\"text\" name=\"day\" value=\"\" placeholder=\"DD\" maxlength=\"2\" ng-model=\"vm.birthDate.day\" ng-blur=\"vm.checkValidation(\'day\')\"></div><div class=\"year-input\" style=\"padding:0\"><input type=\"text\" name=\"year\" value=\"\" placeholder=\"YYYY\" maxlength=\"4\" ng-model=\"vm.birthDate.year\" ng-blur=\"vm.checkValidation(\'year\')\"></div><div class=\"validation-error\" ng-show=\"vm.monthInvalid || vm.dayInvalid || vm.yearInvalid\"><p>{{ vm.monthInvalid || vm.dayInvalid || vm.yearInvalid }}</p></div></div></div></div><div class=\"form-group\"><div class=\"col-xs-10 col-xs-offset-1\" ng-class=\"vm.zipFieldError\"><label class=\"control-label\">ZIP Code</label> <input type=\"text\" class=\"form-control\" name=\"zip\" placeholder=\"5-Digit ZIP\" maxlength=\"5\" ng-model=\"vm.zipCode\" ng-blur=\"vm.checkValidation(\'zip\')\"><div class=\"validation-error\" ng-show=\"vm.zipInvalid\"><p>{{ vm.zipInvalid}}</p></div></div></div><div class=\"checkbox form-group\"><div class=\"col-xs-10 col-xs-offset-1\" ng-class=\"vm.tosFieldError\"><label><input type=\"checkbox\" ng-model=\"vm.tos\"> I accept the <a ui-sref=\"tos\">Terms of Use</a> and <a ui-sref=\"coc\">Code of Conduct</a></label><div class=\"validation-error\" ng-show=\"vm.tosInvalid\"><p>{{ vm.tosInvalid}}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-4 col-xs-offset-1\"><p class=\"submit\"><button type=\"submit\" name=\"submit\" class=\"btn btn-custom\">Continue</button></p></div></div><div class=\"col-xs-offset-1 col-xs-10\"><uib-alert ng-show=\"vm.alertMessage\" type=\"{{ vm.alertType}}\" close=\"vm.closeAlert()\">{{ vm.alertMessage}}</uib-alert></div></form></div></div><div class=\"bg-full\"></div>");
$templateCache.put("app/components/user/signup/signup2.html","<div class=\"signup-content col-xs-12 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6\"><div class=\"col-xs-offset-1 col-xs-11\"><h2>Create my Account</h2></div><form ng-submit=\"vm.signup()\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-xs-4 control-label\">Email</label><div class=\"col-xs-6\"><input type=\"text\" name=\"email\" value=\"\" class=\"form-control\" placeholder=\"Email\" ng-model=\"vm.email\" ng-blur=\"vm.checkValidation(\'email\')\"><div class=\"validation-error\" ng-show=\"vm.emailInvalid\"><p>{{ vm.emailInvalid }}</p></div></div></div><div class=\"form-group\"><label class=\"col-xs-4 control-label\">Password</label><div class=\"col-xs-6\"><input type=\"password\" name=\"password\" value=\"\" class=\"form-control\" placeholder=\"Password\" ng-model=\"vm.password\" ng-blur=\"vm.checkValidation(\'password\')\"><button class=\"help-mark\" title=\"Passwords must be at least 14 characters long and contain at least one of each of the following categories:&#10;&#10; &#x2022; Uppercase Letter&#10; &#x2022; Lowercase Letter&#10; &#x2022; Number&#10; &#x2022; Any of the following special characters<br>!@#$%^&*()[]{}&#10;&#10; It may not contain your email address or Tax ID Number\">?</button><ul class=\"validation-error\" ng-show=\"vm.passwordInvalid.length > 1\"><li ng-repeat=\"err in vm.passwordInvalid\">{{ err }}</li></ul><div class=\"validation-error\" ng-show=\"vm.passwordInvalid.length === 1\"><p>{{ vm.passwordInvalid[0] }}</p></div></div></div><div class=\"form-group\"><label class=\"col-xs-4 control-label\">Confirm Password</label><div class=\"col-xs-6\"><input type=\"password\" name=\"confirm-password\" value=\"\" class=\"form-control\" placeholder=\"Confirm Password\" ng-model=\"vm.password2\" ng-blur=\"vm.checkValidation(\'password2\')\"><div class=\"validation-error\" ng-show=\"vm.password2Invalid\"><p>{{ vm.password2Invalid }}</p></div></div></div><div class=\"form-group\"><div class=\"col-xs-offset-4 col-xs-2\"><p class=\"submit\"><button type=\"submit\" name=\"submit\" class=\"btn btn-custom\">Register</button></p></div></div><alert style=\"text-align:center\" ng-show=\"vm.alertMessage\" type=\"{{ vm.alertType }}\" close=\"vm.closeAlert()\">{{ vm.alertMessage }}</alert></form></div>");}]);